import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    Node: ['NodeType'],
  },
};
export default result;

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date (isoformat) */
  Date: any;
  /** Date with time (isoformat) */
  DateTime: any;
  /** The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID. */
  GlobalID: any;
  /** The `JSON` scalar type represents JSON values as specified by ECMA-404 */
  JSON: any;
  Thumbnails: any;
  /** Time (isoformat) */
  Time: any;
  UUID: any;
  Upload: any;
};

export type Affiliation = {
  __typename?: 'Affiliation';
  hash: Scalars['UUID'];
  id: Scalars['UUID'];
  isManager: Scalars['Boolean'];
  isStudent: Scalars['Boolean'];
  isTeacher: Scalars['Boolean'];
  /** User invitation not resolved. */
  pending: Scalars['Boolean'];
  school: School;
  /**
   * Send email invitation NOW.<br />
   * Note: this field will clear after the invitation has been sent.
   */
  sendInvite: Scalars['Boolean'];
  user: User;
};

export type AffiliationSchoolArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type AffiliationFilter = {
  hash?: InputMaybe<UuidFilterLookup>;
  id?: InputMaybe<Scalars['String']>;
  isManager?: InputMaybe<Scalars['Boolean']>;
  isStudent?: InputMaybe<Scalars['Boolean']>;
  isTeacher?: InputMaybe<Scalars['Boolean']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  school?: InputMaybe<SchoolFilter>;
  sendInvite?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserFilter>;
};

export type AiAssistant = {
  __typename?: 'AiAssistant';
  id: Scalars['UUID'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Used for selecting assistants for chat */
  namespaces: Array<Scalars['String']>;
  newMessages?: Maybe<Array<Message>>;
  type: Scalars['String'];
};

export type AiAssistantConfig = {
  __typename?: 'AiAssistantConfig';
  customInstructions: Scalars['String'];
  id: Scalars['UUID'];
  image?: Maybe<DjangoImageType>;
  initialMessage?: Maybe<Scalars['String']>;
  isShared: Scalars['Boolean'];
  name: Scalars['String'];
  vector?: Maybe<Vector>;
};

export type Article = {
  __typename?: 'Article';
  assessment?: Maybe<NodeType>;
  /** Use CMS from another Content in the same Module. If choices are missing, save. */
  cmsContentSource?: Maybe<NodeType>;
  driveUrl?: Maybe<Scalars['String']>;
  fileFile?: Maybe<DjangoFileType>;
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  mediaType: Scalars['String'];
  /** Defaults to "type of content" value (e.g. "Student handout") */
  name: Scalars['String'];
  namespace: Scalars['String'];
  pdfFile?: Maybe<DjangoFileType>;
  pdfUrl?: Maybe<Scalars['String']>;
  pk: Scalars['String'];
  placeholder?: Maybe<NodeType>;
  preziUrl?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  youtubeUrl?: Maybe<Scalars['String']>;
};

export type ArticleFilter = {
  assessment?: InputMaybe<DjangoModelFilterInput>;
  cmsContentSource?: InputMaybe<DjangoModelFilterInput>;
  driveUrl?: InputMaybe<StrFilterLookup>;
  fileFile?: InputMaybe<UploadFilterLookup>;
  id?: InputMaybe<Scalars['String']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  mediaType?: InputMaybe<StrFilterLookup>;
  name?: InputMaybe<Scalars['String']>;
  namespace?: InputMaybe<StrFilterLookup>;
  pdfFile?: InputMaybe<UploadFilterLookup>;
  pk?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<DjangoModelFilterInput>;
  preziUrl?: InputMaybe<StrFilterLookup>;
  type?: InputMaybe<StrFilterLookup>;
  youtubeUrl?: InputMaybe<StrFilterLookup>;
};

export type ArticleRead = {
  __typename?: 'ArticleRead';
  article: Article;
  articleId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  user: User;
  userId: Scalars['String'];
};

export type ArticleReadFilter = {
  articleId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ArticleReadInput = {
  articleId: Scalars['String'];
};

export type AssignTrackToStudentInput = {
  studyGroup: Scalars['String'];
  track: Scalars['String'];
  user: Scalars['String'];
};

export type Assistant = {
  __typename?: 'Assistant';
  id: Scalars['UUID'];
  image?: Maybe<DjangoImageType>;
  infobipId?: Maybe<Scalars['String']>;
  introMessages: Scalars['JSON'];
  name: Scalars['String'];
  /** Comma separeted list of namespaces to target with auto enroll */
  namespaces?: Maybe<Scalars['String']>;
};

export type AssistantFilter = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type AssistantPartialInput = {
  customInstructions?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  initialMessage?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  vectorId?: InputMaybe<Scalars['String']>;
};

export type AssistantShareInput = {
  id: Scalars['UUID'];
};

export type ChalkUp = {
  __typename?: 'ChalkUp';
  content: Content;
  contentId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  studyGroup: StudyGroup;
  studyGroupId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type ChalkUpStudyGroupArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ChalkUpFilter = {
  content?: InputMaybe<ContentFilter>;
  createdAt?: InputMaybe<DatetimeFilterLookup>;
  id?: InputMaybe<Scalars['String']>;
  studyGroup?: InputMaybe<StudyGroupFilter>;
  user?: InputMaybe<UserFilter>;
};

export type ChalkUpInput = {
  content: NodeInput;
  id: Scalars['UUID'];
  studyGroup?: InputMaybe<NodeInput>;
  user: NodeInput;
};

export type ChalkUpOrder = {
  createdAt?: InputMaybe<Ordering>;
};

export type ChalkUpPartialInput = {
  content?: InputMaybe<NodeInput>;
  id: Scalars['UUID'];
  studyGroup?: InputMaybe<NodeInput>;
  user?: InputMaybe<NodeInput>;
};

export type Changelog = {
  __typename?: 'Changelog';
  endDate: Scalars['Date'];
  id: Scalars['UUID'];
  log: Scalars['String'];
  seen: Scalars['Boolean'];
  startDate: Scalars['Date'];
  title: Scalars['String'];
};

export type Content = {
  __typename?: 'Content';
  assessment?: Maybe<NodeType>;
  /** Use CMS from another Content in the same Module. If choices are missing, save. */
  cmsContentSource?: Maybe<NodeType>;
  contentForwarding?: Maybe<NodeType>;
  /** Use CMS from another Content in the same Module. If choices are missing, save. */
  contentUsingCmsContent?: Maybe<Array<DjangoModelType>>;
  driveUrl?: Maybe<Scalars['String']>;
  estimatedDuration: Scalars['Int'];
  fileFile?: Maybe<DjangoFileType>;
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isDemo: Scalars['Boolean'];
  /** Precedence: 1: "Other file", 2: "PDF" */
  isDownloadable: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  isShareable: Scalars['Boolean'];
  mediaType: Scalars['String'];
  module?: Maybe<Module>;
  /** Defaults to "type of content" value (e.g. "Student handout") */
  name: Scalars['String'];
  pdfFile?: Maybe<DjangoFileType>;
  pdfUrl?: Maybe<Scalars['String']>;
  pinnings?: Maybe<Array<DjangoModelType>>;
  pk: Scalars['String'];
  placeholder?: Maybe<NodeType>;
  preziUrl?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  typeOfContent: TypeOfContent;
  unit?: Maybe<Unit>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

export type ContentModuleArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ContentTypeOfContentArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ContentFilter = {
  id?: InputMaybe<Scalars['String']>;
  isDemo?: InputMaybe<Scalars['Boolean']>;
  isDownloadable?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isShareable?: InputMaybe<Scalars['Boolean']>;
  module?: InputMaybe<ModuleFilter>;
  name?: InputMaybe<StrFilterLookup>;
};

export type ContentInput = {
  assessment?: InputMaybe<NodeInput>;
  contentForwarding?: InputMaybe<NodeInput>;
  /** Use CMS from another Content in the same Module. If choices are missing, save. */
  contentUsingCmsContent?: InputMaybe<NodeListInput>;
  driveUrl?: InputMaybe<Scalars['String']>;
  /** Estimated time needed to complete content */
  estimatedDuration?: InputMaybe<Scalars['Time']>;
  fileFile?: InputMaybe<Scalars['Upload']>;
  isDemo?: InputMaybe<Scalars['Boolean']>;
  /** Precedence: 1: "Other file", 2: "PDF" */
  isDownloadable?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isShareable?: InputMaybe<Scalars['Boolean']>;
  mediaType?: InputMaybe<Scalars['String']>;
  module: Scalars['String'];
  /** Defaults to "type of content" value (e.g. "Student handout") */
  name?: InputMaybe<Scalars['String']>;
  pdfFile?: InputMaybe<Scalars['Upload']>;
  pinnings?: InputMaybe<NodeListInput>;
  preziUrl?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  typeOfContent: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type ContentOrder = {
  sortOrder?: InputMaybe<Ordering>;
};

export type ContentPartialInput = {
  assessment?: InputMaybe<NodeInput>;
  contentForwarding?: InputMaybe<NodeInput>;
  /** Use CMS from another Content in the same Module. If choices are missing, save. */
  contentUsingCmsContent?: InputMaybe<NodeListInput>;
  driveUrl?: InputMaybe<Scalars['String']>;
  /** Estimated time needed to complete content */
  estimatedDuration?: InputMaybe<Scalars['Time']>;
  fileFile?: InputMaybe<Scalars['Upload']>;
  isDemo?: InputMaybe<Scalars['Boolean']>;
  /** Precedence: 1: "Other file", 2: "PDF" */
  isDownloadable?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  isShareable?: InputMaybe<Scalars['Boolean']>;
  mediaType?: InputMaybe<Scalars['String']>;
  module: Scalars['String'];
  /** Defaults to "type of content" value (e.g. "Student handout") */
  name?: InputMaybe<Scalars['String']>;
  pdfFile?: InputMaybe<Scalars['Upload']>;
  pinnings?: InputMaybe<NodeListInput>;
  preziUrl?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  typeOfContent: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type Conversation = {
  __typename?: 'Conversation';
  assistant?: Maybe<Assistant>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  gptBlockUniqueId?: Maybe<Scalars['UUID']>;
  hasInappropriateMsg: Scalars['Boolean'];
  history: Array<ConversationMessage>;
  id: Scalars['UUID'];
  lastMessage?: Maybe<ConversationMessage>;
  limit: Scalars['Int'];
  name: Scalars['String'];
  notDisplayedMessageLen: Scalars['Int'];
  user: User;
};

export type ConversationBlockInput = {
  id: Scalars['String'];
};

export type ConversationInput = {
  assistantId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  systemMessage?: InputMaybe<Scalars['Boolean']>;
};

export type ConversationMessage = {
  __typename?: 'ConversationMessage';
  createdAt?: Maybe<Scalars['DateTime']>;
  flags: Array<ConversationMessageFlag>;
  id: Scalars['UUID'];
  isGenerated: Scalars['Boolean'];
  text: Scalars['String'];
};

export type ConversationMessageFlag = {
  __typename?: 'ConversationMessageFlag';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  type: Scalars['String'];
};

export type ConversationMessageFlagInput = {
  messageId: Scalars['String'];
  type: Scalars['String'];
};

export type DateFilterLookup = {
  contains?: InputMaybe<Scalars['Date']>;
  endsWith?: InputMaybe<Scalars['Date']>;
  exact?: InputMaybe<Scalars['Date']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  iContains?: InputMaybe<Scalars['Date']>;
  iEndsWith?: InputMaybe<Scalars['Date']>;
  iExact?: InputMaybe<Scalars['Date']>;
  iRegex?: InputMaybe<Scalars['String']>;
  iStartsWith?: InputMaybe<Scalars['Date']>;
  inList?: InputMaybe<Array<Scalars['Date']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  range?: InputMaybe<Array<Scalars['Date']>>;
  regex?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['Date']>;
};

export type DatetimeFilterLookup = {
  contains?: InputMaybe<Scalars['DateTime']>;
  endsWith?: InputMaybe<Scalars['DateTime']>;
  exact?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  iContains?: InputMaybe<Scalars['DateTime']>;
  iEndsWith?: InputMaybe<Scalars['DateTime']>;
  iExact?: InputMaybe<Scalars['DateTime']>;
  iRegex?: InputMaybe<Scalars['String']>;
  iStartsWith?: InputMaybe<Scalars['DateTime']>;
  inList?: InputMaybe<Array<Scalars['DateTime']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  range?: InputMaybe<Array<Scalars['DateTime']>>;
  regex?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['DateTime']>;
};

export type DjangoFileType = {
  __typename?: 'DjangoFileType';
  name: Scalars['String'];
  path: Scalars['String'];
  size: Scalars['Int'];
  url: Scalars['String'];
};

export type DjangoImageType = {
  __typename?: 'DjangoImageType';
  height: Scalars['Int'];
  name: Scalars['String'];
  path: Scalars['String'];
  size: Scalars['Int'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type DjangoModelFilterInput = {
  pk: Scalars['ID'];
};

export type DjangoModelType = {
  __typename?: 'DjangoModelType';
  pk: Scalars['ID'];
};

export type Event = {
  __typename?: 'Event';
  description: Scalars['String'];
  endDatetime?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  image: DjangoImageType;
  link: Scalars['String'];
  namespace: Scalars['String'];
  startDatetime?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type File = {
  __typename?: 'File';
  createdAt?: Maybe<Scalars['DateTime']>;
  file: DjangoFileType;
  id: Scalars['UUID'];
  user: NodeType;
  vectorIds: Array<Scalars['String']>;
};

export type FileInput = {
  file: Scalars['String'];
  vectorId?: InputMaybe<Scalars['String']>;
};

export type FilerFileType = {
  __typename?: 'FilerFileType';
  id: Scalars['GlobalID'];
};

export type FilerImageType = {
  __typename?: 'FilerImageType';
  height: Scalars['Int'];
  id: Scalars['GlobalID'];
  label: Scalars['String'];
  name: Scalars['String'];
  owner?: Maybe<User>;
  thumbnailUrlTiny: Scalars['String'];
  thumbnailUrls: Array<Scalars['String']>;
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type FilerImageTypeOwnerArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type Folder = {
  __typename?: 'Folder';
  children: Array<Folder>;
  files: Array<FilerFileType>;
  id: Scalars['GlobalID'];
  images: Array<FilerImageType>;
  name: Scalars['String'];
  owner?: Maybe<User>;
  parent?: Maybe<Folder>;
  pk: Scalars['String'];
};

export type FolderChildrenArgs = {
  filters?: InputMaybe<FolderFilter>;
};

export type FolderOwnerArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type FolderFilter = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<StrFilterLookup>;
  owner?: InputMaybe<DjangoModelFilterInput>;
};

export type FolderInput = {
  name: Scalars['String'];
  owner?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['String']>;
};

export type FolderPartialInput = {
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['String']>;
};

export type Guide = {
  __typename?: 'Guide';
  assessment?: Maybe<NodeType>;
  /** Use CMS from another Content in the same Module. If choices are missing, save. */
  cmsContentSource?: Maybe<NodeType>;
  contentForwarding?: Maybe<NodeType>;
  driveUrl?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  image: DjangoImageType;
  isDemo: Scalars['Boolean'];
  mediaType: Scalars['String'];
  /** Defaults to "type of content" value (e.g. "Student handout") */
  name: Scalars['String'];
  pdfUrl?: Maybe<Scalars['String']>;
  pk: Scalars['String'];
  placeholder?: Maybe<NodeType>;
  preziUrl?: Maybe<Scalars['String']>;
  program: Program;
  sortOrder: Scalars['Int'];
  thumbnails?: Maybe<Scalars['Thumbnails']>;
  typeOfContent: NodeType;
  videoUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

export type GuideProgramArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type GuideFilter = {
  assessment?: InputMaybe<DjangoModelFilterInput>;
  cmsContentSource?: InputMaybe<DjangoModelFilterInput>;
  contentForwarding?: InputMaybe<DjangoModelFilterInput>;
  driveUrl?: InputMaybe<StrFilterLookup>;
  fileFile?: InputMaybe<UploadFilterLookup>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<StrFilterLookup>;
  pdfFile?: InputMaybe<UploadFilterLookup>;
  pk?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<DjangoModelFilterInput>;
  preziUrl?: InputMaybe<StrFilterLookup>;
  program?: InputMaybe<DjangoModelFilterInput>;
  typeOfContent?: InputMaybe<DjangoModelFilterInput>;
  youtubeUrl?: InputMaybe<StrFilterLookup>;
};

export type GuideOrder = {
  sortOrder?: InputMaybe<Ordering>;
};

export type InfobipUserProxy = {
  __typename?: 'InfobipUserProxy';
  complete: Scalars['Boolean'];
  id: Scalars['Int'];
  infobipPassword?: Maybe<Scalars['String']>;
  infobipState: Scalars['String'];
  infobipUsername: Scalars['String'];
  phoneVerified: Scalars['Boolean'];
  platformId?: Maybe<Scalars['String']>;
  platformSchool?: Maybe<School>;
  platformSchoolId?: Maybe<Scalars['String']>;
  platformStudyGroup?: Maybe<StudyGroup>;
  platformStudyGroupId?: Maybe<Scalars['String']>;
};

export type IntFilterLookup = {
  contains?: InputMaybe<Scalars['Int']>;
  endsWith?: InputMaybe<Scalars['Int']>;
  exact?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  iContains?: InputMaybe<Scalars['Int']>;
  iEndsWith?: InputMaybe<Scalars['Int']>;
  iExact?: InputMaybe<Scalars['Int']>;
  iRegex?: InputMaybe<Scalars['String']>;
  iStartsWith?: InputMaybe<Scalars['Int']>;
  inList?: InputMaybe<Array<Scalars['Int']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  range?: InputMaybe<Array<Scalars['Int']>>;
  regex?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['Int']>;
};

export type InteractiveComponentState = {
  __typename?: 'InteractiveComponentState';
  state: Scalars['JSON'];
};

export type InteractiveComponentStateInput = {
  componentId: Scalars['String'];
  hash: Scalars['String'];
  state: Scalars['JSON'];
  studyGroupId: Scalars['String'];
  userId: Scalars['String'];
};

export type JsonContent = {
  __typename?: 'JsonContent';
  count: Scalars['Int'];
  currentPage: Scalars['Int'];
  id: Scalars['String'];
  isDirty: Scalars['Boolean'];
  isPresentation: Scalars['Boolean'];
  results: Array<JsonContentResult>;
  totalPages: Scalars['Int'];
};

export type JsonContentFilter = {
  pk?: InputMaybe<Scalars['String']>;
};

export type JsonContentResult = {
  __typename?: 'JsonContentResult';
  children: Array<Scalars['JSON']>;
  data: Scalars['JSON'];
  id: Scalars['UUID'];
  plugin: Scalars['String'];
};

export type LeadUser = {
  __typename?: 'LeadUser';
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['JSON'];
  email: Scalars['String'];
};

export type LeadUserInput = {
  data: Scalars['JSON'];
  email: Scalars['String'];
};

export type LeadUserPartialInput = {
  data: Scalars['JSON'];
  email?: InputMaybe<Scalars['String']>;
};

export type License = {
  __typename?: 'License';
  id: Scalars['UUID'];
  maxStudents: Scalars['Int'];
  maxTeachers: Scalars['Int'];
  period: Period;
  program: Program;
  school: School;
  studyGroup?: Maybe<StudyGroup>;
};

export type LicenseSchoolArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type LicenseFilter = {
  id?: InputMaybe<Scalars['String']>;
  maxStudents?: InputMaybe<IntFilterLookup>;
  maxTeachers?: InputMaybe<IntFilterLookup>;
  period?: InputMaybe<PeriodFilter>;
  program?: InputMaybe<ProgramFilter>;
  school?: InputMaybe<SchoolFilter>;
};

export type LicenseInput = {
  id: Scalars['UUID'];
  maxStudents?: InputMaybe<Scalars['Int']>;
  maxTeachers?: InputMaybe<Scalars['Int']>;
};

export type LicensePartialInput = {
  id: Scalars['UUID'];
  maxStudents?: InputMaybe<Scalars['Int']>;
  maxTeachers?: InputMaybe<Scalars['Int']>;
};

export type Message = {
  __typename?: 'Message';
  apiId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  inappropriate?: Maybe<Scalars['String']>;
  offtopic?: Maybe<Scalars['String']>;
  originalContent?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  suggestion?: Maybe<Scalars['String']>;
  thread?: Maybe<ThreadData>;
};

export type MessageInput = {
  content: Scalars['String'];
  threadId: Scalars['String'];
};

export type Module = {
  __typename?: 'Module';
  contents: Array<Content>;
  id: Scalars['UUID'];
  isPublished: Scalars['Boolean'];
  name: Scalars['String'];
  unit?: Maybe<NodeType>;
};

export type ModuleContentsArgs = {
  filters?: InputMaybe<ContentFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ModuleContentsInput = {
  contents: Array<Scalars['String']>;
  module: Scalars['String'];
};

export type ModuleFilter = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<StrFilterLookup>;
  unit?: InputMaybe<UnitFilter>;
};

export type ModuleInput = {
  isPublished?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  unit: Scalars['String'];
};

export type ModuleJsonContent = {
  __typename?: 'ModuleJsonContent';
  contents: Array<JsonContent>;
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type ModuleJsonContentContentsArgs = {
  filters?: InputMaybe<JsonContentFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ModuleOrder = {
  sortOrder?: InputMaybe<Ordering>;
};

export type ModulePartialInput = {
  isPublished?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  unit: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addProgramUnit: Program;
  appendDataToLeadUser: LeadUser;
  assignTrackToStudent: TrackTeacherAssignment;
  chooseTrack: TrackUserChoice;
  completeContent: ChalkUp;
  createArticleRead: ArticleRead;
  createAssistant?: Maybe<AiAssistantConfig>;
  createChalkUp: ChalkUp;
  createChalkUps: Array<ChalkUp>;
  createContent: Content;
  createConversationFromBlock: Conversation;
  createFile: Scalars['Boolean'];
  createFolder: Folder;
  createInfobip: User;
  createLeadUser: LeadUser;
  createLeadUsers: Array<LeadUser>;
  createLicense: License;
  createLicenses: Array<License>;
  createMessage: Thread;
  createModule: Module;
  createNote: Note;
  createPeriod: Period;
  createPeriods: Array<Period>;
  createPinning: Pinning;
  createPinnings: Array<Pinning>;
  createProgram: Program;
  createSchool: School;
  createSchools: Array<School>;
  createShare: Share;
  createShares: Array<Share>;
  createStudyGroup: StudyGroup;
  createStudyGroups: Array<StudyGroup>;
  createThread: Thread;
  createTrack: Track;
  createTrackContent: TrackContent;
  createTrackContents: Array<TrackContent>;
  createTrackModule: TrackModule;
  createTrackModules: Array<TrackModule>;
  createTrackTeacherAssignment: TrackTeacherAssignment;
  createTrackTeacherAssignments: Array<TrackTeacherAssignment>;
  createTrackUnit: TrackUnit;
  createTrackUnits: Array<TrackUnit>;
  createTrackUserChoice: TrackUserChoice;
  createTrackUserChoices: Array<TrackUserChoice>;
  createTracks: Array<Track>;
  createTriggerFromBlock: Scalars['Boolean'];
  createUnit: Unit;
  deleteChalkUps: Array<ChalkUp>;
  deleteContent: Array<Content>;
  deleteFolder: Array<Folder>;
  deleteLeadUsers: Array<LeadUser>;
  deleteLicenses: Array<License>;
  deleteModule: Array<Module>;
  deleteNote: Note;
  deletePeriods: Array<Period>;
  deletePinnings: Array<Pinning>;
  deleteProgram: Array<Program>;
  deleteSchools: Array<School>;
  deleteShares: Array<Share>;
  deleteStudyGroups: Array<StudyGroup>;
  deleteTrackContents: Array<TrackContent>;
  deleteTrackModules: Array<TrackModule>;
  deleteTrackTeacherAssignments: Array<TrackTeacherAssignment>;
  deleteTrackUnits: Array<TrackUnit>;
  deleteTrackUserChoices: Array<TrackUserChoice>;
  deleteTracks: Array<Track>;
  deleteUnit: Array<Unit>;
  getConversationResponse: Conversation;
  markMessageWithFlag: ConversationMessageFlag;
  pinContent: Pinning;
  publishContent: JsonContent;
  removeProgramUnit: Program;
  reorderContents: Array<Content>;
  reorderModules: Array<Module>;
  reorderUnits: Array<ProgramUnit>;
  resetConversation: Conversation;
  revertContentToLive: JsonContent;
  saveInteractiveComponentState: InteractiveComponentState;
  seeChangelog: Scalars['Boolean'];
  setJsonCmsContent: JsonContent;
  shareContent: Share;
  toggleAssistantShare: AiAssistantConfig;
  updateAssistant?: Maybe<AiAssistantConfig>;
  updateChalkUps: Array<ChalkUp>;
  updateContent: Array<Content>;
  updateFolder: Array<Folder>;
  updateLeadUsers: Array<LeadUser>;
  updateLicenses: Array<License>;
  updateModule: Array<Module>;
  updateNoteComment: Note;
  updateNoteData: Note;
  updatePeriods: Array<Period>;
  updatePinnings: Array<Pinning>;
  updateProgram: Array<Program>;
  updateSchools: Array<School>;
  updateShares: Array<Share>;
  updateStudyGroups: Array<StudyGroup>;
  updateTrackBig: Track;
  updateTrackContents: Array<TrackContent>;
  updateTrackModules: Array<TrackModule>;
  updateTrackTeacherAssignments: Array<TrackTeacherAssignment>;
  updateTrackUnits: Array<TrackUnit>;
  updateTrackUserChoices: Array<TrackUserChoice>;
  updateTracks: Array<Track>;
  updateUnit: Array<Unit>;
};

export type MutationAddProgramUnitArgs = {
  data: ProgramUnitInput;
};

export type MutationAppendDataToLeadUserArgs = {
  data: LeadUserInput;
};

export type MutationAssignTrackToStudentArgs = {
  data: AssignTrackToStudentInput;
};

export type MutationChooseTrackArgs = {
  studyGroupId?: InputMaybe<Scalars['String']>;
  trackId: Scalars['String'];
};

export type MutationCompleteContentArgs = {
  contentId: Scalars['String'];
  studyGroupId?: InputMaybe<Scalars['String']>;
};

export type MutationCreateArticleReadArgs = {
  data: ArticleReadInput;
};

export type MutationCreateAssistantArgs = {
  data: AssistantPartialInput;
};

export type MutationCreateChalkUpArgs = {
  data: ChalkUpInput;
};

export type MutationCreateChalkUpsArgs = {
  data: Array<ChalkUpInput>;
};

export type MutationCreateContentArgs = {
  data: ContentInput;
};

export type MutationCreateConversationFromBlockArgs = {
  data: ConversationBlockInput;
};

export type MutationCreateFileArgs = {
  data: FileInput;
};

export type MutationCreateFolderArgs = {
  data: FolderInput;
};

export type MutationCreateInfobipArgs = {
  studyGroupId: Scalars['String'];
  userId: Scalars['String'];
};

export type MutationCreateLeadUserArgs = {
  data: LeadUserInput;
};

export type MutationCreateLeadUsersArgs = {
  data: Array<LeadUserInput>;
};

export type MutationCreateLicenseArgs = {
  data: LicenseInput;
};

export type MutationCreateLicensesArgs = {
  data: Array<LicenseInput>;
};

export type MutationCreateMessageArgs = {
  data: MessageInput;
};

export type MutationCreateModuleArgs = {
  data: ModuleInput;
};

export type MutationCreateNoteArgs = {
  data: NoteInput;
};

export type MutationCreatePeriodArgs = {
  data: PeriodInput;
};

export type MutationCreatePeriodsArgs = {
  data: Array<PeriodInput>;
};

export type MutationCreatePinningArgs = {
  data: PinningInput;
};

export type MutationCreatePinningsArgs = {
  data: Array<PinningInput>;
};

export type MutationCreateProgramArgs = {
  data: ProgramInput;
};

export type MutationCreateSchoolArgs = {
  data: SchoolInput;
};

export type MutationCreateSchoolsArgs = {
  data: Array<SchoolInput>;
};

export type MutationCreateShareArgs = {
  data: ShareInput;
};

export type MutationCreateSharesArgs = {
  data: Array<ShareInput>;
};

export type MutationCreateStudyGroupArgs = {
  data: StudyGroupInput;
};

export type MutationCreateStudyGroupsArgs = {
  data: Array<StudyGroupInput>;
};

export type MutationCreateThreadArgs = {
  data: ThreadInput;
};

export type MutationCreateTrackArgs = {
  data: TrackCreateInput;
};

export type MutationCreateTrackContentArgs = {
  data: TrackContentCreateInput;
};

export type MutationCreateTrackContentsArgs = {
  data: Array<TrackContentInput>;
};

export type MutationCreateTrackModuleArgs = {
  data: TrackModuleInput;
};

export type MutationCreateTrackModulesArgs = {
  data: Array<TrackModuleInput>;
};

export type MutationCreateTrackTeacherAssignmentArgs = {
  data: TrackTeacherAssignmentInput;
};

export type MutationCreateTrackTeacherAssignmentsArgs = {
  data: Array<TrackTeacherAssignmentInput>;
};

export type MutationCreateTrackUnitArgs = {
  data: TrackUnitInput;
};

export type MutationCreateTrackUnitsArgs = {
  data: Array<TrackUnitInput>;
};

export type MutationCreateTrackUserChoiceArgs = {
  data: TrackUserChoiceInput;
};

export type MutationCreateTrackUserChoicesArgs = {
  data: Array<TrackUserChoiceInput>;
};

export type MutationCreateTracksArgs = {
  data: Array<TrackCreateInput>;
};

export type MutationCreateTriggerFromBlockArgs = {
  id: Scalars['Int'];
};

export type MutationCreateUnitArgs = {
  data: UnitInput;
};

export type MutationDeleteChalkUpsArgs = {
  filters?: InputMaybe<ChalkUpFilter>;
};

export type MutationDeleteContentArgs = {
  filters?: InputMaybe<ContentFilter>;
};

export type MutationDeleteFolderArgs = {
  filters?: InputMaybe<FolderFilter>;
};

export type MutationDeleteLicensesArgs = {
  filters?: InputMaybe<LicenseFilter>;
};

export type MutationDeleteModuleArgs = {
  filters?: InputMaybe<ModuleFilter>;
};

export type MutationDeleteNoteArgs = {
  data: NoteDeleteInput;
};

export type MutationDeletePeriodsArgs = {
  filters?: InputMaybe<PeriodFilter>;
};

export type MutationDeletePinningsArgs = {
  filters?: InputMaybe<PinningFilter>;
};

export type MutationDeleteProgramArgs = {
  filters?: InputMaybe<ProgramFilter>;
};

export type MutationDeleteSchoolsArgs = {
  filters?: InputMaybe<SchoolFilter>;
};

export type MutationDeleteSharesArgs = {
  filters?: InputMaybe<ShareFilter>;
};

export type MutationDeleteStudyGroupsArgs = {
  filters?: InputMaybe<StudyGroupFilter>;
};

export type MutationDeleteTrackContentsArgs = {
  filters?: InputMaybe<TrackContentFilter>;
};

export type MutationDeleteTrackModulesArgs = {
  filters?: InputMaybe<TrackModuleFilter>;
};

export type MutationDeleteTrackTeacherAssignmentsArgs = {
  filters?: InputMaybe<TrackTeacherAssignmentFilter>;
};

export type MutationDeleteTrackUnitsArgs = {
  filters?: InputMaybe<TrackUnitFilter>;
};

export type MutationDeleteTrackUserChoicesArgs = {
  filters?: InputMaybe<TrackUserChoiceFilter>;
};

export type MutationDeleteTracksArgs = {
  filters?: InputMaybe<TrackFilter>;
};

export type MutationDeleteUnitArgs = {
  filters?: InputMaybe<UnitFilter>;
};

export type MutationGetConversationResponseArgs = {
  data: ConversationInput;
};

export type MutationMarkMessageWithFlagArgs = {
  data: ConversationMessageFlagInput;
};

export type MutationPinContentArgs = {
  contentId: Scalars['String'];
  studyGroupId?: InputMaybe<Scalars['String']>;
};

export type MutationPublishContentArgs = {
  pk: Scalars['String'];
};

export type MutationRemoveProgramUnitArgs = {
  data: ProgramUnitInput;
};

export type MutationReorderContentsArgs = {
  data: ModuleContentsInput;
};

export type MutationReorderModulesArgs = {
  data: UnitModulesInput;
};

export type MutationReorderUnitsArgs = {
  data: ProgramUnitsInput;
};

export type MutationResetConversationArgs = {
  data: ResetConversationInput;
};

export type MutationRevertContentToLiveArgs = {
  pk: Scalars['String'];
};

export type MutationSaveInteractiveComponentStateArgs = {
  data: InteractiveComponentStateInput;
  reset?: InputMaybe<Scalars['Boolean']>;
};

export type MutationSeeChangelogArgs = {
  data: SeeChangelogInput;
};

export type MutationSetJsonCmsContentArgs = {
  contentData: Scalars['JSON'];
  page: Scalars['Int'];
  pk: Scalars['String'];
  variant?: InputMaybe<Scalars['String']>;
};

export type MutationShareContentArgs = {
  contentId: Scalars['String'];
  studyGroupId?: InputMaybe<Scalars['String']>;
};

export type MutationToggleAssistantShareArgs = {
  data: AssistantShareInput;
};

export type MutationUpdateAssistantArgs = {
  data: AssistantPartialInput;
};

export type MutationUpdateChalkUpsArgs = {
  data: ChalkUpPartialInput;
  filters?: InputMaybe<ChalkUpFilter>;
};

export type MutationUpdateContentArgs = {
  data: ContentPartialInput;
  filters?: InputMaybe<ContentFilter>;
};

export type MutationUpdateFolderArgs = {
  data: FolderPartialInput;
  filters?: InputMaybe<FolderFilter>;
};

export type MutationUpdateLeadUsersArgs = {
  data: LeadUserPartialInput;
};

export type MutationUpdateLicensesArgs = {
  data: LicensePartialInput;
  filters?: InputMaybe<LicenseFilter>;
};

export type MutationUpdateModuleArgs = {
  data: ModulePartialInput;
  filters?: InputMaybe<ModuleFilter>;
};

export type MutationUpdateNoteCommentArgs = {
  data: NoteCommentInput;
};

export type MutationUpdateNoteDataArgs = {
  data: NoteDataInput;
};

export type MutationUpdatePeriodsArgs = {
  data: PeriodPartialInput;
  filters?: InputMaybe<PeriodFilter>;
};

export type MutationUpdatePinningsArgs = {
  data: PinningPartialInput;
  filters?: InputMaybe<PinningFilter>;
};

export type MutationUpdateProgramArgs = {
  data: ProgramPartialInput;
  filters?: InputMaybe<ProgramFilter>;
};

export type MutationUpdateSchoolsArgs = {
  data: SchoolPartialInput;
  filters?: InputMaybe<SchoolFilter>;
};

export type MutationUpdateSharesArgs = {
  data: SharePartialInput;
  filters?: InputMaybe<ShareFilter>;
};

export type MutationUpdateStudyGroupsArgs = {
  data: StudyGroupPartialInput;
  filters?: InputMaybe<StudyGroupFilter>;
};

export type MutationUpdateTrackBigArgs = {
  data: TrackBigPartialInput;
};

export type MutationUpdateTrackContentsArgs = {
  data: TrackContentPartialInput;
  filters?: InputMaybe<TrackContentFilter>;
};

export type MutationUpdateTrackModulesArgs = {
  data: TrackModulePartialInput;
  filters?: InputMaybe<TrackModuleFilter>;
};

export type MutationUpdateTrackTeacherAssignmentsArgs = {
  data: TrackTeacherAssignmentPartialInput;
  filters?: InputMaybe<TrackTeacherAssignmentFilter>;
};

export type MutationUpdateTrackUnitsArgs = {
  data: TrackUnitPartialInput;
  filters?: InputMaybe<TrackUnitFilter>;
};

export type MutationUpdateTrackUserChoicesArgs = {
  data: TrackUserChoicePartialInput;
  filters?: InputMaybe<TrackUserChoiceFilter>;
};

export type MutationUpdateTracksArgs = {
  data: TrackPartialInput;
  filters?: InputMaybe<TrackFilter>;
};

export type MutationUpdateUnitArgs = {
  data: Array<UnitInput>;
};

/** An object with a Globally Unique ID */
export type Node = {
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
};

/** Input of an object that implements the `Node` interface. */
export type NodeInput = {
  id: Scalars['GlobalID'];
};

/** Add/remove/set the selected nodes. */
export type NodeListInput = {
  add?: InputMaybe<Array<NodeInput>>;
  remove?: InputMaybe<Array<NodeInput>>;
  set?: InputMaybe<Array<NodeInput>>;
};

/** Generic type for objects that implements the `Node` interface. */
export type NodeType = Node & {
  __typename?: 'NodeType';
  id: Scalars['GlobalID'];
};

export type Note = {
  __typename?: 'Note';
  comment: Scalars['String'];
  content: Content;
  data: Scalars['JSON'];
  id: Scalars['GlobalID'];
  updatedAt: Scalars['DateTime'];
  user: User;
};

export type NoteContentArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type NoteCommentInput = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type NoteDataInput = {
  data: Scalars['JSON'];
  id: Scalars['String'];
};

export type NoteDeleteInput = {
  id: Scalars['String'];
};

export type NoteInput = {
  content: Scalars['String'];
  data: Scalars['JSON'];
};

export type OffsetPaginationInput = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};

export enum Ordering {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Organization = {
  __typename?: 'Organization';
  bigImage?: Maybe<DjangoImageType>;
  description: Scalars['String'];
  id: Scalars['GlobalID'];
  image?: Maybe<DjangoImageType>;
  name: Scalars['String'];
  pk: Scalars['String'];
  url: Scalars['String'];
  videoUrl?: Maybe<Scalars['String']>;
  visionMissionWord: Scalars['JSON'];
};

export type OrganizationFilter = {
  id?: InputMaybe<Scalars['String']>;
};

export type OrganizationOrder = {
  sortOrder?: InputMaybe<Ordering>;
};

export type OrganizationUser = {
  __typename?: 'OrganizationUser';
  id: Scalars['GlobalID'];
  index: Scalars['Int'];
  organization: Organization;
  organizationId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type PaginationType = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Period = {
  __typename?: 'Period';
  firstDate: Scalars['Date'];
  id: Scalars['UUID'];
  lastDate: Scalars['Date'];
  name: Scalars['String'];
};

export type PeriodFilter = {
  firstDate?: InputMaybe<DateFilterLookup>;
  lastDate?: InputMaybe<DateFilterLookup>;
};

export type PeriodInput = {
  firstDate: Scalars['Date'];
  id: Scalars['UUID'];
  lastDate: Scalars['Date'];
};

export type PeriodOrder = {
  firstDate?: InputMaybe<Ordering>;
};

export type PeriodPartialInput = {
  firstDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['UUID'];
  lastDate?: InputMaybe<Scalars['Date']>;
};

export type Pinning = {
  __typename?: 'Pinning';
  content: Content;
  contentId: Scalars['String'];
  id: Scalars['UUID'];
  studyGroup: StudyGroup;
  studyGroupId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type PinningUserArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type PinningFilter = {
  content?: InputMaybe<ContentFilter>;
  id?: InputMaybe<Scalars['String']>;
  studyGroup?: InputMaybe<StudyGroupFilter>;
  user?: InputMaybe<UserFilter>;
};

export type PinningInput = {
  id: Scalars['UUID'];
};

export type PinningPartialInput = {
  id: Scalars['UUID'];
};

export type Program = {
  __typename?: 'Program';
  description: Scalars['String'];
  guides: Array<Guide>;
  id: Scalars['UUID'];
  image: DjangoImageType;
  isChallenge: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  isTeacherTraining: Scalars['Boolean'];
  name: Scalars['String'];
  namespaces: Array<Scalars['String']>;
  newMenu: Scalars['Boolean'];
  newRenderer: Scalars['Boolean'];
  pk: Scalars['String'];
  programUnits: Array<Unit>;
  progress: Scalars['Int'];
  studyGroups: Array<StudyGroup>;
  thumbnails?: Maybe<Scalars['Thumbnails']>;
  tracks: Array<Track>;
  units: Array<Unit>;
  useAiFeatures: Scalars['Boolean'];
  video?: Maybe<DjangoFileType>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type ProgramGuidesArgs = {
  filters?: InputMaybe<GuideFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ProgramProgramUnitsArgs = {
  filters?: InputMaybe<UnitFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ProgramTracksArgs = {
  filters?: InputMaybe<TrackFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ProgramUnitsArgs = {
  filters?: InputMaybe<UnitFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ProgramFilter = {
  id?: InputMaybe<Scalars['String']>;
  isChallenge?: InputMaybe<Scalars['Boolean']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isTeacherTraining?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<StrFilterLookup>;
  newRenderer?: InputMaybe<Scalars['Boolean']>;
};

export type ProgramInfo = {
  __typename?: 'ProgramInfo';
  bigImage?: Maybe<DjangoImageType>;
  cardInfo: Scalars['String'];
  demo?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  equipment: Scalars['String'];
  id: Scalars['GlobalID'];
  image?: Maybe<DjangoImageType>;
  /** If blank, will say 'None' */
  knowledgePrerequisites?: Maybe<Scalars['String']>;
  maxGrade: Scalars['Int'];
  maxHours?: Maybe<Scalars['Int']>;
  minGrade: Scalars['Int'];
  minHours?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  partners?: Maybe<Array<Organization>>;
  professionalCompetences: Scalars['String'];
  programRank: Scalars['String'];
  programUnitsDescription?: Maybe<Scalars['String']>;
  scopeAndSequence?: Maybe<DjangoFileType>;
  shortDescription: Scalars['String'];
  shortInfo: Scalars['String'];
  /** This is usually a lowercase version of the section title with hyphens instead of spaces. Other non-alphanumeric characters not allowed. */
  slug?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  /** If blank, will say 'NGSS, ISTE' */
  standardsAlignment?: Maybe<Scalars['String']>;
  studentExp: Scalars['String'];
  tags: Scalars['String'];
  teacherExp: Scalars['String'];
  teacherExperience?: Maybe<Scalars['String']>;
  techFields: Scalars['String'];
  technicalSkills: Scalars['String'];
  technologiesUsedInTheProgram?: Maybe<Scalars['String']>;
  tracks?: Maybe<Array<Track>>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type ProgramInfoTracksArgs = {
  filters?: InputMaybe<TrackFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ProgramInfoFilter = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type ProgramInfoOrder = {
  sortOrder?: InputMaybe<Ordering>;
};

export type ProgramInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  newMenu?: InputMaybe<Scalars['Boolean']>;
  newRenderer?: InputMaybe<Scalars['Boolean']>;
  video?: InputMaybe<Scalars['String']>;
};

export type ProgramJsonContent = {
  __typename?: 'ProgramJsonContent';
  id: Scalars['UUID'];
  name: Scalars['String'];
  units: Array<UnitJsonContent>;
};

export type ProgramOrder = {
  sortOrder?: InputMaybe<Ordering>;
};

export type ProgramPartialInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  newMenu?: InputMaybe<Scalars['Boolean']>;
  newRenderer?: InputMaybe<Scalars['Boolean']>;
  video?: InputMaybe<Scalars['String']>;
};

export type ProgramUnit = {
  __typename?: 'ProgramUnit';
  image: DjangoImageType;
  program: Program;
  thumbnails?: Maybe<Scalars['Thumbnails']>;
  unit: Unit;
};

export type ProgramUnitProgramArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ProgramUnitUnitArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ProgramUnitInput = {
  program: Scalars['String'];
  unit: Scalars['String'];
};

export type ProgramUnitsInput = {
  program: Scalars['String'];
  units: Array<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  adminMartinAnalytics: Scalars['JSON'];
  adminUserAnalyticsBreakdown: Scalars['JSON'];
  adminUserAnalyticsTimeline: Scalars['JSON'];
  adminUserAnalyticsTotals: Scalars['JSON'];
  aiAssistants: Array<AiAssistant>;
  analyticsDrillDown: Scalars['JSON'];
  article: Article;
  articleRead: Array<ArticleRead>;
  articleReads: Array<ArticleRead>;
  articles: Array<Article>;
  assistants: Array<Assistant>;
  availableChallengeStudyGroup?: Maybe<StudyGroup>;
  chalkUp: ChalkUp;
  chalkUps: Array<ChalkUp>;
  challengePoints: Scalars['JSON'];
  challengeSchools: Array<School>;
  challengeStudyGroups: Array<StudyGroup>;
  content: Content;
  contents: Array<Content>;
  conversation: Conversation;
  conversations: Array<Conversation>;
  events: Array<Event>;
  exploreStudyGroups: Array<StudyGroup>;
  filerFolder: Folder;
  filerFolders: Array<Folder>;
  getInteractiveContentState?: Maybe<InteractiveComponentState>;
  getJsonCmsContent: JsonContent;
  getLastChangelog: Changelog;
  getProgramJsonCmsContent: ProgramJsonContent;
  getUserOrganizations: Array<OrganizationUser>;
  globalStudyGroups: Array<StudyGroup>;
  guide: Guide;
  guides: Array<Guide>;
  leadUsers: Array<LeadUser>;
  license: License;
  licenses: Array<License>;
  managedSchools: Array<School>;
  me: User;
  messages: Array<ConversationMessage>;
  module: Module;
  modules: Array<Module>;
  notes: Array<Note>;
  organization: Organization;
  organizationPrograms: Array<Program>;
  organizations: Array<Organization>;
  period: Period;
  periods: Array<Period>;
  pinning: Pinning;
  pinnings: Array<Pinning>;
  program: Program;
  programInfo: ProgramInfo;
  programInfos: Array<ProgramInfo>;
  programs: Array<Program>;
  school: School;
  schools: Array<School>;
  standardResults: Array<StandardResult>;
  studentTeam: StudentTeam;
  studentTeams: Array<StudentTeam>;
  studyGroup: StudyGroup;
  studyGroups: Array<StudyGroup>;
  thread: Thread;
  threads: Array<Thread>;
  track: Track;
  trackContent: TrackContent;
  trackContents: Array<TrackContent>;
  trackModule: TrackModule;
  trackModules: Array<TrackModule>;
  trackTeacherAssignment: TrackTeacherAssignment;
  trackTeacherAssignments: Array<TrackTeacherAssignment>;
  trackUnit: TrackUnit;
  trackUnits: Array<TrackUnit>;
  trackUserChoice: TrackUserChoice;
  trackUserChoices: Array<TrackUserChoice>;
  tracks: Array<Track>;
  typeOfContent: TypeOfContent;
  typeOfContents: Array<TypeOfContent>;
  unit: Unit;
  units: Array<Unit>;
  user: User;
  userAssistants: Array<AiAssistantConfig>;
  userFiles: Array<File>;
  users: Array<User>;
};

export type QueryAdminMartinAnalyticsArgs = {
  deleted?: InputMaybe<Scalars['Boolean']>;
  schoolIds?: InputMaybe<Array<Scalars['String']>>;
  studyGroupIds?: InputMaybe<Array<Scalars['String']>>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryAdminUserAnalyticsBreakdownArgs = {
  activeLicense?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<Scalars['String']>>;
  schoolIds?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['String']>;
  studyGroupIds?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryAdminUserAnalyticsTimelineArgs = {
  activeLicense?: InputMaybe<Scalars['Boolean']>;
  breakDownBy?: Scalars['String'];
  endDate?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<Scalars['String']>>;
  schoolIds?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['String']>;
  studyGroupIds?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryAdminUserAnalyticsTotalsArgs = {
  activeLicense?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<Scalars['String']>>;
  schoolIds?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['String']>;
  studyGroupIds?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryAiAssistantsArgs = {
  filters?: InputMaybe<AssistantFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryArticleArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryArticleReadArgs = {
  filters?: InputMaybe<ArticleReadFilter>;
};

export type QueryArticleReadsArgs = {
  filters?: InputMaybe<ArticleReadFilter>;
};

export type QueryArticlesArgs = {
  filters?: InputMaybe<ArticleFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryChalkUpArgs = {
  order?: InputMaybe<ChalkUpOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryChalkUpsArgs = {
  filters?: InputMaybe<ChalkUpFilter>;
  order?: InputMaybe<ChalkUpOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryContentArgs = {
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryContentsArgs = {
  filters?: InputMaybe<ContentFilter>;
  order?: InputMaybe<ContentOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryConversationArgs = {
  id: Scalars['String'];
};

export type QueryConversationsArgs = {
  conversationId?: InputMaybe<Scalars['String']>;
  gptBlockId?: InputMaybe<Scalars['String']>;
  gptBlockName?: InputMaybe<Scalars['String']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  studyGroupId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type QueryFilerFolderArgs = {
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryFilerFoldersArgs = {
  rootOnly?: Scalars['Boolean'];
};

export type QueryGetInteractiveContentStateArgs = {
  componentId: Scalars['String'];
  studyGroupId: Scalars['String'];
  userId: Scalars['String'];
};

export type QueryGetJsonCmsContentArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pk?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type QueryGetProgramJsonCmsContentArgs = {
  id: Scalars['String'];
};

export type QueryGlobalStudyGroupsArgs = {
  enrolledOrTeacher: Scalars['Boolean'];
};

export type QueryGuideArgs = {
  order?: InputMaybe<GuideOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryGuidesArgs = {
  filters?: InputMaybe<GuideFilter>;
  order?: InputMaybe<GuideOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryLicenseArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryLicensesArgs = {
  filters?: InputMaybe<LicenseFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryManagedSchoolsArgs = {
  pagination?: InputMaybe<PaginationType>;
};

export type QueryMessagesArgs = {
  conversationId: Scalars['String'];
};

export type QueryModuleArgs = {
  order?: InputMaybe<ModuleOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryModulesArgs = {
  filters?: InputMaybe<ModuleFilter>;
  order?: InputMaybe<ModuleOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryNotesArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryOrganizationArgs = {
  order?: InputMaybe<OrganizationOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryOrganizationProgramsArgs = {
  organizationId?: InputMaybe<Scalars['String']>;
};

export type QueryOrganizationsArgs = {
  filters?: InputMaybe<OrganizationFilter>;
  order?: InputMaybe<OrganizationOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryPeriodArgs = {
  order?: InputMaybe<PeriodOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryPeriodsArgs = {
  filters?: InputMaybe<PeriodFilter>;
  order?: InputMaybe<PeriodOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryPinningArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryPinningsArgs = {
  filters?: InputMaybe<PinningFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryProgramArgs = {
  order?: InputMaybe<ProgramOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryProgramInfoArgs = {
  order?: InputMaybe<ProgramInfoOrder>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryProgramInfosArgs = {
  filters?: InputMaybe<ProgramInfoFilter>;
  order?: InputMaybe<ProgramInfoOrder>;
};

export type QueryProgramsArgs = {
  filters?: InputMaybe<ProgramFilter>;
  order?: InputMaybe<ProgramOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QuerySchoolArgs = {
  order?: InputMaybe<SchoolOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QuerySchoolsArgs = {
  filters?: InputMaybe<SchoolFilter>;
  order?: InputMaybe<SchoolOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryStandardResultsArgs = {
  filters?: InputMaybe<StandardResultFilter>;
};

export type QueryStudentTeamArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryStudentTeamsArgs = {
  filters?: InputMaybe<StudentTeamFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryStudyGroupArgs = {
  order?: InputMaybe<StudyGroupOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryStudyGroupsArgs = {
  filters?: InputMaybe<StudyGroupFilter>;
  order?: InputMaybe<StudyGroupOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryThreadArgs = {
  id: Scalars['String'];
};

export type QueryThreadsArgs = {
  filters?: InputMaybe<ThreadFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryTrackArgs = {
  order?: InputMaybe<TrackOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryTrackContentArgs = {
  order?: InputMaybe<TrackContentOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryTrackContentsArgs = {
  filters?: InputMaybe<TrackContentFilter>;
  order?: InputMaybe<TrackContentOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryTrackModuleArgs = {
  order?: InputMaybe<TrackModuleOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryTrackModulesArgs = {
  filters?: InputMaybe<TrackModuleFilter>;
  order?: InputMaybe<TrackModuleOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryTrackTeacherAssignmentArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryTrackTeacherAssignmentsArgs = {
  filters?: InputMaybe<TrackTeacherAssignmentFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryTrackUnitArgs = {
  order?: InputMaybe<TrackUnitOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryTrackUnitsArgs = {
  filters?: InputMaybe<TrackUnitFilter>;
  order?: InputMaybe<TrackUnitOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryTrackUserChoiceArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryTrackUserChoicesArgs = {
  filters?: InputMaybe<TrackUserChoiceFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryTracksArgs = {
  filters?: InputMaybe<TrackFilter>;
  order?: InputMaybe<TrackOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryTypeOfContentArgs = {
  order?: InputMaybe<TypeOfContentOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryTypeOfContentsArgs = {
  filters?: InputMaybe<TypeOfContentFilter>;
  order?: InputMaybe<TypeOfContentOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryUnitArgs = {
  order?: InputMaybe<UnitOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryUnitsArgs = {
  filters?: InputMaybe<UnitFilter>;
  order?: InputMaybe<UnitOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type QueryUserArgs = {
  order?: InputMaybe<UserOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  pk?: InputMaybe<Scalars['ID']>;
};

export type QueryUsersArgs = {
  filters?: InputMaybe<UserFilter>;
  order?: InputMaybe<UserOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ResetConversationInput = {
  blockId: Scalars['String'];
  conversationId: Scalars['String'];
};

export type School = {
  __typename?: 'School';
  affiliation?: Maybe<Affiliation>;
  affiliations: Array<Affiliation>;
  id: Scalars['UUID'];
  infobipUsers: Array<InfobipUserProxy>;
  licenses: Array<License>;
  managers: Array<User>;
  name: Scalars['String'];
  namespace: Scalars['String'];
  programs: Array<Program>;
  students: Array<User>;
  teachers: Array<User>;
};

export type SchoolAffiliationsArgs = {
  filters?: InputMaybe<AffiliationFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type SchoolLicensesArgs = {
  filters?: InputMaybe<LicenseFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type SchoolFilter = {
  affiliation?: InputMaybe<AffiliationFilter>;
  id?: InputMaybe<Scalars['String']>;
  license?: InputMaybe<LicenseFilter>;
  name?: InputMaybe<StrFilterLookup>;
  namespace?: InputMaybe<StrFilterLookup>;
};

export type SchoolInput = {
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type SchoolOrder = {
  name?: InputMaybe<Ordering>;
};

export type SchoolPartialInput = {
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type SeeChangelogInput = {
  id: Scalars['String'];
};

export type Share = {
  __typename?: 'Share';
  content: Content;
  contentId: Scalars['String'];
  id: Scalars['UUID'];
  sharedAt?: Maybe<Scalars['DateTime']>;
  studyGroup: StudyGroup;
  studyGroupId: Scalars['String'];
};

export type ShareStudyGroupArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ShareFilter = {
  content?: InputMaybe<ContentFilter>;
  id?: InputMaybe<Scalars['String']>;
  sharedAt?: InputMaybe<DatetimeFilterLookup>;
  studyGroup?: InputMaybe<StudyGroupFilter>;
};

export type ShareInput = {
  content: NodeInput;
  id: Scalars['UUID'];
  studyGroup: NodeInput;
};

export type SharePartialInput = {
  content?: InputMaybe<NodeInput>;
  id: Scalars['UUID'];
  studyGroup?: InputMaybe<NodeInput>;
};

export type StandardResult = {
  __typename?: 'StandardResult';
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  result: Scalars['Int'];
  user: NodeType;
};

export type StandardResultFilter = {
  id?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserFilter>;
};

export type StrCustomFilterLookup = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  exact?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  iContains?: InputMaybe<Scalars['String']>;
  iEndsWith?: InputMaybe<Scalars['String']>;
  iExact?: InputMaybe<Scalars['String']>;
  iRegex?: InputMaybe<Scalars['String']>;
  iStartsWith?: InputMaybe<Scalars['String']>;
  inList?: InputMaybe<Array<Scalars['String']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  range?: InputMaybe<Array<Scalars['String']>>;
  regex?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StrFieldWithFilter = {
  field: Scalars['String'];
  lookup: StrCustomFilterLookup;
};

export type StrFieldsOrFilter = {
  fields: Array<StrFieldWithFilter>;
};

export type StrFilterLookup = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  exact?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  iContains?: InputMaybe<Scalars['String']>;
  iEndsWith?: InputMaybe<Scalars['String']>;
  iExact?: InputMaybe<Scalars['String']>;
  iRegex?: InputMaybe<Scalars['String']>;
  iStartsWith?: InputMaybe<Scalars['String']>;
  inList?: InputMaybe<Array<Scalars['String']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  range?: InputMaybe<Array<Scalars['String']>>;
  regex?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StudentTeam = {
  __typename?: 'StudentTeam';
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  members: Array<User>;
  name: Scalars['String'];
  studyGroup?: Maybe<StudyGroup>;
  teamLeader: User;
};

export type StudentTeamFilter = {
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  members?: InputMaybe<DjangoModelFilterInput>;
  name?: InputMaybe<StrFilterLookup>;
  studyGroup?: InputMaybe<StudyGroupFilter>;
  teamLeader?: InputMaybe<UserFilter>;
};

export type StudyGroup = {
  __typename?: 'StudyGroup';
  chalkups: Array<ChalkUp>;
  id: Scalars['UUID'];
  infobipUsers: Array<InfobipUserProxy>;
  inviteCode: Scalars['String'];
  inviteCodeEnabled: Scalars['Boolean'];
  isChallenge: Scalars['Boolean'];
  isExplore: Scalars['Boolean'];
  isSelfLearning: Scalars['Boolean'];
  license: License;
  name: Scalars['String'];
  pinnings: Array<Pinning>;
  pk: Scalars['String'];
  program: Program;
  schoolName: Scalars['String'];
  shares: Array<Share>;
  students: Array<User>;
  teachers: Array<User>;
  trackAssignments?: Maybe<Array<Scalars['String']>>;
  trackChoice?: Maybe<Scalars['String']>;
  tracks: Array<Track>;
  tracksLicense: Array<Track>;
  usesMaxWidth: Scalars['Boolean'];
  usesNewRenderer: Scalars['Boolean'];
};

export type StudyGroupChalkupsArgs = {
  filters?: InputMaybe<ChalkUpFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type StudyGroupSharesArgs = {
  filters?: InputMaybe<ShareFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type StudyGroupFilter = {
  fieldsOrFilter?: InputMaybe<StrFieldsOrFilter>;
  id?: InputMaybe<Scalars['String']>;
  inviteCode?: InputMaybe<StrFilterLookup>;
  inviteCodeEnabled?: InputMaybe<Scalars['Boolean']>;
  isChallenge?: InputMaybe<Scalars['Boolean']>;
  isExplore?: InputMaybe<Scalars['Boolean']>;
  isSelfLearning?: InputMaybe<Scalars['Boolean']>;
  license?: InputMaybe<LicenseFilter>;
  name?: InputMaybe<StrFilterLookup>;
};

export type StudyGroupInput = {
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type StudyGroupOrder = {
  sortOrder?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type StudyGroupPartialInput = {
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type Thread = {
  __typename?: 'Thread';
  assistant: AiAssistant;
  block?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['UUID'];
  messages: Array<Message>;
  newMessages: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: NodeType;
};

export type ThreadAssistantArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type ThreadData = {
  __typename?: 'ThreadData';
  id: Scalars['UUID'];
};

export type ThreadFilter = {
  assistant?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserFilter>;
};

export type ThreadInput = {
  assistantId: Scalars['String'];
  block?: InputMaybe<Scalars['String']>;
};

export type Track = {
  __typename?: 'Track';
  conditionEnabled: Scalars['Boolean'];
  conditionShown: Scalars['Boolean'];
  description: Scalars['String'];
  disableMessage?: Maybe<Scalars['String']>;
  enableCondition?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  estimatedDuration: Scalars['Int'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  program: Program;
  progress?: Maybe<Scalars['Float']>;
  showCondition?: Maybe<Scalars['String']>;
  /** A comma-separated list of tags. */
  tags: Array<Scalars['String']>;
  trackGuides: Array<TrackGuide>;
  trackUnits: Array<TrackUnit>;
};

export type TrackProgramArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type TrackTrackGuidesArgs = {
  filters?: InputMaybe<TrackGuideFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type TrackTrackUnitsArgs = {
  filters?: InputMaybe<TrackUnitFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type TrackBigPartialInput = {
  description?: InputMaybe<Scalars['String']>;
  disableMessage?: InputMaybe<Scalars['String']>;
  enableCondition?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  showCondition?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** A comma-separated list of tags. */
  tags: Array<Scalars['String']>;
  trackGuides: Array<TrackGuideInput>;
  trackUnits: Array<TrackUnitBigInput>;
};

export type TrackContent = {
  __typename?: 'TrackContent';
  conditionEnabled: Scalars['Boolean'];
  conditionShown: Scalars['Boolean'];
  content: Content;
  disableMessage?: Maybe<Scalars['String']>;
  enableCondition?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  forwardContent?: Maybe<Content>;
  id: Scalars['UUID'];
  showCondition?: Maybe<Scalars['String']>;
  trackModule: TrackModule;
};

export type TrackContentContentArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type TrackContentForwardContentArgs = {
  pk?: InputMaybe<Scalars['ID']>;
};

export type TrackContentTrackModuleArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type TrackContentBigInput = {
  disableMessage?: InputMaybe<Scalars['String']>;
  enableCondition?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  showCondition?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  trackModule?: InputMaybe<Scalars['String']>;
};

export type TrackContentCreateInput = {
  content: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  trackModule: Scalars['String'];
};

export type TrackContentFilter = {
  content?: InputMaybe<ContentFilter>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  trackModule?: InputMaybe<TrackModuleFilter>;
};

export type TrackContentInput = {
  content: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  trackModule: Scalars['String'];
};

export type TrackContentOrder = {
  content_SortOrder?: InputMaybe<Ordering>;
};

export type TrackContentPartialInput = {
  content: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  trackModule: Scalars['String'];
};

export type TrackCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  disableMessage?: InputMaybe<Scalars['String']>;
  enableCondition?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  program: Scalars['String'];
  showCondition?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type TrackFilter = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<StrFilterLookup>;
  program?: InputMaybe<ProgramFilter>;
};

export type TrackGuide = {
  __typename?: 'TrackGuide';
  enabled: Scalars['Boolean'];
  guide: Guide;
  id: Scalars['UUID'];
};

export type TrackGuideGuideArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type TrackGuideFilter = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  guide?: InputMaybe<GuideFilter>;
  id?: InputMaybe<Scalars['String']>;
};

export type TrackGuideInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type TrackModule = {
  __typename?: 'TrackModule';
  conditionEnabled: Scalars['Boolean'];
  conditionShown: Scalars['Boolean'];
  disableMessage?: Maybe<Scalars['String']>;
  enableCondition?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['UUID'];
  module: Module;
  showCondition?: Maybe<Scalars['String']>;
  trackContents: Array<TrackContent>;
  trackUnit: TrackUnit;
};

export type TrackModuleModuleArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type TrackModuleTrackContentsArgs = {
  filters?: InputMaybe<TrackContentFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type TrackModuleTrackUnitArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type TrackModuleBigInput = {
  disableMessage?: InputMaybe<Scalars['String']>;
  enableCondition?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  showCondition?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  trackContents?: InputMaybe<Array<TrackContentBigInput>>;
  trackUnit?: InputMaybe<Scalars['String']>;
};

export type TrackModuleFilter = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  module?: InputMaybe<ModuleFilter>;
  trackUnit?: InputMaybe<TrackUnitFilter>;
};

export type TrackModuleInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  module: Scalars['String'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  trackUnit: Scalars['String'];
};

export type TrackModuleOrder = {
  module_SortOrder?: InputMaybe<Ordering>;
};

export type TrackModulePartialInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  module: Scalars['String'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  trackUnit: Scalars['String'];
};

export type TrackOrder = {
  sortOrder?: InputMaybe<Ordering>;
};

export type TrackPartialInput = {
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  program: Scalars['String'];
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type TrackTeacherAssignment = {
  __typename?: 'TrackTeacherAssignment';
  id: Scalars['UUID'];
  studyGroup: StudyGroup;
  track: Track;
  user: User;
};

export type TrackTeacherAssignmentStudyGroupArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type TrackTeacherAssignmentFilter = {
  id?: InputMaybe<Scalars['String']>;
  studyGroup?: InputMaybe<StudyGroupFilter>;
  track?: InputMaybe<TrackFilter>;
  user?: InputMaybe<UserFilter>;
};

export type TrackTeacherAssignmentInput = {
  id: Scalars['UUID'];
  studyGroup: NodeInput;
  track: NodeInput;
  user: NodeInput;
};

export type TrackTeacherAssignmentPartialInput = {
  id: Scalars['UUID'];
  studyGroup?: InputMaybe<NodeInput>;
  track?: InputMaybe<NodeInput>;
  user?: InputMaybe<NodeInput>;
};

export type TrackUnit = {
  __typename?: 'TrackUnit';
  canBeShared?: Maybe<Scalars['Float']>;
  conditionEnabled: Scalars['Boolean'];
  conditionShown: Scalars['Boolean'];
  disableMessage?: Maybe<Scalars['String']>;
  enableCondition?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['UUID'];
  progress?: Maybe<Scalars['Float']>;
  showCondition?: Maybe<Scalars['String']>;
  track: Track;
  trackModules: Array<TrackModule>;
  unit: Unit;
};

export type TrackUnitTrackArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type TrackUnitTrackModulesArgs = {
  filters?: InputMaybe<TrackModuleFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type TrackUnitUnitArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type TrackUnitBigInput = {
  disableMessage?: InputMaybe<Scalars['String']>;
  enableCondition?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  showCondition?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  track?: InputMaybe<Scalars['String']>;
  trackModules?: InputMaybe<Array<TrackModuleBigInput>>;
};

export type TrackUnitFilter = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  track?: InputMaybe<TrackFilter>;
  unit?: InputMaybe<UnitFilter>;
};

export type TrackUnitInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  track: Scalars['String'];
  unit: Scalars['String'];
};

export type TrackUnitOrder = {
  sortOrder?: InputMaybe<Ordering>;
};

export type TrackUnitPartialInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  track: Scalars['String'];
  unit: Scalars['String'];
};

export type TrackUserChoice = {
  __typename?: 'TrackUserChoice';
  id: Scalars['UUID'];
  studyGroup: StudyGroup;
  track: Track;
  user: User;
};

export type TrackUserChoiceStudyGroupArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type TrackUserChoiceFilter = {
  id?: InputMaybe<Scalars['String']>;
  studyGroup?: InputMaybe<StudyGroupFilter>;
  track?: InputMaybe<TrackFilter>;
  user?: InputMaybe<UserFilter>;
};

export type TrackUserChoiceInput = {
  id: Scalars['UUID'];
  studyGroup: NodeInput;
  track: NodeInput;
  user: NodeInput;
};

export type TrackUserChoicePartialInput = {
  id: Scalars['UUID'];
  studyGroup?: InputMaybe<NodeInput>;
  track?: InputMaybe<NodeInput>;
  user?: InputMaybe<NodeInput>;
};

export type TypeOfContent = {
  __typename?: 'TypeOfContent';
  forModules: Scalars['Boolean'];
  forPrograms: Scalars['Boolean'];
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type TypeOfContentFilter = {
  forModules?: InputMaybe<Scalars['Boolean']>;
  forPrograms?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<StrFilterLookup>;
};

export type TypeOfContentOrder = {
  sortOrder?: InputMaybe<Ordering>;
};

export type UuidFilterLookup = {
  contains?: InputMaybe<Scalars['UUID']>;
  endsWith?: InputMaybe<Scalars['UUID']>;
  exact?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  iContains?: InputMaybe<Scalars['UUID']>;
  iEndsWith?: InputMaybe<Scalars['UUID']>;
  iExact?: InputMaybe<Scalars['UUID']>;
  iRegex?: InputMaybe<Scalars['String']>;
  iStartsWith?: InputMaybe<Scalars['UUID']>;
  inList?: InputMaybe<Array<Scalars['UUID']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  range?: InputMaybe<Array<Scalars['UUID']>>;
  regex?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['UUID']>;
};

export type Unit = {
  __typename?: 'Unit';
  color: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: DjangoImageType;
  isDemo: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  modules: Array<Module>;
  name: Scalars['String'];
  pk: Scalars['String'];
  programInfoDescription: Scalars['String'];
  progress: Scalars['Int'];
  thumbnails?: Maybe<Scalars['Thumbnails']>;
};

export type UnitModulesArgs = {
  filters?: InputMaybe<ModuleFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type UnitFilter = {
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<StrFilterLookup>;
  program?: InputMaybe<ProgramFilter>;
};

export type UnitInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  isDemo?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  program: Scalars['String'];
};

export type UnitJsonContent = {
  __typename?: 'UnitJsonContent';
  id: Scalars['UUID'];
  modules: Array<ModuleJsonContent>;
  name: Scalars['String'];
};

export type UnitModulesInput = {
  modules: Array<Scalars['String']>;
  unit: Scalars['String'];
};

export type UnitOrder = {
  sortOrder?: InputMaybe<Ordering>;
};

export type UploadFilterLookup = {
  contains?: InputMaybe<Scalars['Upload']>;
  endsWith?: InputMaybe<Scalars['Upload']>;
  exact?: InputMaybe<Scalars['Upload']>;
  gt?: InputMaybe<Scalars['Upload']>;
  gte?: InputMaybe<Scalars['Upload']>;
  iContains?: InputMaybe<Scalars['Upload']>;
  iEndsWith?: InputMaybe<Scalars['Upload']>;
  iExact?: InputMaybe<Scalars['Upload']>;
  iRegex?: InputMaybe<Scalars['String']>;
  iStartsWith?: InputMaybe<Scalars['Upload']>;
  inList?: InputMaybe<Array<Scalars['Upload']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Upload']>;
  lte?: InputMaybe<Scalars['Upload']>;
  range?: InputMaybe<Array<Scalars['Upload']>>;
  regex?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['Upload']>;
};

export type User = {
  __typename?: 'User';
  chalkups: Array<ChalkUp>;
  dateJoined: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  hasEmail: Scalars['Boolean'];
  hasWrongEmail: Scalars['Boolean'];
  hasWrongUsername: Scalars['Boolean'];
  id: Scalars['UUID'];
  infobipDirect?: Maybe<InfobipUserProxy>;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean'];
  isDemo: Scalars['Boolean'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean'];
  lastName: Scalars['String'];
  pk: Scalars['String'];
  showExperimentalFeatures: Scalars['Boolean'];
  studentTeams: Scalars['String'];
  studyGroups: Array<StudyGroup>;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String'];
};

export type UserFilter = {
  id?: InputMaybe<Scalars['String']>;
};

export type UserOrder = {
  sortOrder?: InputMaybe<Ordering>;
};

export type Vector = {
  __typename?: 'Vector';
  createdAt?: Maybe<Scalars['DateTime']>;
  files: Array<File>;
  id: Scalars['UUID'];
};

export type GetLastChangelogQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetLastChangelogQueryQuery = {
  __typename?: 'Query';
  getLastChangelog: {
    __typename?: 'Changelog';
    id: any;
    title: string;
    seen: boolean;
    log: string;
    startDate: any;
    endDate: any;
  };
};

export type SeeChangelogMutationVariables = Exact<{
  data: SeeChangelogInput;
}>;

export type SeeChangelogMutation = {
  __typename?: 'Mutation';
  seeChangelog: boolean;
};

export type GetUserAssistantsQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserAssistantsQuery = {
  __typename?: 'Query';
  userAssistants: Array<{
    __typename?: 'AiAssistantConfig';
    id: any;
    customInstructions: string;
    initialMessage?: string | null;
    name: string;
    isShared: boolean;
    vector?: {
      __typename?: 'Vector';
      id: any;
      files: Array<{
        __typename?: 'File';
        id: any;
        createdAt?: any | null;
        file: { __typename?: 'DjangoFileType'; name: string };
      }>;
    } | null;
  }>;
};

export type ToggleAssistantShareMutationVariables = Exact<{
  assistantId: Scalars['UUID'];
}>;

export type ToggleAssistantShareMutation = {
  __typename?: 'Mutation';
  toggleAssistantShare: {
    __typename?: 'AiAssistantConfig';
    id: any;
    isShared: boolean;
  };
};

export type GetAiAssistantsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAiAssistantsQuery = {
  __typename?: 'Query';
  aiAssistants: Array<{
    __typename?: 'AiAssistant';
    id: any;
    name: string;
    imageUrl?: string | null;
    namespaces: Array<string>;
    type: string;
    newMessages?: Array<{
      __typename?: 'Message';
      content?: string | null;
      createdAt?: any | null;
      id: any;
      inappropriate?: string | null;
      offtopic?: string | null;
      suggestion?: string | null;
      role: string;
      thread?: { __typename?: 'ThreadData'; id: any } | null;
    }> | null;
  }>;
};

export type GetThreadsByAssistantQueryVariables = Exact<{
  assistantId: Scalars['String'];
  userId: Scalars['String'];
}>;

export type GetThreadsByAssistantQuery = {
  __typename?: 'Query';
  threads: Array<{
    __typename?: 'Thread';
    id: any;
    block?: string | null;
    newMessages: boolean;
    createdAt?: any | null;
    updatedAt?: any | null;
  }>;
};

export type GetThreadsByAssistantWithMessagesQueryVariables = Exact<{
  assistantId: Scalars['String'];
  userId: Scalars['String'];
}>;

export type GetThreadsByAssistantWithMessagesQuery = {
  __typename?: 'Query';
  threads: Array<{
    __typename?: 'Thread';
    id: any;
    block?: string | null;
    newMessages: boolean;
    createdAt?: any | null;
    updatedAt?: any | null;
    messages: Array<{
      __typename?: 'Message';
      content?: string | null;
      createdAt?: any | null;
      id: any;
      inappropriate?: string | null;
      offtopic?: string | null;
    }>;
  }>;
};

export type CreateThreadMutationVariables = Exact<{
  assistantId: Scalars['String'];
  blockId?: InputMaybe<Scalars['String']>;
}>;

export type CreateThreadMutation = {
  __typename?: 'Mutation';
  createThread: { __typename?: 'Thread'; id: any };
};

export type CreateUserAssistantMutationVariables = Exact<{
  name: Scalars['String'];
}>;

export type CreateUserAssistantMutation = {
  __typename?: 'Mutation';
  createAssistant?: {
    __typename?: 'AiAssistantConfig';
    customInstructions: string;
    id: any;
    initialMessage?: string | null;
    name: string;
  } | null;
};

export type UpdateUserAssitantMutationVariables = Exact<{
  assistantId: Scalars['String'];
  name: Scalars['String'];
  customInstructions: Scalars['String'];
  initialMessage: Scalars['String'];
  file?: InputMaybe<Scalars['String']>;
}>;

export type UpdateUserAssitantMutation = {
  __typename?: 'Mutation';
  updateAssistant?: {
    __typename?: 'AiAssistantConfig';
    id: any;
    customInstructions: string;
    initialMessage?: string | null;
    name: string;
  } | null;
};

export type GetThreadQueryVariables = Exact<{
  threadId: Scalars['String'];
}>;

export type GetThreadQuery = {
  __typename?: 'Query';
  thread: {
    __typename?: 'Thread';
    id: any;
    newMessages: boolean;
    createdAt?: any | null;
    updatedAt?: any | null;
    messages: Array<{
      __typename?: 'Message';
      content?: string | null;
      createdAt?: any | null;
      id: any;
      inappropriate?: string | null;
      offtopic?: string | null;
      suggestion?: string | null;
      role: string;
    }>;
  };
};

export type CreateMessageMutationVariables = Exact<{
  threadId: Scalars['String'];
  content: Scalars['String'];
}>;

export type CreateMessageMutation = {
  __typename?: 'Mutation';
  createMessage: {
    __typename?: 'Thread';
    id: any;
    messages: Array<{
      __typename?: 'Message';
      content?: string | null;
      createdAt?: any | null;
      id: any;
      inappropriate?: string | null;
      offtopic?: string | null;
      suggestion?: string | null;
      role: string;
    }>;
  };
};

export type CreateTriggerFromBlockMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type CreateTriggerFromBlockMutation = {
  __typename?: 'Mutation';
  createTriggerFromBlock: boolean;
};

export type GetUserFilesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserFilesQuery = {
  __typename?: 'Query';
  userFiles: Array<{
    __typename?: 'File';
    vectorIds: Array<string>;
    id: any;
    file: { __typename?: 'DjangoFileType'; name: string };
  }>;
};

export type CreateFileMutationVariables = Exact<{
  file: Scalars['String'];
  vectorId?: InputMaybe<Scalars['String']>;
}>;

export type CreateFileMutation = {
  __typename?: 'Mutation';
  createFile: boolean;
};

export type GetStudentTeamsQueryVariables = Exact<{
  studyGroupId: Scalars['String'];
}>;

export type GetStudentTeamsQuery = {
  __typename?: 'Query';
  studentTeams: Array<{
    __typename?: 'StudentTeam';
    id: any;
    name: string;
    teamLeader: { __typename?: 'User'; pk: string };
    members: Array<{ __typename?: 'User'; pk: string }>;
  }>;
};

export type ArticleQueryVariables = Exact<{
  articleId: Scalars['ID'];
}>;

export type ArticleQuery = {
  __typename?: 'Query';
  article: {
    __typename?: 'Article';
    driveUrl?: string | null;
    fileUrl?: string | null;
    id: any;
    pk: string;
    mediaType: string;
    name: string;
    namespace: string;
    pdfUrl?: string | null;
    preziUrl?: string | null;
    type: string;
    youtubeUrl?: string | null;
  };
};

export type GetArticleReadsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;

export type GetArticleReadsQuery = {
  __typename?: 'Query';
  articleReads: Array<{
    __typename?: 'ArticleRead';
    userId: string;
    articleId: string;
  }>;
};

export type CreateArticleReadMutationVariables = Exact<{
  articleId: Scalars['String'];
}>;

export type CreateArticleReadMutation = {
  __typename?: 'Mutation';
  createArticleRead: {
    __typename?: 'ArticleRead';
    userId: string;
    articleId: string;
  };
};

export type AnalyticsChalkupsQueryVariables = Exact<{
  studyGroupId: Scalars['String'];
}>;

export type AnalyticsChalkupsQuery = {
  __typename?: 'Query';
  chalkUps: Array<{
    __typename?: 'ChalkUp';
    content: { __typename?: 'Content'; id: any };
    user: { __typename?: 'User'; id: any };
  }>;
};

export type ProgramAndStudyGroupDrillDownQueryVariables = Exact<{
  programId: Scalars['ID'];
  studyGroupId: Scalars['ID'];
}>;

export type ProgramAndStudyGroupDrillDownQuery = {
  __typename?: 'Query';
  program: {
    __typename?: 'Program';
    id: any;
    name: string;
    newRenderer: boolean;
    newMenu: boolean;
    programUnits: Array<{
      __typename?: 'Unit';
      id: any;
      name: string;
      modules: Array<{
        __typename?: 'Module';
        id: any;
        name: string;
        contents: Array<{ __typename?: 'Content'; id: any; name: string }>;
      }>;
    }>;
  };
  studyGroup: {
    __typename?: 'StudyGroup';
    id: any;
    name: string;
    isSelfLearning: boolean;
    students: Array<{
      __typename?: 'User';
      id: any;
      fullName: string;
      email: string;
      username: string;
    }>;
    license: {
      __typename?: 'License';
      period: { __typename?: 'Period'; firstDate: any; lastDate: any };
    };
  };
};

export type SudyGroupPersonalizedLearningConversationsQueryVariables = Exact<{
  studyGroupId: Scalars['String'];
}>;

export type SudyGroupPersonalizedLearningConversationsQuery = {
  __typename?: 'Query';
  conversations: Array<{
    __typename?: 'Conversation';
    id: any;
    name: string;
    gptBlockUniqueId?: any | null;
    createdAt?: any | null;
    history: Array<{
      __typename?: 'ConversationMessage';
      createdAt?: any | null;
      id: any;
      isGenerated: boolean;
      text: string;
    }>;
    user: {
      __typename?: 'User';
      id: any;
      email: string;
      firstName: string;
      fullName: string;
      lastName: string;
      username: string;
    };
  }>;
};

export type SchoolForStudyGroupQueryVariables = Exact<{
  studyGroupId: Scalars['ID'];
}>;

export type SchoolForStudyGroupQuery = {
  __typename?: 'Query';
  studyGroup: {
    __typename?: 'StudyGroup';
    license: {
      __typename?: 'License';
      school: { __typename?: 'School'; id: any; name: string };
    };
  };
};

export type InteractiveComponentStateQueryVariables = Exact<{
  userId: Scalars['String'];
  studyGroupId: Scalars['String'];
  componentId: Scalars['String'];
}>;

export type InteractiveComponentStateQuery = {
  __typename?: 'Query';
  getInteractiveContentState?: {
    __typename?: 'InteractiveComponentState';
    state: any;
  } | null;
};

export type SaveInteractiveComponentStateMutationVariables = Exact<{
  data: InteractiveComponentStateInput;
  reset?: InputMaybe<Scalars['Boolean']>;
}>;

export type SaveInteractiveComponentStateMutation = {
  __typename?: 'Mutation';
  saveInteractiveComponentState: {
    __typename?: 'InteractiveComponentState';
    state: any;
  };
};

export type GetInfobipUsersForStudyGroupQueryVariables = Exact<{
  studyGroupId: Scalars['ID'];
}>;

export type GetInfobipUsersForStudyGroupQuery = {
  __typename?: 'Query';
  studyGroup: {
    __typename?: 'StudyGroup';
    infobipUsers: Array<{
      __typename?: 'InfobipUserProxy';
      id: number;
      platformId?: string | null;
      platformSchoolId?: string | null;
      platformStudyGroupId?: string | null;
      infobipState: string;
      infobipPassword?: string | null;
      complete: boolean;
      phoneVerified: boolean;
    }>;
  };
};

export type GetInfobipUsersForSchoolQueryVariables = Exact<{
  schoolId: Scalars['String'];
}>;

export type GetInfobipUsersForSchoolQuery = {
  __typename?: 'Query';
  schools: Array<{
    __typename?: 'School';
    infobipUsers: Array<{
      __typename?: 'InfobipUserProxy';
      id: number;
      platformId?: string | null;
      platformSchoolId?: string | null;
      platformStudyGroupId?: string | null;
      infobipState: string;
      infobipPassword?: string | null;
      complete: boolean;
      phoneVerified: boolean;
    }>;
  }>;
};

export type CreateInfobipUserMutationVariables = Exact<{
  userId: Scalars['String'];
  studyGroupId: Scalars['String'];
}>;

export type CreateInfobipUserMutation = {
  __typename?: 'Mutation';
  createInfobip: {
    __typename?: 'User';
    id: any;
    infobipDirect?: {
      __typename?: 'InfobipUserProxy';
      id: number;
      infobipState: string;
    } | null;
  };
};

export type GetAllStudentsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllStudentsQuery = {
  __typename?: 'Query';
  studyGroups: Array<{
    __typename?: 'StudyGroup';
    id: any;
    students: Array<{
      __typename?: 'User';
      id: any;
      username: string;
      firstName: string;
      lastName: string;
      email: string;
    }>;
  }>;
};

export type ManagedSchoolsQueryVariables = Exact<{ [key: string]: never }>;

export type ManagedSchoolsQuery = {
  __typename?: 'Query';
  managedSchools: Array<{
    __typename?: 'School';
    id: any;
    name: string;
    programs: Array<{ __typename?: 'Program'; id: any }>;
    licenses: Array<{
      __typename?: 'License';
      id: any;
      maxStudents: number;
      maxTeachers: number;
      studyGroup?: {
        __typename?: 'StudyGroup';
        id: any;
        name: string;
        inviteCode: string;
        inviteCodeEnabled: boolean;
      } | null;
      period: {
        __typename?: 'Period';
        id: any;
        firstDate: any;
        lastDate: any;
        name: string;
      };
      program: {
        __typename?: 'Program';
        id: any;
        name: string;
        thumbnails?: any | null;
        image: { __typename?: 'DjangoImageType'; name: string };
      };
    }>;
    affiliation?: {
      __typename?: 'Affiliation';
      isManager: boolean;
      isTeacher: boolean;
    } | null;
  }>;
};

export type OrganizationsQueryVariables = Exact<{ [key: string]: never }>;

export type OrganizationsQuery = {
  __typename?: 'Query';
  organizations: Array<{
    __typename?: 'Organization';
    id: any;
    description: string;
    name: string;
    pk: string;
  }>;
};

export type OrganizationProgramsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']>;
}>;

export type OrganizationProgramsQuery = {
  __typename?: 'Query';
  organizationPrograms: Array<{
    __typename?: 'Program';
    description: string;
    id: any;
    name: string;
    pk: string;
    thumbnails?: any | null;
  }>;
};

export type GetUserOrganizationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUserOrganizationsQuery = {
  __typename?: 'Query';
  getUserOrganizations: Array<{
    __typename?: 'OrganizationUser';
    id: any;
    index: number;
    organization: { __typename?: 'Organization'; id: any; name: string };
  }>;
};

export type UsersStudyGroupsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;

export type UsersStudyGroupsQuery = {
  __typename?: 'Query';
  studyGroups: Array<{
    __typename?: 'StudyGroup';
    id: any;
    name: string;
    isSelfLearning: boolean;
    license: {
      __typename?: 'License';
      program: {
        __typename?: 'Program';
        id: any;
        name: string;
        newRenderer: boolean;
        newMenu: boolean;
        programUnits: Array<{
          __typename?: 'Unit';
          id: any;
          name: string;
          modules: Array<{
            __typename?: 'Module';
            id: any;
            name: string;
            contents: Array<{ __typename?: 'Content'; id: any; name: string }>;
          }>;
        }>;
      };
      period: { __typename?: 'Period'; firstDate: any; lastDate: any };
    };
  }>;
  users: Array<{
    __typename?: 'User';
    id: any;
    fullName: string;
    email: string;
    username: string;
  }>;
};

export type AdminAnalyticsOrganizationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAnalyticsOrganizationsQuery = {
  __typename?: 'Query';
  organizations: Array<{ __typename?: 'Organization'; id: any; name: string }>;
};

export type AdminAnalyticsProgramsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAnalyticsProgramsQuery = {
  __typename?: 'Query';
  programs: Array<{
    __typename?: 'Program';
    id: any;
    name: string;
    programUnits: Array<{
      __typename?: 'Unit';
      id: any;
      name: string;
      modules: Array<{
        __typename?: 'Module';
        id: any;
        name: string;
        contents: Array<{ __typename?: 'Content'; id: any; name: string }>;
      }>;
    }>;
  }>;
};

export type AdminAnalyticsSchoolsQueryVariables = Exact<{
  includeTeachers?: InputMaybe<Scalars['Boolean']>;
}>;

export type AdminAnalyticsSchoolsQuery = {
  __typename?: 'Query';
  schools: Array<{
    __typename?: 'School';
    id: any;
    name: string;
    licenses: Array<{
      __typename?: 'License';
      studyGroup?: {
        __typename?: 'StudyGroup';
        id: any;
        name: string;
        students: Array<{
          __typename?: 'User';
          id: any;
          username: string;
          fullName: string;
          email: string;
        }>;
        teachers?: Array<{
          __typename?: 'User';
          id: any;
          username: string;
          fullName: string;
          email: string;
        }>;
      } | null;
    }>;
  }>;
};

export type AdminAnalyticsDrillDownQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAnalyticsDrillDownQuery = {
  __typename?: 'Query';
  analyticsDrillDown: any;
};

export type AdminMartinAnalyticsQueryVariables = Exact<{
  schoolIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  studyGroupIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
}>;

export type AdminMartinAnalyticsQuery = {
  __typename?: 'Query';
  adminMartinAnalytics: any;
};

export type AdminUserAnalyticsTimelineQueryVariables = Exact<{
  organizationIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  schoolIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  studyGroupIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  activeLicense?: InputMaybe<Scalars['Boolean']>;
  breakDownBy?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;

export type AdminUserAnalyticsTimelineQuery = {
  __typename?: 'Query';
  adminUserAnalyticsTimeline: any;
};

export type AdminUserAnalyticsTotalsQueryVariables = Exact<{
  organizationIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  schoolIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  studyGroupIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  activeLicense?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;

export type AdminUserAnalyticsTotalsQuery = {
  __typename?: 'Query';
  adminUserAnalyticsTotals: any;
};

export type AdminUserAnalyticsBreakdownQueryVariables = Exact<{
  organizationIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  schoolIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  studyGroupIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  activeLicense?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;

export type AdminUserAnalyticsBreakdownQuery = {
  __typename?: 'Query';
  adminUserAnalyticsBreakdown: any;
};

export type StudyGroupWithoutUsersQueryVariables = Exact<{
  studyGroupId: Scalars['ID'];
  userId: Scalars['String'];
}>;

export type StudyGroupWithoutUsersQuery = {
  __typename?: 'Query';
  studyGroup: {
    __typename?: 'StudyGroup';
    id: any;
    pk: string;
    name: string;
    isSelfLearning: boolean;
    isExplore: boolean;
    trackAssignments?: Array<string> | null;
    trackChoice?: string | null;
    license: {
      __typename?: 'License';
      id: any;
      period: { __typename?: 'Period'; lastDate: any };
      program: { __typename?: 'Program'; id: any; pk: string };
    };
    tracksLicense: Array<{ __typename?: 'Track'; id: any; name: string }>;
    shares: Array<{ __typename?: 'Share'; id: any; contentId: string }>;
    chalkups: Array<{ __typename?: 'ChalkUp'; id: any; contentId: string }>;
  };
  pinnings: Array<{ __typename?: 'Pinning'; id: any; contentId: string }>;
};

export type StudyGroupQueryVariables = Exact<{
  studyGroupId: Scalars['ID'];
  userId: Scalars['String'];
}>;

export type StudyGroupQuery = {
  __typename?: 'Query';
  studyGroup: {
    __typename?: 'StudyGroup';
    id: any;
    pk: string;
    name: string;
    isSelfLearning: boolean;
    isExplore: boolean;
    trackAssignments?: Array<string> | null;
    trackChoice?: string | null;
    license: {
      __typename?: 'License';
      id: any;
      period: { __typename?: 'Period'; lastDate: any };
      program: { __typename?: 'Program'; id: any; pk: string };
    };
    tracksLicense: Array<{ __typename?: 'Track'; id: any; name: string }>;
    students: Array<{
      __typename?: 'User';
      pk: string;
      username: string;
      email: string;
      firstName: string;
      lastName: string;
      fullName: string;
    }>;
    teachers: Array<{
      __typename?: 'User';
      pk: string;
      username: string;
      email: string;
      firstName: string;
      lastName: string;
      fullName: string;
    }>;
    shares: Array<{ __typename?: 'Share'; id: any; contentId: string }>;
    chalkups: Array<{ __typename?: 'ChalkUp'; id: any; contentId: string }>;
  };
  pinnings: Array<{ __typename?: 'Pinning'; id: any; contentId: string }>;
};

export type ProgramQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;

export type ProgramQuery = {
  __typename?: 'Query';
  program: {
    __typename?: 'Program';
    id: any;
    pk: string;
    name: string;
    description: string;
    videoUrl?: string | null;
    newMenu: boolean;
    thumbnails?: any | null;
    image: { __typename?: 'DjangoImageType'; name: string };
    guides: Array<{
      __typename?: 'Guide';
      id: any;
      name: string;
      pdfUrl?: string | null;
      mediaType: string;
      youtubeUrl?: string | null;
      preziUrl?: string | null;
      driveUrl?: string | null;
      fileUrl?: string | null;
      videoUrl?: string | null;
    }>;
  };
};

export type ClassPageUnitFragmentFragment = {
  __typename?: 'Unit';
  isPublished: boolean;
  description: string;
  thumbnails?: any | null;
  color: string;
  image: { __typename?: 'DjangoImageType'; name: string };
};

export type ProgramAndProgramUnitsQueryVariables = Exact<{
  programId: Scalars['ID'];
  classPage: Scalars['Boolean'];
}>;

export type ProgramAndProgramUnitsQuery = {
  __typename?: 'Query';
  program: {
    __typename?: 'Program';
    id: any;
    pk: string;
    name: string;
    description: string;
    progress: number;
    videoUrl?: string | null;
    newMenu: boolean;
    thumbnails?: any | null;
    image: { __typename?: 'DjangoImageType'; name: string };
    guides: Array<{
      __typename?: 'Guide';
      id: any;
      name: string;
      pdfUrl?: string | null;
      mediaType: string;
      youtubeUrl?: string | null;
      preziUrl?: string | null;
      driveUrl?: string | null;
      fileUrl?: string | null;
      videoUrl?: string | null;
    }>;
    programUnits: Array<{
      __typename?: 'Unit';
      id: any;
      progress: number;
      name: string;
      description: string;
      thumbnails?: any | null;
      isPublished: boolean;
      color: string;
      modules: Array<{
        __typename?: 'Module';
        id: any;
        name: string;
        contents: Array<{ __typename?: 'Content'; id: any; name: string }>;
      }>;
      image: { __typename?: 'DjangoImageType'; name: string };
    }>;
  };
};

export type ProgramStudyGroupsQueryVariables = Exact<{
  programIdStr: Scalars['String'];
}>;

export type ProgramStudyGroupsQuery = {
  __typename?: 'Query';
  studyGroups: Array<{
    __typename?: 'StudyGroup';
    id: any;
    name: string;
    schoolName: string;
    trackChoice?: string | null;
    trackAssignments?: Array<string> | null;
    tracks: Array<{
      __typename?: 'Track';
      id: any;
      name: string;
      tags: Array<string>;
    }>;
  }>;
};

export type ProgramStudyGroupQueryVariables = Exact<{
  programIdStr: Scalars['String'];
  studyGroupId: Scalars['String'];
}>;

export type ProgramStudyGroupQuery = {
  __typename?: 'Query';
  studyGroups: Array<{
    __typename?: 'StudyGroup';
    id: any;
    name: string;
    schoolName: string;
    trackChoice?: string | null;
    trackAssignments?: Array<string> | null;
  }>;
};

export type TrackQueryVariables = Exact<{
  trackId: Scalars['ID'];
  classPage: Scalars['Boolean'];
}>;

export type TrackQuery = {
  __typename?: 'Query';
  track: {
    __typename?: 'Track';
    id: any;
    name: string;
    progress?: number | null;
    conditionEnabled: boolean;
    conditionShown: boolean;
    trackGuides: Array<{
      __typename?: 'TrackGuide';
      id: any;
      guide: {
        __typename?: 'Guide';
        id: any;
        name: string;
        pdfUrl?: string | null;
        mediaType: string;
        youtubeUrl?: string | null;
        preziUrl?: string | null;
        driveUrl?: string | null;
        fileUrl?: string | null;
        videoUrl?: string | null;
      };
    }>;
    trackUnits: Array<{
      __typename?: 'TrackUnit';
      id: any;
      progress?: number | null;
      canBeShared?: number | null;
      conditionEnabled: boolean;
      conditionShown: boolean;
      unit: {
        __typename?: 'Unit';
        id: any;
        name: string;
        isDemo: boolean;
        isPublished: boolean;
        description: string;
        thumbnails?: any | null;
        color: string;
        image: { __typename?: 'DjangoImageType'; name: string };
      };
      trackModules?: Array<{
        __typename?: 'TrackModule';
        id: any;
        conditionEnabled: boolean;
        conditionShown: boolean;
        module: { __typename?: 'Module'; id: any; name: string };
        trackContents: Array<{
          __typename?: 'TrackContent';
          id: any;
          conditionEnabled: boolean;
          conditionShown: boolean;
          content: {
            __typename?: 'Content';
            id: any;
            name: string;
            mediaType: string;
            isShareable: boolean;
            isDownloadable: boolean;
            isDemo: boolean;
            fileUrl?: string | null;
          };
          forwardContent?: {
            __typename?: 'Content';
            id: any;
            name: string;
            mediaType: string;
            isShareable: boolean;
            isDownloadable: boolean;
            isDemo: boolean;
            fileUrl?: string | null;
          } | null;
        }>;
      }>;
    }>;
  };
};

export type TrackProgressQueryVariables = Exact<{
  trackId: Scalars['ID'];
  trackIdString: Scalars['String'];
}>;

export type TrackProgressQuery = {
  __typename?: 'Query';
  track: { __typename?: 'Track'; id: any; progress?: number | null };
  trackUnits: Array<{
    __typename?: 'TrackUnit';
    id: any;
    progress?: number | null;
    canBeShared?: number | null;
  }>;
};

export type CompleteChalkupMutationVariables = Exact<{
  contentId: Scalars['String'];
  studyGroupId?: InputMaybe<Scalars['String']>;
}>;

export type CompleteChalkupMutation = {
  __typename?: 'Mutation';
  completeContent: { __typename?: 'ChalkUp'; id: any; contentId: string };
};

export type CompleteShareMutationVariables = Exact<{
  contentId: Scalars['String'];
  studyGroupId: Scalars['String'];
}>;

export type CompleteShareMutation = {
  __typename?: 'Mutation';
  shareContent: { __typename?: 'Share'; id: any; contentId: string };
};

export type CompletePinningMutationVariables = Exact<{
  contentId: Scalars['String'];
  studyGroupId: Scalars['String'];
}>;

export type CompletePinningMutation = {
  __typename?: 'Mutation';
  pinContent: { __typename?: 'Pinning'; id: any; contentId: string };
};

export type UnChalkUpMutationVariables = Exact<{
  chalkUpId: Scalars['String'];
}>;

export type UnChalkUpMutation = {
  __typename?: 'Mutation';
  deleteChalkUps: Array<{ __typename?: 'ChalkUp'; id: any }>;
};

export type UnShareMutationVariables = Exact<{
  shareId: Scalars['String'];
}>;

export type UnShareMutation = {
  __typename?: 'Mutation';
  deleteShares: Array<{ __typename?: 'Share'; id: any }>;
};

export type UnPinMutationVariables = Exact<{
  pinId: Scalars['String'];
}>;

export type UnPinMutation = {
  __typename?: 'Mutation';
  deletePinnings: Array<{ __typename?: 'Pinning'; id: any }>;
};

export type ChooseTrackMutationVariables = Exact<{
  trackId: Scalars['String'];
  studyGroupId: Scalars['String'];
}>;

export type ChooseTrackMutation = {
  __typename?: 'Mutation';
  chooseTrack: {
    __typename?: 'TrackUserChoice';
    id: any;
    track: { __typename?: 'Track'; id: any };
    studyGroup: { __typename?: 'StudyGroup'; id: any };
  };
};

export type StudentsTrackAssignemntsQueryVariables = Exact<{
  studyGroupId: Scalars['String'];
}>;

export type StudentsTrackAssignemntsQuery = {
  __typename?: 'Query';
  trackTeacherAssignments: Array<{
    __typename?: 'TrackTeacherAssignment';
    id: any;
    track: { __typename?: 'Track'; id: any };
    user: { __typename?: 'User'; id: any };
  }>;
};

export type AssignTrackToStudentMutationVariables = Exact<{
  data: AssignTrackToStudentInput;
}>;

export type AssignTrackToStudentMutation = {
  __typename?: 'Mutation';
  assignTrackToStudent: {
    __typename?: 'TrackTeacherAssignment';
    id: any;
    track: { __typename?: 'Track'; id: any };
    user: { __typename?: 'User'; id: any };
  };
};

export type DeleteTrackAssignmentMutationVariables = Exact<{
  trackAssignmentId: Scalars['String'];
}>;

export type DeleteTrackAssignmentMutation = {
  __typename?: 'Mutation';
  deleteTrackTeacherAssignments: Array<{
    __typename?: 'TrackTeacherAssignment';
    id: any;
  }>;
};

export type CanBeSharedQueryVariables = Exact<{
  trackUnitId: Scalars['ID'];
}>;

export type CanBeSharedQuery = {
  __typename?: 'Query';
  trackUnit: { __typename?: 'TrackUnit'; id: any; canBeShared?: number | null };
};

export type UserChalkupsWithoutClassQueryVariables = Exact<{
  userId: Scalars['String'];
}>;

export type UserChalkupsWithoutClassQuery = {
  __typename?: 'Query';
  chalkUps: Array<{ __typename?: 'ChalkUp'; id: any; contentId: string }>;
};

export type DashboardQueryQueryVariables = Exact<{
  userId: Scalars['String'];
  loadPinnings: Scalars['Boolean'];
  limit: Scalars['Int'];
  offset?: Scalars['Int'];
  customFilters?: InputMaybe<StudyGroupFilter>;
}>;

export type DashboardQueryQuery = {
  __typename?: 'Query';
  studyGroups: Array<{
    __typename?: 'StudyGroup';
    id: any;
    name: string;
    isSelfLearning: boolean;
    isExplore: boolean;
    isChallenge: boolean;
    license: {
      __typename?: 'License';
      school: { __typename?: 'School'; id: any; name: string };
      period: { __typename?: 'Period'; id: any; name: string; lastDate: any };
      program: {
        __typename?: 'Program';
        id: any;
        name: string;
        thumbnails?: any | null;
        description: string;
        image: { __typename?: 'DjangoImageType'; name: string };
      };
    };
  }>;
  pinnings?: Array<{
    __typename?: 'Pinning';
    id: any;
    content: {
      __typename?: 'Content';
      id: any;
      name: string;
      mediaType: string;
    };
    studyGroup: {
      __typename?: 'StudyGroup';
      id: any;
      program: { __typename?: 'Program'; id: any };
    };
  }>;
};

export type DashboardGlobalProgramsQueryVariables = Exact<{
  enrolledOrTeacher: Scalars['Boolean'];
}>;

export type DashboardGlobalProgramsQuery = {
  __typename?: 'Query';
  globalStudyGroups: Array<{
    __typename?: 'StudyGroup';
    id: any;
    name: string;
    license: {
      __typename?: 'License';
      school: { __typename?: 'School'; id: any; name: string };
      program: {
        __typename?: 'Program';
        id: any;
        name: string;
        thumbnails?: any | null;
        description: string;
        image: { __typename?: 'DjangoImageType'; name: string };
      };
    };
  }>;
};

export type DashboardExploreStudyGroupsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type DashboardExploreStudyGroupsQuery = {
  __typename?: 'Query';
  exploreStudyGroups: Array<{
    __typename?: 'StudyGroup';
    id: any;
    name: string;
    isExplore: boolean;
    isSelfLearning: boolean;
    isChallenge: boolean;
    license: {
      __typename?: 'License';
      school: { __typename?: 'School'; id: any; name: string };
      program: {
        __typename?: 'Program';
        id: any;
        name: string;
        thumbnails?: any | null;
        description: string;
        image: { __typename?: 'DjangoImageType'; name: string };
        programUnits: Array<{
          __typename?: 'Unit';
          id: any;
          name: string;
          description: string;
          thumbnails?: any | null;
          modules: Array<{
            __typename?: 'Module';
            id: any;
            name: string;
            contents: Array<{ __typename?: 'Content'; id: any; name: string }>;
          }>;
        }>;
      };
    };
  }>;
};

export type ChallengeSchoolsQueryVariables = Exact<{ [key: string]: never }>;

export type ChallengeSchoolsQuery = {
  __typename?: 'Query';
  challengeSchools: Array<{ __typename?: 'School'; id: any; name: string }>;
};

export type AvailableChallengeStudyGroupQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AvailableChallengeStudyGroupQuery = {
  __typename?: 'Query';
  availableChallengeStudyGroup?: {
    __typename?: 'StudyGroup';
    pk: string;
    name: string;
    inviteCode: string;
    license: {
      __typename?: 'License';
      school: { __typename?: 'School'; name: string };
    };
  } | null;
};

export type ChallengeProgramsQueryVariables = Exact<{ [key: string]: never }>;

export type ChallengeProgramsQuery = {
  __typename?: 'Query';
  programs: Array<{
    __typename?: 'Program';
    name: string;
    id: any;
    isChallenge: boolean;
    description: string;
    namespaces: Array<string>;
  }>;
};

export type PublicProgramsQueryVariables = Exact<{ [key: string]: never }>;

export type PublicProgramsQuery = {
  __typename?: 'Query';
  programs: Array<{
    __typename?: 'Program';
    name: string;
    id: any;
    isChallenge: boolean;
    isPublic: boolean;
    description: string;
    namespaces: Array<string>;
    thumbnails?: any | null;
  }>;
};

export type PublicUnitsQueryVariables = Exact<{ [key: string]: never }>;

export type PublicUnitsQuery = {
  __typename?: 'Query';
  units: Array<{
    __typename?: 'Unit';
    name: string;
    id: any;
    description: string;
    thumbnails?: any | null;
    color: string;
    isPublished: boolean;
  }>;
};

export type TeacherTrainingProgramsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TeacherTrainingProgramsQuery = {
  __typename?: 'Query';
  programs: Array<{
    __typename?: 'Program';
    name: string;
    id: any;
    isChallenge: boolean;
    isTeacherTraining: boolean;
    description: string;
    namespaces: Array<string>;
  }>;
};

export type LeaderboardDataQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type LeaderboardDataQueryQuery = {
  __typename?: 'Query';
  challengePoints: any;
};

export type DashboardChallengeStudyGroupsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type DashboardChallengeStudyGroupsQuery = {
  __typename?: 'Query';
  challengeStudyGroups: Array<{
    __typename?: 'StudyGroup';
    id: any;
    name: string;
    isExplore: boolean;
    isSelfLearning: boolean;
    isChallenge: boolean;
    license: {
      __typename?: 'License';
      school: { __typename?: 'School'; id: any; name: string };
      program: {
        __typename?: 'Program';
        id: any;
        name: string;
        thumbnails?: any | null;
        description: string;
        image: { __typename?: 'DjangoImageType'; name: string };
        programUnits: Array<{
          __typename?: 'Unit';
          id: any;
          name: string;
          description: string;
          thumbnails?: any | null;
          modules: Array<{
            __typename?: 'Module';
            id: any;
            name: string;
            contents: Array<{ __typename?: 'Content'; id: any; name: string }>;
          }>;
        }>;
      };
    };
  }>;
};

export type ArticlesQueryVariables = Exact<{ [key: string]: never }>;

export type ArticlesQuery = {
  __typename?: 'Query';
  articles: Array<{
    __typename?: 'Article';
    id: any;
    pk: string;
    name: string;
    type: string;
    namespace: string;
  }>;
};

export type EventsQueryVariables = Exact<{ [key: string]: never }>;

export type EventsQuery = {
  __typename?: 'Query';
  events: Array<{
    __typename?: 'Event';
    id: any;
    title: string;
    description: string;
    endDatetime?: any | null;
    link: string;
    namespace: string;
    startDatetime?: any | null;
    image: { __typename?: 'DjangoImageType'; name: string; url: string };
  }>;
};

export type GetMeWithInfobipQueryVariables = Exact<{ [key: string]: never }>;

export type GetMeWithInfobipQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: any;
    infobipDirect?: {
      __typename?: 'InfobipUserProxy';
      id: number;
      infobipState: string;
      infobipUsername: string;
      infobipPassword?: string | null;
    } | null;
  };
};

export type GetJsonCmsContentQueryVariables = Exact<{
  contentPk?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
}>;

export type GetJsonCmsContentQuery = {
  __typename?: 'Query';
  getJsonCmsContent: {
    __typename?: 'JsonContent';
    count: number;
    currentPage: number;
    isPresentation: boolean;
    totalPages: number;
    results: Array<{
      __typename?: 'JsonContentResult';
      id: any;
      plugin: string;
      data: any;
      children: Array<any>;
    }>;
  };
};

export type GetProgramInfoQueryVariables = Exact<{
  programInfoPk: Scalars['ID'];
}>;

export type GetProgramInfoQuery = {
  __typename?: 'Query';
  programInfo: {
    __typename?: 'ProgramInfo';
    technologiesUsedInTheProgram?: string | null;
    name: string;
    id: any;
    description: string;
    shortDescription: string;
    tags: string;
    slug?: string | null;
    technicalSkills: string;
    professionalCompetences: string;
    minGrade: number;
    maxGrade: number;
    minHours?: number | null;
    maxHours?: number | null;
    programUnitsDescription?: string | null;
    programRank: string;
    techFields: string;
    knowledgePrerequisites?: string | null;
    teacherExperience?: string | null;
    standardsAlignment?: string | null;
    demo?: string | null;
    videoUrl?: string | null;
    scopeAndSequence?: {
      __typename?: 'DjangoFileType';
      url: string;
      name: string;
    } | null;
    tracks?: Array<{
      __typename?: 'Track';
      estimatedDuration: number;
      tags: Array<string>;
      name: string;
      trackUnits: Array<{
        __typename?: 'TrackUnit';
        id: any;
        trackModules: Array<{
          __typename?: 'TrackModule';
          id: any;
          module: { __typename?: 'Module'; id: any; name: string };
        }>;
        unit: {
          __typename?: 'Unit';
          id: any;
          name: string;
          programInfoDescription: string;
        };
      }>;
    }> | null;
    organization?: {
      __typename?: 'Organization';
      name: string;
      url: string;
      id: any;
      image?: {
        __typename?: 'DjangoImageType';
        height: number;
        name: string;
        size: number;
        url: string;
        width: number;
      } | null;
    } | null;
    partners?: Array<{
      __typename?: 'Organization';
      id: any;
      name: string;
      url: string;
      image?: {
        __typename?: 'DjangoImageType';
        height: number;
        name: string;
        size: number;
        url: string;
        width: number;
      } | null;
    }> | null;
    image?: {
      __typename?: 'DjangoImageType';
      height: number;
      name: string;
      size: number;
      url: string;
      width: number;
    } | null;
  };
};

export type GetAllProgramInfoQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllProgramInfoQuery = {
  __typename?: 'Query';
  programInfos: Array<{
    __typename?: 'ProgramInfo';
    technologiesUsedInTheProgram?: string | null;
    name: string;
    id: any;
    slug?: string | null;
    technicalSkills: string;
    professionalCompetences: string;
    minGrade: number;
    maxGrade: number;
    shortDescription: string;
    tags: string;
    programRank: string;
    techFields: string;
    image?: {
      __typename?: 'DjangoImageType';
      height: number;
      name: string;
      size: number;
      url: string;
      width: number;
    } | null;
    organization?: {
      __typename?: 'Organization';
      name: string;
      url: string;
      id: any;
      image?: {
        __typename?: 'DjangoImageType';
        height: number;
        name: string;
        size: number;
        url: string;
        width: number;
      } | null;
    } | null;
  }>;
};

export type MarketPlaceEmailEnterMutationVariables = Exact<{
  data: LeadUserInput;
}>;

export type MarketPlaceEmailEnterMutation = {
  __typename?: 'Mutation';
  appendDataToLeadUser: { __typename?: 'LeadUser'; data: any; email: string };
};

export type ConversationQueryQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  conversationId?: InputMaybe<Scalars['String']>;
  studyGroupId?: InputMaybe<Scalars['String']>;
  gptBlockId?: InputMaybe<Scalars['String']>;
}>;

export type ConversationQueryQuery = {
  __typename?: 'Query';
  conversations: Array<{
    __typename?: 'Conversation';
    name: string;
    id: any;
    gptBlockUniqueId?: any | null;
    limit: number;
    notDisplayedMessageLen: number;
    hasInappropriateMsg: boolean;
    createdAt?: any | null;
    lastMessage?: {
      __typename?: 'ConversationMessage';
      id: any;
      text: string;
      isGenerated: boolean;
      createdAt?: any | null;
    } | null;
    user: { __typename?: 'User'; id: any };
    assistant?: {
      __typename?: 'Assistant';
      id: any;
      introMessages: any;
      name: string;
      namespaces?: string | null;
      image?: {
        __typename?: 'DjangoImageType';
        height: number;
        name: string;
        path: string;
        size: number;
        url: string;
        width: number;
      } | null;
    } | null;
  }>;
};

export type GetConversationMessagesQueryVariables = Exact<{
  conversationId: Scalars['String'];
}>;

export type GetConversationMessagesQuery = {
  __typename?: 'Query';
  messages: Array<{
    __typename?: 'ConversationMessage';
    id: any;
    text: string;
    isGenerated: boolean;
    createdAt?: any | null;
    flags: Array<{
      __typename?: 'ConversationMessageFlag';
      type: string;
      createdById?: string | null;
      createdAt?: any | null;
    }>;
  }>;
};

export type GetHistoryForSearchQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  conversationId?: InputMaybe<Scalars['String']>;
  studyGroupId?: InputMaybe<Scalars['String']>;
  gptBlockId?: InputMaybe<Scalars['String']>;
}>;

export type GetHistoryForSearchQuery = {
  __typename?: 'Query';
  conversations: Array<{
    __typename?: 'Conversation';
    id: any;
    history: Array<{
      __typename?: 'ConversationMessage';
      id: any;
      text: string;
      isGenerated: boolean;
      createdAt?: any | null;
    }>;
    assistant?: {
      __typename?: 'Assistant';
      id: any;
      introMessages: any;
      name: string;
      namespaces?: string | null;
      image?: {
        __typename?: 'DjangoImageType';
        height: number;
        name: string;
        path: string;
        size: number;
        url: string;
        width: number;
      } | null;
    } | null;
  }>;
};

export type SendConversationMessageMutationVariables = Exact<{
  data: ConversationInput;
}>;

export type SendConversationMessageMutation = {
  __typename?: 'Mutation';
  getConversationResponse: { __typename?: 'Conversation'; id: any };
};

export type CreateConversationFromBlockMutationVariables = Exact<{
  data: ConversationBlockInput;
}>;

export type CreateConversationFromBlockMutation = {
  __typename?: 'Mutation';
  createConversationFromBlock: { __typename?: 'Conversation'; id: any };
};

export type ResetConversationFromBlockIdMutationVariables = Exact<{
  conversationId: Scalars['String'];
  blockId: Scalars['String'];
}>;

export type ResetConversationFromBlockIdMutation = {
  __typename?: 'Mutation';
  resetConversation: { __typename?: 'Conversation'; id: any };
};

export type MarkMessageWithFlagMutationVariables = Exact<{
  type: Scalars['String'];
  messageId: Scalars['String'];
}>;

export type MarkMessageWithFlagMutation = {
  __typename?: 'Mutation';
  markMessageWithFlag: { __typename?: 'ConversationMessageFlag'; id: any };
};

export type AssistantsQueryQueryVariables = Exact<{ [key: string]: never }>;

export type AssistantsQueryQuery = {
  __typename?: 'Query';
  assistants: Array<{
    __typename?: 'Assistant';
    id: any;
    infobipId?: string | null;
    introMessages: any;
    name: string;
    namespaces?: string | null;
    image?: {
      __typename?: 'DjangoImageType';
      height: number;
      name: string;
      path: string;
      size: number;
      url: string;
      width: number;
    } | null;
  }>;
};

export const ClassPageUnitFragmentFragmentDoc = gql`
  fragment ClassPageUnitFragment on Unit {
    isPublished
    description
    image {
      name
    }
    thumbnails
    color
  }
`;
export const GetLastChangelogQueryDocument = gql`
  query GetLastChangelogQuery {
    getLastChangelog {
      id
      title
      seen
      log
      startDate
      endDate
    }
  }
`;

/**
 * __useGetLastChangelogQueryQuery__
 *
 * To run a query within a React component, call `useGetLastChangelogQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastChangelogQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastChangelogQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLastChangelogQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLastChangelogQueryQuery,
    GetLastChangelogQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLastChangelogQueryQuery,
    GetLastChangelogQueryQueryVariables
  >(GetLastChangelogQueryDocument, options);
}
export function useGetLastChangelogQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLastChangelogQueryQuery,
    GetLastChangelogQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLastChangelogQueryQuery,
    GetLastChangelogQueryQueryVariables
  >(GetLastChangelogQueryDocument, options);
}
export type GetLastChangelogQueryQueryHookResult = ReturnType<
  typeof useGetLastChangelogQueryQuery
>;
export type GetLastChangelogQueryLazyQueryHookResult = ReturnType<
  typeof useGetLastChangelogQueryLazyQuery
>;
export type GetLastChangelogQueryQueryResult = Apollo.QueryResult<
  GetLastChangelogQueryQuery,
  GetLastChangelogQueryQueryVariables
>;
export const SeeChangelogDocument = gql`
  mutation SeeChangelog($data: SeeChangelogInput!) {
    seeChangelog(data: $data)
  }
`;
export type SeeChangelogMutationFn = Apollo.MutationFunction<
  SeeChangelogMutation,
  SeeChangelogMutationVariables
>;

/**
 * __useSeeChangelogMutation__
 *
 * To run a mutation, you first call `useSeeChangelogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeeChangelogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seeChangelogMutation, { data, loading, error }] = useSeeChangelogMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSeeChangelogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SeeChangelogMutation,
    SeeChangelogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SeeChangelogMutation,
    SeeChangelogMutationVariables
  >(SeeChangelogDocument, options);
}
export type SeeChangelogMutationHookResult = ReturnType<
  typeof useSeeChangelogMutation
>;
export type SeeChangelogMutationResult =
  Apollo.MutationResult<SeeChangelogMutation>;
export type SeeChangelogMutationOptions = Apollo.BaseMutationOptions<
  SeeChangelogMutation,
  SeeChangelogMutationVariables
>;
export const GetUserAssistantsDocument = gql`
  query GetUserAssistants {
    userAssistants {
      id
      customInstructions
      initialMessage
      name
      isShared
      vector {
        id
        files {
          id
          file {
            name
          }
          createdAt
        }
      }
    }
  }
`;

/**
 * __useGetUserAssistantsQuery__
 *
 * To run a query within a React component, call `useGetUserAssistantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAssistantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAssistantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAssistantsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserAssistantsQuery,
    GetUserAssistantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserAssistantsQuery,
    GetUserAssistantsQueryVariables
  >(GetUserAssistantsDocument, options);
}
export function useGetUserAssistantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserAssistantsQuery,
    GetUserAssistantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserAssistantsQuery,
    GetUserAssistantsQueryVariables
  >(GetUserAssistantsDocument, options);
}
export type GetUserAssistantsQueryHookResult = ReturnType<
  typeof useGetUserAssistantsQuery
>;
export type GetUserAssistantsLazyQueryHookResult = ReturnType<
  typeof useGetUserAssistantsLazyQuery
>;
export type GetUserAssistantsQueryResult = Apollo.QueryResult<
  GetUserAssistantsQuery,
  GetUserAssistantsQueryVariables
>;
export const ToggleAssistantShareDocument = gql`
  mutation ToggleAssistantShare($assistantId: UUID!) {
    toggleAssistantShare(data: { id: $assistantId }) {
      id
      isShared
    }
  }
`;
export type ToggleAssistantShareMutationFn = Apollo.MutationFunction<
  ToggleAssistantShareMutation,
  ToggleAssistantShareMutationVariables
>;

/**
 * __useToggleAssistantShareMutation__
 *
 * To run a mutation, you first call `useToggleAssistantShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAssistantShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAssistantShareMutation, { data, loading, error }] = useToggleAssistantShareMutation({
 *   variables: {
 *      assistantId: // value for 'assistantId'
 *   },
 * });
 */
export function useToggleAssistantShareMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleAssistantShareMutation,
    ToggleAssistantShareMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleAssistantShareMutation,
    ToggleAssistantShareMutationVariables
  >(ToggleAssistantShareDocument, options);
}
export type ToggleAssistantShareMutationHookResult = ReturnType<
  typeof useToggleAssistantShareMutation
>;
export type ToggleAssistantShareMutationResult =
  Apollo.MutationResult<ToggleAssistantShareMutation>;
export type ToggleAssistantShareMutationOptions = Apollo.BaseMutationOptions<
  ToggleAssistantShareMutation,
  ToggleAssistantShareMutationVariables
>;
export const GetAiAssistantsDocument = gql`
  query GetAiAssistants {
    aiAssistants {
      id
      name
      imageUrl
      namespaces
      type
      newMessages {
        content
        createdAt
        id
        inappropriate
        offtopic
        suggestion
        role
        thread {
          id
        }
      }
    }
  }
`;

/**
 * __useGetAiAssistantsQuery__
 *
 * To run a query within a React component, call `useGetAiAssistantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiAssistantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiAssistantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiAssistantsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAiAssistantsQuery,
    GetAiAssistantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAiAssistantsQuery, GetAiAssistantsQueryVariables>(
    GetAiAssistantsDocument,
    options,
  );
}
export function useGetAiAssistantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAiAssistantsQuery,
    GetAiAssistantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAiAssistantsQuery,
    GetAiAssistantsQueryVariables
  >(GetAiAssistantsDocument, options);
}
export type GetAiAssistantsQueryHookResult = ReturnType<
  typeof useGetAiAssistantsQuery
>;
export type GetAiAssistantsLazyQueryHookResult = ReturnType<
  typeof useGetAiAssistantsLazyQuery
>;
export type GetAiAssistantsQueryResult = Apollo.QueryResult<
  GetAiAssistantsQuery,
  GetAiAssistantsQueryVariables
>;
export const GetThreadsByAssistantDocument = gql`
  query GetThreadsByAssistant($assistantId: String!, $userId: String!) {
    threads(filters: { assistant: $assistantId, user: { id: $userId } }) {
      id
      block
      newMessages
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetThreadsByAssistantQuery__
 *
 * To run a query within a React component, call `useGetThreadsByAssistantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadsByAssistantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadsByAssistantQuery({
 *   variables: {
 *      assistantId: // value for 'assistantId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetThreadsByAssistantQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetThreadsByAssistantQuery,
    GetThreadsByAssistantQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetThreadsByAssistantQuery,
    GetThreadsByAssistantQueryVariables
  >(GetThreadsByAssistantDocument, options);
}
export function useGetThreadsByAssistantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetThreadsByAssistantQuery,
    GetThreadsByAssistantQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetThreadsByAssistantQuery,
    GetThreadsByAssistantQueryVariables
  >(GetThreadsByAssistantDocument, options);
}
export type GetThreadsByAssistantQueryHookResult = ReturnType<
  typeof useGetThreadsByAssistantQuery
>;
export type GetThreadsByAssistantLazyQueryHookResult = ReturnType<
  typeof useGetThreadsByAssistantLazyQuery
>;
export type GetThreadsByAssistantQueryResult = Apollo.QueryResult<
  GetThreadsByAssistantQuery,
  GetThreadsByAssistantQueryVariables
>;
export const GetThreadsByAssistantWithMessagesDocument = gql`
  query GetThreadsByAssistantWithMessages(
    $assistantId: String!
    $userId: String!
  ) {
    threads(filters: { assistant: $assistantId, user: { id: $userId } }) {
      id
      block
      newMessages
      createdAt
      updatedAt
      messages {
        content
        createdAt
        id
        inappropriate
        offtopic
      }
    }
  }
`;

/**
 * __useGetThreadsByAssistantWithMessagesQuery__
 *
 * To run a query within a React component, call `useGetThreadsByAssistantWithMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadsByAssistantWithMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadsByAssistantWithMessagesQuery({
 *   variables: {
 *      assistantId: // value for 'assistantId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetThreadsByAssistantWithMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetThreadsByAssistantWithMessagesQuery,
    GetThreadsByAssistantWithMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetThreadsByAssistantWithMessagesQuery,
    GetThreadsByAssistantWithMessagesQueryVariables
  >(GetThreadsByAssistantWithMessagesDocument, options);
}
export function useGetThreadsByAssistantWithMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetThreadsByAssistantWithMessagesQuery,
    GetThreadsByAssistantWithMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetThreadsByAssistantWithMessagesQuery,
    GetThreadsByAssistantWithMessagesQueryVariables
  >(GetThreadsByAssistantWithMessagesDocument, options);
}
export type GetThreadsByAssistantWithMessagesQueryHookResult = ReturnType<
  typeof useGetThreadsByAssistantWithMessagesQuery
>;
export type GetThreadsByAssistantWithMessagesLazyQueryHookResult = ReturnType<
  typeof useGetThreadsByAssistantWithMessagesLazyQuery
>;
export type GetThreadsByAssistantWithMessagesQueryResult = Apollo.QueryResult<
  GetThreadsByAssistantWithMessagesQuery,
  GetThreadsByAssistantWithMessagesQueryVariables
>;
export const CreateThreadDocument = gql`
  mutation CreateThread($assistantId: String!, $blockId: String) {
    createThread(data: { assistantId: $assistantId, block: $blockId }) {
      id
    }
  }
`;
export type CreateThreadMutationFn = Apollo.MutationFunction<
  CreateThreadMutation,
  CreateThreadMutationVariables
>;

/**
 * __useCreateThreadMutation__
 *
 * To run a mutation, you first call `useCreateThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThreadMutation, { data, loading, error }] = useCreateThreadMutation({
 *   variables: {
 *      assistantId: // value for 'assistantId'
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useCreateThreadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateThreadMutation,
    CreateThreadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateThreadMutation,
    CreateThreadMutationVariables
  >(CreateThreadDocument, options);
}
export type CreateThreadMutationHookResult = ReturnType<
  typeof useCreateThreadMutation
>;
export type CreateThreadMutationResult =
  Apollo.MutationResult<CreateThreadMutation>;
export type CreateThreadMutationOptions = Apollo.BaseMutationOptions<
  CreateThreadMutation,
  CreateThreadMutationVariables
>;
export const CreateUserAssistantDocument = gql`
  mutation CreateUserAssistant($name: String!) {
    createAssistant(data: { name: $name }) {
      customInstructions
      id
      initialMessage
      name
    }
  }
`;
export type CreateUserAssistantMutationFn = Apollo.MutationFunction<
  CreateUserAssistantMutation,
  CreateUserAssistantMutationVariables
>;

/**
 * __useCreateUserAssistantMutation__
 *
 * To run a mutation, you first call `useCreateUserAssistantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAssistantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserAssistantMutation, { data, loading, error }] = useCreateUserAssistantMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateUserAssistantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserAssistantMutation,
    CreateUserAssistantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateUserAssistantMutation,
    CreateUserAssistantMutationVariables
  >(CreateUserAssistantDocument, options);
}
export type CreateUserAssistantMutationHookResult = ReturnType<
  typeof useCreateUserAssistantMutation
>;
export type CreateUserAssistantMutationResult =
  Apollo.MutationResult<CreateUserAssistantMutation>;
export type CreateUserAssistantMutationOptions = Apollo.BaseMutationOptions<
  CreateUserAssistantMutation,
  CreateUserAssistantMutationVariables
>;
export const UpdateUserAssitantDocument = gql`
  mutation UpdateUserAssitant(
    $assistantId: String!
    $name: String!
    $customInstructions: String!
    $initialMessage: String!
    $file: String
  ) {
    updateAssistant(
      data: {
        id: $assistantId
        name: $name
        customInstructions: $customInstructions
        initialMessage: $initialMessage
        file: $file
      }
    ) {
      id
      customInstructions
      initialMessage
      name
    }
  }
`;
export type UpdateUserAssitantMutationFn = Apollo.MutationFunction<
  UpdateUserAssitantMutation,
  UpdateUserAssitantMutationVariables
>;

/**
 * __useUpdateUserAssitantMutation__
 *
 * To run a mutation, you first call `useUpdateUserAssitantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAssitantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAssitantMutation, { data, loading, error }] = useUpdateUserAssitantMutation({
 *   variables: {
 *      assistantId: // value for 'assistantId'
 *      name: // value for 'name'
 *      customInstructions: // value for 'customInstructions'
 *      initialMessage: // value for 'initialMessage'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateUserAssitantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserAssitantMutation,
    UpdateUserAssitantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserAssitantMutation,
    UpdateUserAssitantMutationVariables
  >(UpdateUserAssitantDocument, options);
}
export type UpdateUserAssitantMutationHookResult = ReturnType<
  typeof useUpdateUserAssitantMutation
>;
export type UpdateUserAssitantMutationResult =
  Apollo.MutationResult<UpdateUserAssitantMutation>;
export type UpdateUserAssitantMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserAssitantMutation,
  UpdateUserAssitantMutationVariables
>;
export const GetThreadDocument = gql`
  query GetThread($threadId: String!) {
    thread(id: $threadId) {
      id
      newMessages
      createdAt
      updatedAt
      messages {
        content
        createdAt
        id
        inappropriate
        offtopic
        suggestion
        role
      }
    }
  }
`;

/**
 * __useGetThreadQuery__
 *
 * To run a query within a React component, call `useGetThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadQuery({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useGetThreadQuery(
  baseOptions: Apollo.QueryHookOptions<GetThreadQuery, GetThreadQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetThreadQuery, GetThreadQueryVariables>(
    GetThreadDocument,
    options,
  );
}
export function useGetThreadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetThreadQuery,
    GetThreadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetThreadQuery, GetThreadQueryVariables>(
    GetThreadDocument,
    options,
  );
}
export type GetThreadQueryHookResult = ReturnType<typeof useGetThreadQuery>;
export type GetThreadLazyQueryHookResult = ReturnType<
  typeof useGetThreadLazyQuery
>;
export type GetThreadQueryResult = Apollo.QueryResult<
  GetThreadQuery,
  GetThreadQueryVariables
>;
export const CreateMessageDocument = gql`
  mutation CreateMessage($threadId: String!, $content: String!) {
    createMessage(data: { threadId: $threadId, content: $content }) {
      id
      messages {
        content
        createdAt
        id
        inappropriate
        offtopic
        suggestion
        role
      }
    }
  }
`;
export type CreateMessageMutationFn = Apollo.MutationFunction<
  CreateMessageMutation,
  CreateMessageMutationVariables
>;

/**
 * __useCreateMessageMutation__
 *
 * To run a mutation, you first call `useCreateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageMutation, { data, loading, error }] = useCreateMessageMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMessageMutation,
    CreateMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMessageMutation,
    CreateMessageMutationVariables
  >(CreateMessageDocument, options);
}
export type CreateMessageMutationHookResult = ReturnType<
  typeof useCreateMessageMutation
>;
export type CreateMessageMutationResult =
  Apollo.MutationResult<CreateMessageMutation>;
export type CreateMessageMutationOptions = Apollo.BaseMutationOptions<
  CreateMessageMutation,
  CreateMessageMutationVariables
>;
export const CreateTriggerFromBlockDocument = gql`
  mutation CreateTriggerFromBlock($id: Int!) {
    createTriggerFromBlock(id: $id)
  }
`;
export type CreateTriggerFromBlockMutationFn = Apollo.MutationFunction<
  CreateTriggerFromBlockMutation,
  CreateTriggerFromBlockMutationVariables
>;

/**
 * __useCreateTriggerFromBlockMutation__
 *
 * To run a mutation, you first call `useCreateTriggerFromBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTriggerFromBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTriggerFromBlockMutation, { data, loading, error }] = useCreateTriggerFromBlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateTriggerFromBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTriggerFromBlockMutation,
    CreateTriggerFromBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTriggerFromBlockMutation,
    CreateTriggerFromBlockMutationVariables
  >(CreateTriggerFromBlockDocument, options);
}
export type CreateTriggerFromBlockMutationHookResult = ReturnType<
  typeof useCreateTriggerFromBlockMutation
>;
export type CreateTriggerFromBlockMutationResult =
  Apollo.MutationResult<CreateTriggerFromBlockMutation>;
export type CreateTriggerFromBlockMutationOptions = Apollo.BaseMutationOptions<
  CreateTriggerFromBlockMutation,
  CreateTriggerFromBlockMutationVariables
>;
export const GetUserFilesDocument = gql`
  query GetUserFiles {
    userFiles {
      file {
        name
      }
      vectorIds
      id
    }
  }
`;

/**
 * __useGetUserFilesQuery__
 *
 * To run a query within a React component, call `useGetUserFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserFilesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserFilesQuery,
    GetUserFilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserFilesQuery, GetUserFilesQueryVariables>(
    GetUserFilesDocument,
    options,
  );
}
export function useGetUserFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserFilesQuery,
    GetUserFilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserFilesQuery, GetUserFilesQueryVariables>(
    GetUserFilesDocument,
    options,
  );
}
export type GetUserFilesQueryHookResult = ReturnType<
  typeof useGetUserFilesQuery
>;
export type GetUserFilesLazyQueryHookResult = ReturnType<
  typeof useGetUserFilesLazyQuery
>;
export type GetUserFilesQueryResult = Apollo.QueryResult<
  GetUserFilesQuery,
  GetUserFilesQueryVariables
>;
export const CreateFileDocument = gql`
  mutation CreateFile($file: String!, $vectorId: String) {
    createFile(data: { file: $file, vectorId: $vectorId })
  }
`;
export type CreateFileMutationFn = Apollo.MutationFunction<
  CreateFileMutation,
  CreateFileMutationVariables
>;

/**
 * __useCreateFileMutation__
 *
 * To run a mutation, you first call `useCreateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMutation, { data, loading, error }] = useCreateFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *      vectorId: // value for 'vectorId'
 *   },
 * });
 */
export function useCreateFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFileMutation,
    CreateFileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFileMutation, CreateFileMutationVariables>(
    CreateFileDocument,
    options,
  );
}
export type CreateFileMutationHookResult = ReturnType<
  typeof useCreateFileMutation
>;
export type CreateFileMutationResult =
  Apollo.MutationResult<CreateFileMutation>;
export type CreateFileMutationOptions = Apollo.BaseMutationOptions<
  CreateFileMutation,
  CreateFileMutationVariables
>;
export const GetStudentTeamsDocument = gql`
  query GetStudentTeams($studyGroupId: String!) {
    studentTeams(filters: { studyGroup: { id: $studyGroupId } }) {
      id
      name
      teamLeader {
        pk
      }
      members {
        pk
      }
    }
  }
`;

/**
 * __useGetStudentTeamsQuery__
 *
 * To run a query within a React component, call `useGetStudentTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentTeamsQuery({
 *   variables: {
 *      studyGroupId: // value for 'studyGroupId'
 *   },
 * });
 */
export function useGetStudentTeamsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetStudentTeamsQuery,
    GetStudentTeamsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStudentTeamsQuery, GetStudentTeamsQueryVariables>(
    GetStudentTeamsDocument,
    options,
  );
}
export function useGetStudentTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStudentTeamsQuery,
    GetStudentTeamsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStudentTeamsQuery,
    GetStudentTeamsQueryVariables
  >(GetStudentTeamsDocument, options);
}
export type GetStudentTeamsQueryHookResult = ReturnType<
  typeof useGetStudentTeamsQuery
>;
export type GetStudentTeamsLazyQueryHookResult = ReturnType<
  typeof useGetStudentTeamsLazyQuery
>;
export type GetStudentTeamsQueryResult = Apollo.QueryResult<
  GetStudentTeamsQuery,
  GetStudentTeamsQueryVariables
>;
export const ArticleDocument = gql`
  query Article($articleId: ID!) {
    article(pk: $articleId) {
      driveUrl
      fileUrl
      id
      pk
      mediaType
      name
      namespace
      pk
      pdfUrl
      preziUrl
      type
      youtubeUrl
    }
  }
`;

/**
 * __useArticleQuery__
 *
 * To run a query within a React component, call `useArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useArticleQuery(
  baseOptions: Apollo.QueryHookOptions<ArticleQuery, ArticleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArticleQuery, ArticleQueryVariables>(
    ArticleDocument,
    options,
  );
}
export function useArticleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticleQuery,
    ArticleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArticleQuery, ArticleQueryVariables>(
    ArticleDocument,
    options,
  );
}
export type ArticleQueryHookResult = ReturnType<typeof useArticleQuery>;
export type ArticleLazyQueryHookResult = ReturnType<typeof useArticleLazyQuery>;
export type ArticleQueryResult = Apollo.QueryResult<
  ArticleQuery,
  ArticleQueryVariables
>;
export const GetArticleReadsDocument = gql`
  query GetArticleReads($userId: String!) {
    articleReads(filters: { userId: $userId }) {
      userId
      articleId
    }
  }
`;

/**
 * __useGetArticleReadsQuery__
 *
 * To run a query within a React component, call `useGetArticleReadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleReadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleReadsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetArticleReadsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetArticleReadsQuery,
    GetArticleReadsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetArticleReadsQuery, GetArticleReadsQueryVariables>(
    GetArticleReadsDocument,
    options,
  );
}
export function useGetArticleReadsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetArticleReadsQuery,
    GetArticleReadsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetArticleReadsQuery,
    GetArticleReadsQueryVariables
  >(GetArticleReadsDocument, options);
}
export type GetArticleReadsQueryHookResult = ReturnType<
  typeof useGetArticleReadsQuery
>;
export type GetArticleReadsLazyQueryHookResult = ReturnType<
  typeof useGetArticleReadsLazyQuery
>;
export type GetArticleReadsQueryResult = Apollo.QueryResult<
  GetArticleReadsQuery,
  GetArticleReadsQueryVariables
>;
export const CreateArticleReadDocument = gql`
  mutation CreateArticleRead($articleId: String!) {
    createArticleRead(data: { articleId: $articleId }) {
      userId
      articleId
    }
  }
`;
export type CreateArticleReadMutationFn = Apollo.MutationFunction<
  CreateArticleReadMutation,
  CreateArticleReadMutationVariables
>;

/**
 * __useCreateArticleReadMutation__
 *
 * To run a mutation, you first call `useCreateArticleReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticleReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticleReadMutation, { data, loading, error }] = useCreateArticleReadMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useCreateArticleReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateArticleReadMutation,
    CreateArticleReadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateArticleReadMutation,
    CreateArticleReadMutationVariables
  >(CreateArticleReadDocument, options);
}
export type CreateArticleReadMutationHookResult = ReturnType<
  typeof useCreateArticleReadMutation
>;
export type CreateArticleReadMutationResult =
  Apollo.MutationResult<CreateArticleReadMutation>;
export type CreateArticleReadMutationOptions = Apollo.BaseMutationOptions<
  CreateArticleReadMutation,
  CreateArticleReadMutationVariables
>;
export const AnalyticsChalkupsDocument = gql`
  query AnalyticsChalkups($studyGroupId: String!) {
    chalkUps(filters: { studyGroup: { id: $studyGroupId } }) {
      content {
        id
      }
      user {
        id
      }
    }
  }
`;

/**
 * __useAnalyticsChalkupsQuery__
 *
 * To run a query within a React component, call `useAnalyticsChalkupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsChalkupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsChalkupsQuery({
 *   variables: {
 *      studyGroupId: // value for 'studyGroupId'
 *   },
 * });
 */
export function useAnalyticsChalkupsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AnalyticsChalkupsQuery,
    AnalyticsChalkupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AnalyticsChalkupsQuery,
    AnalyticsChalkupsQueryVariables
  >(AnalyticsChalkupsDocument, options);
}
export function useAnalyticsChalkupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AnalyticsChalkupsQuery,
    AnalyticsChalkupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AnalyticsChalkupsQuery,
    AnalyticsChalkupsQueryVariables
  >(AnalyticsChalkupsDocument, options);
}
export type AnalyticsChalkupsQueryHookResult = ReturnType<
  typeof useAnalyticsChalkupsQuery
>;
export type AnalyticsChalkupsLazyQueryHookResult = ReturnType<
  typeof useAnalyticsChalkupsLazyQuery
>;
export type AnalyticsChalkupsQueryResult = Apollo.QueryResult<
  AnalyticsChalkupsQuery,
  AnalyticsChalkupsQueryVariables
>;
export const ProgramAndStudyGroupDrillDownDocument = gql`
  query ProgramAndStudyGroupDrillDown($programId: ID!, $studyGroupId: ID!) {
    program(pk: $programId) {
      id
      name
      programUnits {
        id
        name
        modules {
          id
          name
          contents {
            id
            name
          }
        }
      }
      newRenderer
      newMenu
    }
    studyGroup(pk: $studyGroupId) {
      id
      name
      students {
        id
        fullName
        email
        username
      }
      license {
        period {
          firstDate
          lastDate
        }
      }
      isSelfLearning
    }
  }
`;

/**
 * __useProgramAndStudyGroupDrillDownQuery__
 *
 * To run a query within a React component, call `useProgramAndStudyGroupDrillDownQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramAndStudyGroupDrillDownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramAndStudyGroupDrillDownQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      studyGroupId: // value for 'studyGroupId'
 *   },
 * });
 */
export function useProgramAndStudyGroupDrillDownQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProgramAndStudyGroupDrillDownQuery,
    ProgramAndStudyGroupDrillDownQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ProgramAndStudyGroupDrillDownQuery,
    ProgramAndStudyGroupDrillDownQueryVariables
  >(ProgramAndStudyGroupDrillDownDocument, options);
}
export function useProgramAndStudyGroupDrillDownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProgramAndStudyGroupDrillDownQuery,
    ProgramAndStudyGroupDrillDownQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProgramAndStudyGroupDrillDownQuery,
    ProgramAndStudyGroupDrillDownQueryVariables
  >(ProgramAndStudyGroupDrillDownDocument, options);
}
export type ProgramAndStudyGroupDrillDownQueryHookResult = ReturnType<
  typeof useProgramAndStudyGroupDrillDownQuery
>;
export type ProgramAndStudyGroupDrillDownLazyQueryHookResult = ReturnType<
  typeof useProgramAndStudyGroupDrillDownLazyQuery
>;
export type ProgramAndStudyGroupDrillDownQueryResult = Apollo.QueryResult<
  ProgramAndStudyGroupDrillDownQuery,
  ProgramAndStudyGroupDrillDownQueryVariables
>;
export const SudyGroupPersonalizedLearningConversationsDocument = gql`
  query SudyGroupPersonalizedLearningConversations($studyGroupId: String!) {
    conversations(gptBlockName: "OPENAI", studyGroupId: $studyGroupId) {
      id
      name
      gptBlockUniqueId
      history {
        createdAt
        id
        isGenerated
        text
      }
      createdAt
      user {
        id
        email
        firstName
        fullName
        lastName
        username
      }
    }
  }
`;

/**
 * __useSudyGroupPersonalizedLearningConversationsQuery__
 *
 * To run a query within a React component, call `useSudyGroupPersonalizedLearningConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSudyGroupPersonalizedLearningConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSudyGroupPersonalizedLearningConversationsQuery({
 *   variables: {
 *      studyGroupId: // value for 'studyGroupId'
 *   },
 * });
 */
export function useSudyGroupPersonalizedLearningConversationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SudyGroupPersonalizedLearningConversationsQuery,
    SudyGroupPersonalizedLearningConversationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SudyGroupPersonalizedLearningConversationsQuery,
    SudyGroupPersonalizedLearningConversationsQueryVariables
  >(SudyGroupPersonalizedLearningConversationsDocument, options);
}
export function useSudyGroupPersonalizedLearningConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SudyGroupPersonalizedLearningConversationsQuery,
    SudyGroupPersonalizedLearningConversationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SudyGroupPersonalizedLearningConversationsQuery,
    SudyGroupPersonalizedLearningConversationsQueryVariables
  >(SudyGroupPersonalizedLearningConversationsDocument, options);
}
export type SudyGroupPersonalizedLearningConversationsQueryHookResult =
  ReturnType<typeof useSudyGroupPersonalizedLearningConversationsQuery>;
export type SudyGroupPersonalizedLearningConversationsLazyQueryHookResult =
  ReturnType<typeof useSudyGroupPersonalizedLearningConversationsLazyQuery>;
export type SudyGroupPersonalizedLearningConversationsQueryResult =
  Apollo.QueryResult<
    SudyGroupPersonalizedLearningConversationsQuery,
    SudyGroupPersonalizedLearningConversationsQueryVariables
  >;
export const SchoolForStudyGroupDocument = gql`
  query SchoolForStudyGroup($studyGroupId: ID!) {
    studyGroup(pk: $studyGroupId) {
      license {
        school {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useSchoolForStudyGroupQuery__
 *
 * To run a query within a React component, call `useSchoolForStudyGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolForStudyGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolForStudyGroupQuery({
 *   variables: {
 *      studyGroupId: // value for 'studyGroupId'
 *   },
 * });
 */
export function useSchoolForStudyGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchoolForStudyGroupQuery,
    SchoolForStudyGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SchoolForStudyGroupQuery,
    SchoolForStudyGroupQueryVariables
  >(SchoolForStudyGroupDocument, options);
}
export function useSchoolForStudyGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolForStudyGroupQuery,
    SchoolForStudyGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SchoolForStudyGroupQuery,
    SchoolForStudyGroupQueryVariables
  >(SchoolForStudyGroupDocument, options);
}
export type SchoolForStudyGroupQueryHookResult = ReturnType<
  typeof useSchoolForStudyGroupQuery
>;
export type SchoolForStudyGroupLazyQueryHookResult = ReturnType<
  typeof useSchoolForStudyGroupLazyQuery
>;
export type SchoolForStudyGroupQueryResult = Apollo.QueryResult<
  SchoolForStudyGroupQuery,
  SchoolForStudyGroupQueryVariables
>;
export const InteractiveComponentStateDocument = gql`
  query InteractiveComponentState(
    $userId: String!
    $studyGroupId: String!
    $componentId: String!
  ) {
    getInteractiveContentState(
      userId: $userId
      studyGroupId: $studyGroupId
      componentId: $componentId
    ) {
      state
    }
  }
`;

/**
 * __useInteractiveComponentStateQuery__
 *
 * To run a query within a React component, call `useInteractiveComponentStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useInteractiveComponentStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInteractiveComponentStateQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      studyGroupId: // value for 'studyGroupId'
 *      componentId: // value for 'componentId'
 *   },
 * });
 */
export function useInteractiveComponentStateQuery(
  baseOptions: Apollo.QueryHookOptions<
    InteractiveComponentStateQuery,
    InteractiveComponentStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InteractiveComponentStateQuery,
    InteractiveComponentStateQueryVariables
  >(InteractiveComponentStateDocument, options);
}
export function useInteractiveComponentStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InteractiveComponentStateQuery,
    InteractiveComponentStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InteractiveComponentStateQuery,
    InteractiveComponentStateQueryVariables
  >(InteractiveComponentStateDocument, options);
}
export type InteractiveComponentStateQueryHookResult = ReturnType<
  typeof useInteractiveComponentStateQuery
>;
export type InteractiveComponentStateLazyQueryHookResult = ReturnType<
  typeof useInteractiveComponentStateLazyQuery
>;
export type InteractiveComponentStateQueryResult = Apollo.QueryResult<
  InteractiveComponentStateQuery,
  InteractiveComponentStateQueryVariables
>;
export const SaveInteractiveComponentStateDocument = gql`
  mutation SaveInteractiveComponentState(
    $data: InteractiveComponentStateInput!
    $reset: Boolean
  ) {
    saveInteractiveComponentState(data: $data, reset: $reset) {
      state
    }
  }
`;
export type SaveInteractiveComponentStateMutationFn = Apollo.MutationFunction<
  SaveInteractiveComponentStateMutation,
  SaveInteractiveComponentStateMutationVariables
>;

/**
 * __useSaveInteractiveComponentStateMutation__
 *
 * To run a mutation, you first call `useSaveInteractiveComponentStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInteractiveComponentStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInteractiveComponentStateMutation, { data, loading, error }] = useSaveInteractiveComponentStateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      reset: // value for 'reset'
 *   },
 * });
 */
export function useSaveInteractiveComponentStateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveInteractiveComponentStateMutation,
    SaveInteractiveComponentStateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveInteractiveComponentStateMutation,
    SaveInteractiveComponentStateMutationVariables
  >(SaveInteractiveComponentStateDocument, options);
}
export type SaveInteractiveComponentStateMutationHookResult = ReturnType<
  typeof useSaveInteractiveComponentStateMutation
>;
export type SaveInteractiveComponentStateMutationResult =
  Apollo.MutationResult<SaveInteractiveComponentStateMutation>;
export type SaveInteractiveComponentStateMutationOptions =
  Apollo.BaseMutationOptions<
    SaveInteractiveComponentStateMutation,
    SaveInteractiveComponentStateMutationVariables
  >;
export const GetInfobipUsersForStudyGroupDocument = gql`
  query getInfobipUsersForStudyGroup($studyGroupId: ID!) {
    studyGroup(pk: $studyGroupId) {
      infobipUsers {
        id
        platformId
        platformSchoolId
        platformStudyGroupId
        infobipState
        infobipPassword
        complete
        phoneVerified
      }
    }
  }
`;

/**
 * __useGetInfobipUsersForStudyGroupQuery__
 *
 * To run a query within a React component, call `useGetInfobipUsersForStudyGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfobipUsersForStudyGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfobipUsersForStudyGroupQuery({
 *   variables: {
 *      studyGroupId: // value for 'studyGroupId'
 *   },
 * });
 */
export function useGetInfobipUsersForStudyGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInfobipUsersForStudyGroupQuery,
    GetInfobipUsersForStudyGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInfobipUsersForStudyGroupQuery,
    GetInfobipUsersForStudyGroupQueryVariables
  >(GetInfobipUsersForStudyGroupDocument, options);
}
export function useGetInfobipUsersForStudyGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInfobipUsersForStudyGroupQuery,
    GetInfobipUsersForStudyGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInfobipUsersForStudyGroupQuery,
    GetInfobipUsersForStudyGroupQueryVariables
  >(GetInfobipUsersForStudyGroupDocument, options);
}
export type GetInfobipUsersForStudyGroupQueryHookResult = ReturnType<
  typeof useGetInfobipUsersForStudyGroupQuery
>;
export type GetInfobipUsersForStudyGroupLazyQueryHookResult = ReturnType<
  typeof useGetInfobipUsersForStudyGroupLazyQuery
>;
export type GetInfobipUsersForStudyGroupQueryResult = Apollo.QueryResult<
  GetInfobipUsersForStudyGroupQuery,
  GetInfobipUsersForStudyGroupQueryVariables
>;
export const GetInfobipUsersForSchoolDocument = gql`
  query getInfobipUsersForSchool($schoolId: String!) {
    schools(filters: { id: $schoolId }) {
      infobipUsers {
        id
        platformId
        platformSchoolId
        platformStudyGroupId
        infobipState
        infobipPassword
        complete
        phoneVerified
      }
    }
  }
`;

/**
 * __useGetInfobipUsersForSchoolQuery__
 *
 * To run a query within a React component, call `useGetInfobipUsersForSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfobipUsersForSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfobipUsersForSchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetInfobipUsersForSchoolQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInfobipUsersForSchoolQuery,
    GetInfobipUsersForSchoolQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInfobipUsersForSchoolQuery,
    GetInfobipUsersForSchoolQueryVariables
  >(GetInfobipUsersForSchoolDocument, options);
}
export function useGetInfobipUsersForSchoolLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInfobipUsersForSchoolQuery,
    GetInfobipUsersForSchoolQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInfobipUsersForSchoolQuery,
    GetInfobipUsersForSchoolQueryVariables
  >(GetInfobipUsersForSchoolDocument, options);
}
export type GetInfobipUsersForSchoolQueryHookResult = ReturnType<
  typeof useGetInfobipUsersForSchoolQuery
>;
export type GetInfobipUsersForSchoolLazyQueryHookResult = ReturnType<
  typeof useGetInfobipUsersForSchoolLazyQuery
>;
export type GetInfobipUsersForSchoolQueryResult = Apollo.QueryResult<
  GetInfobipUsersForSchoolQuery,
  GetInfobipUsersForSchoolQueryVariables
>;
export const CreateInfobipUserDocument = gql`
  mutation createInfobipUser($userId: String!, $studyGroupId: String!) {
    createInfobip(userId: $userId, studyGroupId: $studyGroupId) {
      id
      infobipDirect {
        id
        infobipState
      }
    }
  }
`;
export type CreateInfobipUserMutationFn = Apollo.MutationFunction<
  CreateInfobipUserMutation,
  CreateInfobipUserMutationVariables
>;

/**
 * __useCreateInfobipUserMutation__
 *
 * To run a mutation, you first call `useCreateInfobipUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInfobipUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInfobipUserMutation, { data, loading, error }] = useCreateInfobipUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      studyGroupId: // value for 'studyGroupId'
 *   },
 * });
 */
export function useCreateInfobipUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInfobipUserMutation,
    CreateInfobipUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateInfobipUserMutation,
    CreateInfobipUserMutationVariables
  >(CreateInfobipUserDocument, options);
}
export type CreateInfobipUserMutationHookResult = ReturnType<
  typeof useCreateInfobipUserMutation
>;
export type CreateInfobipUserMutationResult =
  Apollo.MutationResult<CreateInfobipUserMutation>;
export type CreateInfobipUserMutationOptions = Apollo.BaseMutationOptions<
  CreateInfobipUserMutation,
  CreateInfobipUserMutationVariables
>;
export const GetAllStudentsDocument = gql`
  query getAllStudents {
    studyGroups {
      id
      students {
        id
        username
        firstName
        lastName
        email
      }
    }
  }
`;

/**
 * __useGetAllStudentsQuery__
 *
 * To run a query within a React component, call `useGetAllStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStudentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStudentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllStudentsQuery,
    GetAllStudentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllStudentsQuery, GetAllStudentsQueryVariables>(
    GetAllStudentsDocument,
    options,
  );
}
export function useGetAllStudentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllStudentsQuery,
    GetAllStudentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllStudentsQuery, GetAllStudentsQueryVariables>(
    GetAllStudentsDocument,
    options,
  );
}
export type GetAllStudentsQueryHookResult = ReturnType<
  typeof useGetAllStudentsQuery
>;
export type GetAllStudentsLazyQueryHookResult = ReturnType<
  typeof useGetAllStudentsLazyQuery
>;
export type GetAllStudentsQueryResult = Apollo.QueryResult<
  GetAllStudentsQuery,
  GetAllStudentsQueryVariables
>;
export const ManagedSchoolsDocument = gql`
  query ManagedSchools {
    managedSchools {
      id
      name
      programs {
        id
      }
      licenses {
        id
        studyGroup {
          id
          name
          inviteCode
          inviteCodeEnabled
        }
        period {
          id
          firstDate
          lastDate
          name
        }
        program {
          id
          name
          image {
            name
          }
          thumbnails
        }
        maxStudents
        maxTeachers
      }
      affiliation {
        isManager
        isTeacher
      }
    }
  }
`;

/**
 * __useManagedSchoolsQuery__
 *
 * To run a query within a React component, call `useManagedSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedSchoolsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedSchoolsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedSchoolsQuery,
    ManagedSchoolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ManagedSchoolsQuery, ManagedSchoolsQueryVariables>(
    ManagedSchoolsDocument,
    options,
  );
}
export function useManagedSchoolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedSchoolsQuery,
    ManagedSchoolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ManagedSchoolsQuery, ManagedSchoolsQueryVariables>(
    ManagedSchoolsDocument,
    options,
  );
}
export type ManagedSchoolsQueryHookResult = ReturnType<
  typeof useManagedSchoolsQuery
>;
export type ManagedSchoolsLazyQueryHookResult = ReturnType<
  typeof useManagedSchoolsLazyQuery
>;
export type ManagedSchoolsQueryResult = Apollo.QueryResult<
  ManagedSchoolsQuery,
  ManagedSchoolsQueryVariables
>;
export const OrganizationsDocument = gql`
  query Organizations {
    organizations {
      id
      description
      name
      pk
    }
  }
`;

/**
 * __useOrganizationsQuery__
 *
 * To run a query within a React component, call `useOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OrganizationsQuery,
    OrganizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OrganizationsQuery, OrganizationsQueryVariables>(
    OrganizationsDocument,
    options,
  );
}
export function useOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationsQuery,
    OrganizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OrganizationsQuery, OrganizationsQueryVariables>(
    OrganizationsDocument,
    options,
  );
}
export type OrganizationsQueryHookResult = ReturnType<
  typeof useOrganizationsQuery
>;
export type OrganizationsLazyQueryHookResult = ReturnType<
  typeof useOrganizationsLazyQuery
>;
export type OrganizationsQueryResult = Apollo.QueryResult<
  OrganizationsQuery,
  OrganizationsQueryVariables
>;
export const OrganizationProgramsDocument = gql`
  query OrganizationPrograms($organizationId: String) {
    organizationPrograms(organizationId: $organizationId) {
      description
      id
      name
      pk
      thumbnails
    }
  }
`;

/**
 * __useOrganizationProgramsQuery__
 *
 * To run a query within a React component, call `useOrganizationProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationProgramsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationProgramsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OrganizationProgramsQuery,
    OrganizationProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OrganizationProgramsQuery,
    OrganizationProgramsQueryVariables
  >(OrganizationProgramsDocument, options);
}
export function useOrganizationProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationProgramsQuery,
    OrganizationProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrganizationProgramsQuery,
    OrganizationProgramsQueryVariables
  >(OrganizationProgramsDocument, options);
}
export type OrganizationProgramsQueryHookResult = ReturnType<
  typeof useOrganizationProgramsQuery
>;
export type OrganizationProgramsLazyQueryHookResult = ReturnType<
  typeof useOrganizationProgramsLazyQuery
>;
export type OrganizationProgramsQueryResult = Apollo.QueryResult<
  OrganizationProgramsQuery,
  OrganizationProgramsQueryVariables
>;
export const GetUserOrganizationsDocument = gql`
  query GetUserOrganizations {
    getUserOrganizations {
      id
      organization {
        id
        name
      }
      index
    }
  }
`;

/**
 * __useGetUserOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetUserOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserOrganizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserOrganizationsQuery,
    GetUserOrganizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserOrganizationsQuery,
    GetUserOrganizationsQueryVariables
  >(GetUserOrganizationsDocument, options);
}
export function useGetUserOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserOrganizationsQuery,
    GetUserOrganizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserOrganizationsQuery,
    GetUserOrganizationsQueryVariables
  >(GetUserOrganizationsDocument, options);
}
export type GetUserOrganizationsQueryHookResult = ReturnType<
  typeof useGetUserOrganizationsQuery
>;
export type GetUserOrganizationsLazyQueryHookResult = ReturnType<
  typeof useGetUserOrganizationsLazyQuery
>;
export type GetUserOrganizationsQueryResult = Apollo.QueryResult<
  GetUserOrganizationsQuery,
  GetUserOrganizationsQueryVariables
>;
export const UsersStudyGroupsDocument = gql`
  query UsersStudyGroups($userId: String!) {
    studyGroups(
      filters: {
        fieldsOrFilter: {
          fields: [
            {
              field: "student_affiliations__user__id"
              lookup: { iExact: $userId }
            }
          ]
        }
      }
    ) {
      id
      name
      license {
        program {
          id
          name
          newRenderer
          newMenu
          programUnits {
            id
            name
            modules {
              id
              name
              contents {
                id
                name
              }
            }
          }
        }
        period {
          firstDate
          lastDate
        }
      }
      isSelfLearning
    }
    users(filters: { id: $userId }) {
      id
      fullName
      email
      username
    }
  }
`;

/**
 * __useUsersStudyGroupsQuery__
 *
 * To run a query within a React component, call `useUsersStudyGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersStudyGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersStudyGroupsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUsersStudyGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UsersStudyGroupsQuery,
    UsersStudyGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UsersStudyGroupsQuery, UsersStudyGroupsQueryVariables>(
    UsersStudyGroupsDocument,
    options,
  );
}
export function useUsersStudyGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UsersStudyGroupsQuery,
    UsersStudyGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UsersStudyGroupsQuery,
    UsersStudyGroupsQueryVariables
  >(UsersStudyGroupsDocument, options);
}
export type UsersStudyGroupsQueryHookResult = ReturnType<
  typeof useUsersStudyGroupsQuery
>;
export type UsersStudyGroupsLazyQueryHookResult = ReturnType<
  typeof useUsersStudyGroupsLazyQuery
>;
export type UsersStudyGroupsQueryResult = Apollo.QueryResult<
  UsersStudyGroupsQuery,
  UsersStudyGroupsQueryVariables
>;
export const AdminAnalyticsOrganizationsDocument = gql`
  query AdminAnalyticsOrganizations {
    organizations {
      id
      name
    }
  }
`;

/**
 * __useAdminAnalyticsOrganizationsQuery__
 *
 * To run a query within a React component, call `useAdminAnalyticsOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAnalyticsOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAnalyticsOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminAnalyticsOrganizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminAnalyticsOrganizationsQuery,
    AdminAnalyticsOrganizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminAnalyticsOrganizationsQuery,
    AdminAnalyticsOrganizationsQueryVariables
  >(AdminAnalyticsOrganizationsDocument, options);
}
export function useAdminAnalyticsOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminAnalyticsOrganizationsQuery,
    AdminAnalyticsOrganizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminAnalyticsOrganizationsQuery,
    AdminAnalyticsOrganizationsQueryVariables
  >(AdminAnalyticsOrganizationsDocument, options);
}
export type AdminAnalyticsOrganizationsQueryHookResult = ReturnType<
  typeof useAdminAnalyticsOrganizationsQuery
>;
export type AdminAnalyticsOrganizationsLazyQueryHookResult = ReturnType<
  typeof useAdminAnalyticsOrganizationsLazyQuery
>;
export type AdminAnalyticsOrganizationsQueryResult = Apollo.QueryResult<
  AdminAnalyticsOrganizationsQuery,
  AdminAnalyticsOrganizationsQueryVariables
>;
export const AdminAnalyticsProgramsDocument = gql`
  query AdminAnalyticsPrograms {
    programs {
      id
      name
      programUnits {
        id
        name
        modules {
          id
          name
          contents {
            id
            name
          }
        }
      }
    }
  }
`;

/**
 * __useAdminAnalyticsProgramsQuery__
 *
 * To run a query within a React component, call `useAdminAnalyticsProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAnalyticsProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAnalyticsProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminAnalyticsProgramsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminAnalyticsProgramsQuery,
    AdminAnalyticsProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminAnalyticsProgramsQuery,
    AdminAnalyticsProgramsQueryVariables
  >(AdminAnalyticsProgramsDocument, options);
}
export function useAdminAnalyticsProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminAnalyticsProgramsQuery,
    AdminAnalyticsProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminAnalyticsProgramsQuery,
    AdminAnalyticsProgramsQueryVariables
  >(AdminAnalyticsProgramsDocument, options);
}
export type AdminAnalyticsProgramsQueryHookResult = ReturnType<
  typeof useAdminAnalyticsProgramsQuery
>;
export type AdminAnalyticsProgramsLazyQueryHookResult = ReturnType<
  typeof useAdminAnalyticsProgramsLazyQuery
>;
export type AdminAnalyticsProgramsQueryResult = Apollo.QueryResult<
  AdminAnalyticsProgramsQuery,
  AdminAnalyticsProgramsQueryVariables
>;
export const AdminAnalyticsSchoolsDocument = gql`
  query AdminAnalyticsSchools($includeTeachers: Boolean = false) {
    schools {
      id
      name
      licenses {
        studyGroup {
          id
          name
          students {
            id
            username
            fullName
            email
          }
          teachers @include(if: $includeTeachers) {
            id
            username
            fullName
            email
          }
        }
      }
    }
  }
`;

/**
 * __useAdminAnalyticsSchoolsQuery__
 *
 * To run a query within a React component, call `useAdminAnalyticsSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAnalyticsSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAnalyticsSchoolsQuery({
 *   variables: {
 *      includeTeachers: // value for 'includeTeachers'
 *   },
 * });
 */
export function useAdminAnalyticsSchoolsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminAnalyticsSchoolsQuery,
    AdminAnalyticsSchoolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminAnalyticsSchoolsQuery,
    AdminAnalyticsSchoolsQueryVariables
  >(AdminAnalyticsSchoolsDocument, options);
}
export function useAdminAnalyticsSchoolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminAnalyticsSchoolsQuery,
    AdminAnalyticsSchoolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminAnalyticsSchoolsQuery,
    AdminAnalyticsSchoolsQueryVariables
  >(AdminAnalyticsSchoolsDocument, options);
}
export type AdminAnalyticsSchoolsQueryHookResult = ReturnType<
  typeof useAdminAnalyticsSchoolsQuery
>;
export type AdminAnalyticsSchoolsLazyQueryHookResult = ReturnType<
  typeof useAdminAnalyticsSchoolsLazyQuery
>;
export type AdminAnalyticsSchoolsQueryResult = Apollo.QueryResult<
  AdminAnalyticsSchoolsQuery,
  AdminAnalyticsSchoolsQueryVariables
>;
export const AdminAnalyticsDrillDownDocument = gql`
  query AdminAnalyticsDrillDown {
    analyticsDrillDown
  }
`;

/**
 * __useAdminAnalyticsDrillDownQuery__
 *
 * To run a query within a React component, call `useAdminAnalyticsDrillDownQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAnalyticsDrillDownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAnalyticsDrillDownQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminAnalyticsDrillDownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminAnalyticsDrillDownQuery,
    AdminAnalyticsDrillDownQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminAnalyticsDrillDownQuery,
    AdminAnalyticsDrillDownQueryVariables
  >(AdminAnalyticsDrillDownDocument, options);
}
export function useAdminAnalyticsDrillDownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminAnalyticsDrillDownQuery,
    AdminAnalyticsDrillDownQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminAnalyticsDrillDownQuery,
    AdminAnalyticsDrillDownQueryVariables
  >(AdminAnalyticsDrillDownDocument, options);
}
export type AdminAnalyticsDrillDownQueryHookResult = ReturnType<
  typeof useAdminAnalyticsDrillDownQuery
>;
export type AdminAnalyticsDrillDownLazyQueryHookResult = ReturnType<
  typeof useAdminAnalyticsDrillDownLazyQuery
>;
export type AdminAnalyticsDrillDownQueryResult = Apollo.QueryResult<
  AdminAnalyticsDrillDownQuery,
  AdminAnalyticsDrillDownQueryVariables
>;
export const AdminMartinAnalyticsDocument = gql`
  query AdminMartinAnalytics(
    $schoolIds: [String!]
    $studyGroupIds: [String!]
    $userIds: [String!]
    $deleted: Boolean
  ) {
    adminMartinAnalytics(
      schoolIds: $schoolIds
      studyGroupIds: $studyGroupIds
      userIds: $userIds
      deleted: $deleted
    )
  }
`;

/**
 * __useAdminMartinAnalyticsQuery__
 *
 * To run a query within a React component, call `useAdminMartinAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMartinAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMartinAnalyticsQuery({
 *   variables: {
 *      schoolIds: // value for 'schoolIds'
 *      studyGroupIds: // value for 'studyGroupIds'
 *      userIds: // value for 'userIds'
 *      deleted: // value for 'deleted'
 *   },
 * });
 */
export function useAdminMartinAnalyticsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminMartinAnalyticsQuery,
    AdminMartinAnalyticsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminMartinAnalyticsQuery,
    AdminMartinAnalyticsQueryVariables
  >(AdminMartinAnalyticsDocument, options);
}
export function useAdminMartinAnalyticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminMartinAnalyticsQuery,
    AdminMartinAnalyticsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminMartinAnalyticsQuery,
    AdminMartinAnalyticsQueryVariables
  >(AdminMartinAnalyticsDocument, options);
}
export type AdminMartinAnalyticsQueryHookResult = ReturnType<
  typeof useAdminMartinAnalyticsQuery
>;
export type AdminMartinAnalyticsLazyQueryHookResult = ReturnType<
  typeof useAdminMartinAnalyticsLazyQuery
>;
export type AdminMartinAnalyticsQueryResult = Apollo.QueryResult<
  AdminMartinAnalyticsQuery,
  AdminMartinAnalyticsQueryVariables
>;
export const AdminUserAnalyticsTimelineDocument = gql`
  query AdminUserAnalyticsTimeline(
    $organizationIds: [String!]
    $schoolIds: [String!]
    $studyGroupIds: [String!]
    $activeLicense: Boolean
    $breakDownBy: String
    $startDate: String
    $endDate: String
  ) {
    adminUserAnalyticsTimeline(
      organizationIds: $organizationIds
      schoolIds: $schoolIds
      studyGroupIds: $studyGroupIds
      activeLicense: $activeLicense
      breakDownBy: $breakDownBy
      startDate: $startDate
      endDate: $endDate
    )
  }
`;

/**
 * __useAdminUserAnalyticsTimelineQuery__
 *
 * To run a query within a React component, call `useAdminUserAnalyticsTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserAnalyticsTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserAnalyticsTimelineQuery({
 *   variables: {
 *      organizationIds: // value for 'organizationIds'
 *      schoolIds: // value for 'schoolIds'
 *      studyGroupIds: // value for 'studyGroupIds'
 *      activeLicense: // value for 'activeLicense'
 *      breakDownBy: // value for 'breakDownBy'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAdminUserAnalyticsTimelineQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminUserAnalyticsTimelineQuery,
    AdminUserAnalyticsTimelineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminUserAnalyticsTimelineQuery,
    AdminUserAnalyticsTimelineQueryVariables
  >(AdminUserAnalyticsTimelineDocument, options);
}
export function useAdminUserAnalyticsTimelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminUserAnalyticsTimelineQuery,
    AdminUserAnalyticsTimelineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminUserAnalyticsTimelineQuery,
    AdminUserAnalyticsTimelineQueryVariables
  >(AdminUserAnalyticsTimelineDocument, options);
}
export type AdminUserAnalyticsTimelineQueryHookResult = ReturnType<
  typeof useAdminUserAnalyticsTimelineQuery
>;
export type AdminUserAnalyticsTimelineLazyQueryHookResult = ReturnType<
  typeof useAdminUserAnalyticsTimelineLazyQuery
>;
export type AdminUserAnalyticsTimelineQueryResult = Apollo.QueryResult<
  AdminUserAnalyticsTimelineQuery,
  AdminUserAnalyticsTimelineQueryVariables
>;
export const AdminUserAnalyticsTotalsDocument = gql`
  query AdminUserAnalyticsTotals(
    $organizationIds: [String!]
    $schoolIds: [String!]
    $studyGroupIds: [String!]
    $activeLicense: Boolean
    $startDate: String
    $endDate: String
  ) {
    adminUserAnalyticsTotals(
      organizationIds: $organizationIds
      schoolIds: $schoolIds
      studyGroupIds: $studyGroupIds
      activeLicense: $activeLicense
      startDate: $startDate
      endDate: $endDate
    )
  }
`;

/**
 * __useAdminUserAnalyticsTotalsQuery__
 *
 * To run a query within a React component, call `useAdminUserAnalyticsTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserAnalyticsTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserAnalyticsTotalsQuery({
 *   variables: {
 *      organizationIds: // value for 'organizationIds'
 *      schoolIds: // value for 'schoolIds'
 *      studyGroupIds: // value for 'studyGroupIds'
 *      activeLicense: // value for 'activeLicense'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAdminUserAnalyticsTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminUserAnalyticsTotalsQuery,
    AdminUserAnalyticsTotalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminUserAnalyticsTotalsQuery,
    AdminUserAnalyticsTotalsQueryVariables
  >(AdminUserAnalyticsTotalsDocument, options);
}
export function useAdminUserAnalyticsTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminUserAnalyticsTotalsQuery,
    AdminUserAnalyticsTotalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminUserAnalyticsTotalsQuery,
    AdminUserAnalyticsTotalsQueryVariables
  >(AdminUserAnalyticsTotalsDocument, options);
}
export type AdminUserAnalyticsTotalsQueryHookResult = ReturnType<
  typeof useAdminUserAnalyticsTotalsQuery
>;
export type AdminUserAnalyticsTotalsLazyQueryHookResult = ReturnType<
  typeof useAdminUserAnalyticsTotalsLazyQuery
>;
export type AdminUserAnalyticsTotalsQueryResult = Apollo.QueryResult<
  AdminUserAnalyticsTotalsQuery,
  AdminUserAnalyticsTotalsQueryVariables
>;
export const AdminUserAnalyticsBreakdownDocument = gql`
  query AdminUserAnalyticsBreakdown(
    $organizationIds: [String!]
    $schoolIds: [String!]
    $studyGroupIds: [String!]
    $activeLicense: Boolean
    $startDate: String
    $endDate: String
  ) {
    adminUserAnalyticsBreakdown(
      organizationIds: $organizationIds
      schoolIds: $schoolIds
      studyGroupIds: $studyGroupIds
      activeLicense: $activeLicense
      startDate: $startDate
      endDate: $endDate
    )
  }
`;

/**
 * __useAdminUserAnalyticsBreakdownQuery__
 *
 * To run a query within a React component, call `useAdminUserAnalyticsBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserAnalyticsBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserAnalyticsBreakdownQuery({
 *   variables: {
 *      organizationIds: // value for 'organizationIds'
 *      schoolIds: // value for 'schoolIds'
 *      studyGroupIds: // value for 'studyGroupIds'
 *      activeLicense: // value for 'activeLicense'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAdminUserAnalyticsBreakdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminUserAnalyticsBreakdownQuery,
    AdminUserAnalyticsBreakdownQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminUserAnalyticsBreakdownQuery,
    AdminUserAnalyticsBreakdownQueryVariables
  >(AdminUserAnalyticsBreakdownDocument, options);
}
export function useAdminUserAnalyticsBreakdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminUserAnalyticsBreakdownQuery,
    AdminUserAnalyticsBreakdownQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminUserAnalyticsBreakdownQuery,
    AdminUserAnalyticsBreakdownQueryVariables
  >(AdminUserAnalyticsBreakdownDocument, options);
}
export type AdminUserAnalyticsBreakdownQueryHookResult = ReturnType<
  typeof useAdminUserAnalyticsBreakdownQuery
>;
export type AdminUserAnalyticsBreakdownLazyQueryHookResult = ReturnType<
  typeof useAdminUserAnalyticsBreakdownLazyQuery
>;
export type AdminUserAnalyticsBreakdownQueryResult = Apollo.QueryResult<
  AdminUserAnalyticsBreakdownQuery,
  AdminUserAnalyticsBreakdownQueryVariables
>;
export const StudyGroupWithoutUsersDocument = gql`
  query StudyGroupWithoutUsers($studyGroupId: ID!, $userId: String!) {
    studyGroup(pk: $studyGroupId) {
      id
      pk
      name
      isSelfLearning
      isExplore
      trackAssignments
      trackChoice
      license {
        id
        period {
          lastDate
        }
        program {
          id
          pk
        }
      }
      tracksLicense {
        id
        name
      }
      shares {
        id
        contentId
      }
      chalkups(filters: { user: { id: $userId } }) {
        id
        contentId
      }
    }
    pinnings(filters: { user: { id: $userId } }) {
      id
      contentId
    }
  }
`;

/**
 * __useStudyGroupWithoutUsersQuery__
 *
 * To run a query within a React component, call `useStudyGroupWithoutUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudyGroupWithoutUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyGroupWithoutUsersQuery({
 *   variables: {
 *      studyGroupId: // value for 'studyGroupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useStudyGroupWithoutUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    StudyGroupWithoutUsersQuery,
    StudyGroupWithoutUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StudyGroupWithoutUsersQuery,
    StudyGroupWithoutUsersQueryVariables
  >(StudyGroupWithoutUsersDocument, options);
}
export function useStudyGroupWithoutUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StudyGroupWithoutUsersQuery,
    StudyGroupWithoutUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StudyGroupWithoutUsersQuery,
    StudyGroupWithoutUsersQueryVariables
  >(StudyGroupWithoutUsersDocument, options);
}
export type StudyGroupWithoutUsersQueryHookResult = ReturnType<
  typeof useStudyGroupWithoutUsersQuery
>;
export type StudyGroupWithoutUsersLazyQueryHookResult = ReturnType<
  typeof useStudyGroupWithoutUsersLazyQuery
>;
export type StudyGroupWithoutUsersQueryResult = Apollo.QueryResult<
  StudyGroupWithoutUsersQuery,
  StudyGroupWithoutUsersQueryVariables
>;
export const StudyGroupDocument = gql`
  query StudyGroup($studyGroupId: ID!, $userId: String!) {
    studyGroup(pk: $studyGroupId) {
      id
      pk
      name
      isSelfLearning
      isExplore
      trackAssignments
      trackChoice
      license {
        id
        period {
          lastDate
        }
        program {
          id
          pk
        }
      }
      tracksLicense {
        id
        name
      }
      students {
        pk
        username
        email
        firstName
        lastName
        fullName
      }
      teachers {
        pk
        username
        email
        firstName
        lastName
        fullName
      }
      shares {
        id
        contentId
      }
      chalkups(filters: { user: { id: $userId } }) {
        id
        contentId
      }
    }
    pinnings(filters: { user: { id: $userId } }) {
      id
      contentId
    }
  }
`;

/**
 * __useStudyGroupQuery__
 *
 * To run a query within a React component, call `useStudyGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudyGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyGroupQuery({
 *   variables: {
 *      studyGroupId: // value for 'studyGroupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useStudyGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    StudyGroupQuery,
    StudyGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StudyGroupQuery, StudyGroupQueryVariables>(
    StudyGroupDocument,
    options,
  );
}
export function useStudyGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StudyGroupQuery,
    StudyGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StudyGroupQuery, StudyGroupQueryVariables>(
    StudyGroupDocument,
    options,
  );
}
export type StudyGroupQueryHookResult = ReturnType<typeof useStudyGroupQuery>;
export type StudyGroupLazyQueryHookResult = ReturnType<
  typeof useStudyGroupLazyQuery
>;
export type StudyGroupQueryResult = Apollo.QueryResult<
  StudyGroupQuery,
  StudyGroupQueryVariables
>;
export const ProgramDocument = gql`
  query Program($programId: ID!) {
    program(pk: $programId) {
      id
      pk
      name
      description
      videoUrl
      newMenu
      image {
        name
      }
      thumbnails
      guides {
        id
        name
        pdfUrl
        mediaType
        youtubeUrl
        preziUrl
        driveUrl
        fileUrl
        videoUrl
      }
    }
  }
`;

/**
 * __useProgramQuery__
 *
 * To run a query within a React component, call `useProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramQuery(
  baseOptions: Apollo.QueryHookOptions<ProgramQuery, ProgramQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProgramQuery, ProgramQueryVariables>(
    ProgramDocument,
    options,
  );
}
export function useProgramLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProgramQuery,
    ProgramQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProgramQuery, ProgramQueryVariables>(
    ProgramDocument,
    options,
  );
}
export type ProgramQueryHookResult = ReturnType<typeof useProgramQuery>;
export type ProgramLazyQueryHookResult = ReturnType<typeof useProgramLazyQuery>;
export type ProgramQueryResult = Apollo.QueryResult<
  ProgramQuery,
  ProgramQueryVariables
>;
export const ProgramAndProgramUnitsDocument = gql`
  query ProgramAndProgramUnits($programId: ID!, $classPage: Boolean!) {
    program(pk: $programId) {
      id
      pk
      name
      description
      progress
      videoUrl
      newMenu
      image {
        name
      }
      thumbnails
      guides {
        id
        name
        pdfUrl
        mediaType
        youtubeUrl
        preziUrl
        driveUrl
        fileUrl
        videoUrl
      }
      programUnits {
        id
        progress
        name
        description
        thumbnails
        ...ClassPageUnitFragment @include(if: $classPage)
        modules {
          id
          name
          contents {
            id
            name
          }
        }
      }
    }
  }
  ${ClassPageUnitFragmentFragmentDoc}
`;

/**
 * __useProgramAndProgramUnitsQuery__
 *
 * To run a query within a React component, call `useProgramAndProgramUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramAndProgramUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramAndProgramUnitsQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      classPage: // value for 'classPage'
 *   },
 * });
 */
export function useProgramAndProgramUnitsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProgramAndProgramUnitsQuery,
    ProgramAndProgramUnitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ProgramAndProgramUnitsQuery,
    ProgramAndProgramUnitsQueryVariables
  >(ProgramAndProgramUnitsDocument, options);
}
export function useProgramAndProgramUnitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProgramAndProgramUnitsQuery,
    ProgramAndProgramUnitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProgramAndProgramUnitsQuery,
    ProgramAndProgramUnitsQueryVariables
  >(ProgramAndProgramUnitsDocument, options);
}
export type ProgramAndProgramUnitsQueryHookResult = ReturnType<
  typeof useProgramAndProgramUnitsQuery
>;
export type ProgramAndProgramUnitsLazyQueryHookResult = ReturnType<
  typeof useProgramAndProgramUnitsLazyQuery
>;
export type ProgramAndProgramUnitsQueryResult = Apollo.QueryResult<
  ProgramAndProgramUnitsQuery,
  ProgramAndProgramUnitsQueryVariables
>;
export const ProgramStudyGroupsDocument = gql`
  query ProgramStudyGroups($programIdStr: String!) {
    studyGroups(filters: { license: { program: { id: $programIdStr } } }) {
      id
      name
      schoolName
      trackChoice
      trackAssignments
      tracks {
        id
        name
        tags
      }
    }
  }
`;

/**
 * __useProgramStudyGroupsQuery__
 *
 * To run a query within a React component, call `useProgramStudyGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramStudyGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramStudyGroupsQuery({
 *   variables: {
 *      programIdStr: // value for 'programIdStr'
 *   },
 * });
 */
export function useProgramStudyGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProgramStudyGroupsQuery,
    ProgramStudyGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ProgramStudyGroupsQuery,
    ProgramStudyGroupsQueryVariables
  >(ProgramStudyGroupsDocument, options);
}
export function useProgramStudyGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProgramStudyGroupsQuery,
    ProgramStudyGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProgramStudyGroupsQuery,
    ProgramStudyGroupsQueryVariables
  >(ProgramStudyGroupsDocument, options);
}
export type ProgramStudyGroupsQueryHookResult = ReturnType<
  typeof useProgramStudyGroupsQuery
>;
export type ProgramStudyGroupsLazyQueryHookResult = ReturnType<
  typeof useProgramStudyGroupsLazyQuery
>;
export type ProgramStudyGroupsQueryResult = Apollo.QueryResult<
  ProgramStudyGroupsQuery,
  ProgramStudyGroupsQueryVariables
>;
export const ProgramStudyGroupDocument = gql`
  query ProgramStudyGroup($programIdStr: String!, $studyGroupId: String!) {
    studyGroups(
      filters: {
        license: { program: { id: $programIdStr } }
        id: $studyGroupId
      }
    ) {
      id
      name
      schoolName
      trackChoice
      trackAssignments
    }
  }
`;

/**
 * __useProgramStudyGroupQuery__
 *
 * To run a query within a React component, call `useProgramStudyGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramStudyGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramStudyGroupQuery({
 *   variables: {
 *      programIdStr: // value for 'programIdStr'
 *      studyGroupId: // value for 'studyGroupId'
 *   },
 * });
 */
export function useProgramStudyGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProgramStudyGroupQuery,
    ProgramStudyGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ProgramStudyGroupQuery,
    ProgramStudyGroupQueryVariables
  >(ProgramStudyGroupDocument, options);
}
export function useProgramStudyGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProgramStudyGroupQuery,
    ProgramStudyGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProgramStudyGroupQuery,
    ProgramStudyGroupQueryVariables
  >(ProgramStudyGroupDocument, options);
}
export type ProgramStudyGroupQueryHookResult = ReturnType<
  typeof useProgramStudyGroupQuery
>;
export type ProgramStudyGroupLazyQueryHookResult = ReturnType<
  typeof useProgramStudyGroupLazyQuery
>;
export type ProgramStudyGroupQueryResult = Apollo.QueryResult<
  ProgramStudyGroupQuery,
  ProgramStudyGroupQueryVariables
>;
export const TrackDocument = gql`
  query Track($trackId: ID!, $classPage: Boolean!) {
    track(pk: $trackId) {
      id
      name
      progress @include(if: $classPage) @client
      conditionEnabled
      conditionShown
      trackGuides(filters: { enabled: true }) {
        id
        guide {
          id
          name
          pdfUrl
          mediaType
          youtubeUrl
          preziUrl
          driveUrl
          fileUrl
          videoUrl
        }
      }
      trackUnits(filters: { enabled: true }) {
        id
        unit {
          id
          name
          isDemo
          ...ClassPageUnitFragment @include(if: $classPage)
        }
        progress @include(if: $classPage) @client
        canBeShared @include(if: $classPage) @client
        conditionEnabled
        conditionShown
        trackModules(filters: { enabled: true }) @skip(if: $classPage) {
          id
          conditionEnabled
          conditionShown
          module {
            id
            name
          }
          trackContents(filters: { enabled: true }) {
            id
            conditionEnabled
            conditionShown
            content {
              id
              name
              mediaType
              isShareable
              isDownloadable
              isDemo
              fileUrl
            }
            forwardContent {
              id
              name
              mediaType
              isShareable
              isDownloadable
              isDemo
              fileUrl
            }
          }
        }
      }
    }
  }
  ${ClassPageUnitFragmentFragmentDoc}
`;

/**
 * __useTrackQuery__
 *
 * To run a query within a React component, call `useTrackQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackQuery({
 *   variables: {
 *      trackId: // value for 'trackId'
 *      classPage: // value for 'classPage'
 *   },
 * });
 */
export function useTrackQuery(
  baseOptions: Apollo.QueryHookOptions<TrackQuery, TrackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackQuery, TrackQueryVariables>(
    TrackDocument,
    options,
  );
}
export function useTrackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrackQuery, TrackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackQuery, TrackQueryVariables>(
    TrackDocument,
    options,
  );
}
export type TrackQueryHookResult = ReturnType<typeof useTrackQuery>;
export type TrackLazyQueryHookResult = ReturnType<typeof useTrackLazyQuery>;
export type TrackQueryResult = Apollo.QueryResult<
  TrackQuery,
  TrackQueryVariables
>;
export const TrackProgressDocument = gql`
  query TrackProgress($trackId: ID!, $trackIdString: String!) {
    track(pk: $trackId) {
      id
      progress
    }
    trackUnits(filters: { track: { id: $trackIdString }, enabled: true }) {
      id
      progress
      canBeShared
    }
  }
`;

/**
 * __useTrackProgressQuery__
 *
 * To run a query within a React component, call `useTrackProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackProgressQuery({
 *   variables: {
 *      trackId: // value for 'trackId'
 *      trackIdString: // value for 'trackIdString'
 *   },
 * });
 */
export function useTrackProgressQuery(
  baseOptions: Apollo.QueryHookOptions<
    TrackProgressQuery,
    TrackProgressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackProgressQuery, TrackProgressQueryVariables>(
    TrackProgressDocument,
    options,
  );
}
export function useTrackProgressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TrackProgressQuery,
    TrackProgressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackProgressQuery, TrackProgressQueryVariables>(
    TrackProgressDocument,
    options,
  );
}
export type TrackProgressQueryHookResult = ReturnType<
  typeof useTrackProgressQuery
>;
export type TrackProgressLazyQueryHookResult = ReturnType<
  typeof useTrackProgressLazyQuery
>;
export type TrackProgressQueryResult = Apollo.QueryResult<
  TrackProgressQuery,
  TrackProgressQueryVariables
>;
export const CompleteChalkupDocument = gql`
  mutation CompleteChalkup($contentId: String!, $studyGroupId: String) {
    completeContent(contentId: $contentId, studyGroupId: $studyGroupId) {
      id
      contentId
    }
  }
`;
export type CompleteChalkupMutationFn = Apollo.MutationFunction<
  CompleteChalkupMutation,
  CompleteChalkupMutationVariables
>;

/**
 * __useCompleteChalkupMutation__
 *
 * To run a mutation, you first call `useCompleteChalkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteChalkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeChalkupMutation, { data, loading, error }] = useCompleteChalkupMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      studyGroupId: // value for 'studyGroupId'
 *   },
 * });
 */
export function useCompleteChalkupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteChalkupMutation,
    CompleteChalkupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteChalkupMutation,
    CompleteChalkupMutationVariables
  >(CompleteChalkupDocument, options);
}
export type CompleteChalkupMutationHookResult = ReturnType<
  typeof useCompleteChalkupMutation
>;
export type CompleteChalkupMutationResult =
  Apollo.MutationResult<CompleteChalkupMutation>;
export type CompleteChalkupMutationOptions = Apollo.BaseMutationOptions<
  CompleteChalkupMutation,
  CompleteChalkupMutationVariables
>;
export const CompleteShareDocument = gql`
  mutation CompleteShare($contentId: String!, $studyGroupId: String!) {
    shareContent(contentId: $contentId, studyGroupId: $studyGroupId) {
      id
      contentId
    }
  }
`;
export type CompleteShareMutationFn = Apollo.MutationFunction<
  CompleteShareMutation,
  CompleteShareMutationVariables
>;

/**
 * __useCompleteShareMutation__
 *
 * To run a mutation, you first call `useCompleteShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeShareMutation, { data, loading, error }] = useCompleteShareMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      studyGroupId: // value for 'studyGroupId'
 *   },
 * });
 */
export function useCompleteShareMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteShareMutation,
    CompleteShareMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteShareMutation,
    CompleteShareMutationVariables
  >(CompleteShareDocument, options);
}
export type CompleteShareMutationHookResult = ReturnType<
  typeof useCompleteShareMutation
>;
export type CompleteShareMutationResult =
  Apollo.MutationResult<CompleteShareMutation>;
export type CompleteShareMutationOptions = Apollo.BaseMutationOptions<
  CompleteShareMutation,
  CompleteShareMutationVariables
>;
export const CompletePinningDocument = gql`
  mutation CompletePinning($contentId: String!, $studyGroupId: String!) {
    pinContent(contentId: $contentId, studyGroupId: $studyGroupId) {
      id
      contentId
    }
  }
`;
export type CompletePinningMutationFn = Apollo.MutationFunction<
  CompletePinningMutation,
  CompletePinningMutationVariables
>;

/**
 * __useCompletePinningMutation__
 *
 * To run a mutation, you first call `useCompletePinningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePinningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePinningMutation, { data, loading, error }] = useCompletePinningMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      studyGroupId: // value for 'studyGroupId'
 *   },
 * });
 */
export function useCompletePinningMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompletePinningMutation,
    CompletePinningMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompletePinningMutation,
    CompletePinningMutationVariables
  >(CompletePinningDocument, options);
}
export type CompletePinningMutationHookResult = ReturnType<
  typeof useCompletePinningMutation
>;
export type CompletePinningMutationResult =
  Apollo.MutationResult<CompletePinningMutation>;
export type CompletePinningMutationOptions = Apollo.BaseMutationOptions<
  CompletePinningMutation,
  CompletePinningMutationVariables
>;
export const UnChalkUpDocument = gql`
  mutation UnChalkUp($chalkUpId: String!) {
    deleteChalkUps(filters: { id: $chalkUpId }) {
      id
    }
  }
`;
export type UnChalkUpMutationFn = Apollo.MutationFunction<
  UnChalkUpMutation,
  UnChalkUpMutationVariables
>;

/**
 * __useUnChalkUpMutation__
 *
 * To run a mutation, you first call `useUnChalkUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnChalkUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unChalkUpMutation, { data, loading, error }] = useUnChalkUpMutation({
 *   variables: {
 *      chalkUpId: // value for 'chalkUpId'
 *   },
 * });
 */
export function useUnChalkUpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnChalkUpMutation,
    UnChalkUpMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnChalkUpMutation, UnChalkUpMutationVariables>(
    UnChalkUpDocument,
    options,
  );
}
export type UnChalkUpMutationHookResult = ReturnType<
  typeof useUnChalkUpMutation
>;
export type UnChalkUpMutationResult = Apollo.MutationResult<UnChalkUpMutation>;
export type UnChalkUpMutationOptions = Apollo.BaseMutationOptions<
  UnChalkUpMutation,
  UnChalkUpMutationVariables
>;
export const UnShareDocument = gql`
  mutation UnShare($shareId: String!) {
    deleteShares(filters: { id: $shareId }) {
      id
    }
  }
`;
export type UnShareMutationFn = Apollo.MutationFunction<
  UnShareMutation,
  UnShareMutationVariables
>;

/**
 * __useUnShareMutation__
 *
 * To run a mutation, you first call `useUnShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unShareMutation, { data, loading, error }] = useUnShareMutation({
 *   variables: {
 *      shareId: // value for 'shareId'
 *   },
 * });
 */
export function useUnShareMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnShareMutation,
    UnShareMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnShareMutation, UnShareMutationVariables>(
    UnShareDocument,
    options,
  );
}
export type UnShareMutationHookResult = ReturnType<typeof useUnShareMutation>;
export type UnShareMutationResult = Apollo.MutationResult<UnShareMutation>;
export type UnShareMutationOptions = Apollo.BaseMutationOptions<
  UnShareMutation,
  UnShareMutationVariables
>;
export const UnPinDocument = gql`
  mutation UnPin($pinId: String!) {
    deletePinnings(filters: { id: $pinId }) {
      id
    }
  }
`;
export type UnPinMutationFn = Apollo.MutationFunction<
  UnPinMutation,
  UnPinMutationVariables
>;

/**
 * __useUnPinMutation__
 *
 * To run a mutation, you first call `useUnPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unPinMutation, { data, loading, error }] = useUnPinMutation({
 *   variables: {
 *      pinId: // value for 'pinId'
 *   },
 * });
 */
export function useUnPinMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnPinMutation,
    UnPinMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnPinMutation, UnPinMutationVariables>(
    UnPinDocument,
    options,
  );
}
export type UnPinMutationHookResult = ReturnType<typeof useUnPinMutation>;
export type UnPinMutationResult = Apollo.MutationResult<UnPinMutation>;
export type UnPinMutationOptions = Apollo.BaseMutationOptions<
  UnPinMutation,
  UnPinMutationVariables
>;
export const ChooseTrackDocument = gql`
  mutation ChooseTrack($trackId: String!, $studyGroupId: String!) {
    chooseTrack(trackId: $trackId, studyGroupId: $studyGroupId) {
      id
      track {
        id
      }
      studyGroup {
        id
      }
    }
  }
`;
export type ChooseTrackMutationFn = Apollo.MutationFunction<
  ChooseTrackMutation,
  ChooseTrackMutationVariables
>;

/**
 * __useChooseTrackMutation__
 *
 * To run a mutation, you first call `useChooseTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChooseTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chooseTrackMutation, { data, loading, error }] = useChooseTrackMutation({
 *   variables: {
 *      trackId: // value for 'trackId'
 *      studyGroupId: // value for 'studyGroupId'
 *   },
 * });
 */
export function useChooseTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChooseTrackMutation,
    ChooseTrackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChooseTrackMutation, ChooseTrackMutationVariables>(
    ChooseTrackDocument,
    options,
  );
}
export type ChooseTrackMutationHookResult = ReturnType<
  typeof useChooseTrackMutation
>;
export type ChooseTrackMutationResult =
  Apollo.MutationResult<ChooseTrackMutation>;
export type ChooseTrackMutationOptions = Apollo.BaseMutationOptions<
  ChooseTrackMutation,
  ChooseTrackMutationVariables
>;
export const StudentsTrackAssignemntsDocument = gql`
  query StudentsTrackAssignemnts($studyGroupId: String!) {
    trackTeacherAssignments(filters: { studyGroup: { id: $studyGroupId } }) {
      id
      track {
        id
      }
      user {
        id
      }
    }
  }
`;

/**
 * __useStudentsTrackAssignemntsQuery__
 *
 * To run a query within a React component, call `useStudentsTrackAssignemntsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsTrackAssignemntsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsTrackAssignemntsQuery({
 *   variables: {
 *      studyGroupId: // value for 'studyGroupId'
 *   },
 * });
 */
export function useStudentsTrackAssignemntsQuery(
  baseOptions: Apollo.QueryHookOptions<
    StudentsTrackAssignemntsQuery,
    StudentsTrackAssignemntsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StudentsTrackAssignemntsQuery,
    StudentsTrackAssignemntsQueryVariables
  >(StudentsTrackAssignemntsDocument, options);
}
export function useStudentsTrackAssignemntsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StudentsTrackAssignemntsQuery,
    StudentsTrackAssignemntsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StudentsTrackAssignemntsQuery,
    StudentsTrackAssignemntsQueryVariables
  >(StudentsTrackAssignemntsDocument, options);
}
export type StudentsTrackAssignemntsQueryHookResult = ReturnType<
  typeof useStudentsTrackAssignemntsQuery
>;
export type StudentsTrackAssignemntsLazyQueryHookResult = ReturnType<
  typeof useStudentsTrackAssignemntsLazyQuery
>;
export type StudentsTrackAssignemntsQueryResult = Apollo.QueryResult<
  StudentsTrackAssignemntsQuery,
  StudentsTrackAssignemntsQueryVariables
>;
export const AssignTrackToStudentDocument = gql`
  mutation AssignTrackToStudent($data: AssignTrackToStudentInput!) {
    assignTrackToStudent(data: $data) {
      id
      track {
        id
      }
      user {
        id
      }
    }
  }
`;
export type AssignTrackToStudentMutationFn = Apollo.MutationFunction<
  AssignTrackToStudentMutation,
  AssignTrackToStudentMutationVariables
>;

/**
 * __useAssignTrackToStudentMutation__
 *
 * To run a mutation, you first call `useAssignTrackToStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTrackToStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTrackToStudentMutation, { data, loading, error }] = useAssignTrackToStudentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAssignTrackToStudentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignTrackToStudentMutation,
    AssignTrackToStudentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignTrackToStudentMutation,
    AssignTrackToStudentMutationVariables
  >(AssignTrackToStudentDocument, options);
}
export type AssignTrackToStudentMutationHookResult = ReturnType<
  typeof useAssignTrackToStudentMutation
>;
export type AssignTrackToStudentMutationResult =
  Apollo.MutationResult<AssignTrackToStudentMutation>;
export type AssignTrackToStudentMutationOptions = Apollo.BaseMutationOptions<
  AssignTrackToStudentMutation,
  AssignTrackToStudentMutationVariables
>;
export const DeleteTrackAssignmentDocument = gql`
  mutation DeleteTrackAssignment($trackAssignmentId: String!) {
    deleteTrackTeacherAssignments(filters: { id: $trackAssignmentId }) {
      id
    }
  }
`;
export type DeleteTrackAssignmentMutationFn = Apollo.MutationFunction<
  DeleteTrackAssignmentMutation,
  DeleteTrackAssignmentMutationVariables
>;

/**
 * __useDeleteTrackAssignmentMutation__
 *
 * To run a mutation, you first call `useDeleteTrackAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrackAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrackAssignmentMutation, { data, loading, error }] = useDeleteTrackAssignmentMutation({
 *   variables: {
 *      trackAssignmentId: // value for 'trackAssignmentId'
 *   },
 * });
 */
export function useDeleteTrackAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTrackAssignmentMutation,
    DeleteTrackAssignmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteTrackAssignmentMutation,
    DeleteTrackAssignmentMutationVariables
  >(DeleteTrackAssignmentDocument, options);
}
export type DeleteTrackAssignmentMutationHookResult = ReturnType<
  typeof useDeleteTrackAssignmentMutation
>;
export type DeleteTrackAssignmentMutationResult =
  Apollo.MutationResult<DeleteTrackAssignmentMutation>;
export type DeleteTrackAssignmentMutationOptions = Apollo.BaseMutationOptions<
  DeleteTrackAssignmentMutation,
  DeleteTrackAssignmentMutationVariables
>;
export const CanBeSharedDocument = gql`
  query CanBeShared($trackUnitId: ID!) {
    trackUnit(pk: $trackUnitId) {
      id
      canBeShared
    }
  }
`;

/**
 * __useCanBeSharedQuery__
 *
 * To run a query within a React component, call `useCanBeSharedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanBeSharedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanBeSharedQuery({
 *   variables: {
 *      trackUnitId: // value for 'trackUnitId'
 *   },
 * });
 */
export function useCanBeSharedQuery(
  baseOptions: Apollo.QueryHookOptions<
    CanBeSharedQuery,
    CanBeSharedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CanBeSharedQuery, CanBeSharedQueryVariables>(
    CanBeSharedDocument,
    options,
  );
}
export function useCanBeSharedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CanBeSharedQuery,
    CanBeSharedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CanBeSharedQuery, CanBeSharedQueryVariables>(
    CanBeSharedDocument,
    options,
  );
}
export type CanBeSharedQueryHookResult = ReturnType<typeof useCanBeSharedQuery>;
export type CanBeSharedLazyQueryHookResult = ReturnType<
  typeof useCanBeSharedLazyQuery
>;
export type CanBeSharedQueryResult = Apollo.QueryResult<
  CanBeSharedQuery,
  CanBeSharedQueryVariables
>;
export const UserChalkupsWithoutClassDocument = gql`
  query UserChalkupsWithoutClass($userId: String!) {
    chalkUps(filters: { studyGroup: null, user: { id: $userId } }) {
      id
      contentId
    }
  }
`;

/**
 * __useUserChalkupsWithoutClassQuery__
 *
 * To run a query within a React component, call `useUserChalkupsWithoutClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserChalkupsWithoutClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserChalkupsWithoutClassQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserChalkupsWithoutClassQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserChalkupsWithoutClassQuery,
    UserChalkupsWithoutClassQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserChalkupsWithoutClassQuery,
    UserChalkupsWithoutClassQueryVariables
  >(UserChalkupsWithoutClassDocument, options);
}
export function useUserChalkupsWithoutClassLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserChalkupsWithoutClassQuery,
    UserChalkupsWithoutClassQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserChalkupsWithoutClassQuery,
    UserChalkupsWithoutClassQueryVariables
  >(UserChalkupsWithoutClassDocument, options);
}
export type UserChalkupsWithoutClassQueryHookResult = ReturnType<
  typeof useUserChalkupsWithoutClassQuery
>;
export type UserChalkupsWithoutClassLazyQueryHookResult = ReturnType<
  typeof useUserChalkupsWithoutClassLazyQuery
>;
export type UserChalkupsWithoutClassQueryResult = Apollo.QueryResult<
  UserChalkupsWithoutClassQuery,
  UserChalkupsWithoutClassQueryVariables
>;
export const DashboardQueryDocument = gql`
  query DashboardQuery(
    $userId: String!
    $loadPinnings: Boolean!
    $limit: Int!
    $offset: Int! = 0
    $customFilters: StudyGroupFilter
  ) {
    studyGroups(
      pagination: { limit: $limit, offset: $offset }
      filters: $customFilters
      order: { updatedAt: DESC }
    ) {
      id
      name
      isSelfLearning
      isExplore
      isChallenge
      license {
        school {
          id
          name
        }
        period {
          id
          name
          lastDate
        }
        program {
          id
          name
          image {
            name
          }
          thumbnails
          description
        }
      }
    }
    pinnings(filters: { user: { id: $userId } }) @include(if: $loadPinnings) {
      id
      content {
        id
        name
        mediaType
      }
      studyGroup {
        id
        program {
          id
        }
      }
    }
  }
`;

/**
 * __useDashboardQueryQuery__
 *
 * To run a query within a React component, call `useDashboardQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      loadPinnings: // value for 'loadPinnings'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      customFilters: // value for 'customFilters'
 *   },
 * });
 */
export function useDashboardQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    DashboardQueryQuery,
    DashboardQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DashboardQueryQuery, DashboardQueryQueryVariables>(
    DashboardQueryDocument,
    options,
  );
}
export function useDashboardQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DashboardQueryQuery,
    DashboardQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DashboardQueryQuery, DashboardQueryQueryVariables>(
    DashboardQueryDocument,
    options,
  );
}
export type DashboardQueryQueryHookResult = ReturnType<
  typeof useDashboardQueryQuery
>;
export type DashboardQueryLazyQueryHookResult = ReturnType<
  typeof useDashboardQueryLazyQuery
>;
export type DashboardQueryQueryResult = Apollo.QueryResult<
  DashboardQueryQuery,
  DashboardQueryQueryVariables
>;
export const DashboardGlobalProgramsDocument = gql`
  query DashboardGlobalPrograms($enrolledOrTeacher: Boolean!) {
    globalStudyGroups(enrolledOrTeacher: $enrolledOrTeacher) {
      id
      name
      license {
        school {
          id
          name
        }
        program {
          id
          name
          image {
            name
          }
          thumbnails
          description
        }
      }
    }
  }
`;

/**
 * __useDashboardGlobalProgramsQuery__
 *
 * To run a query within a React component, call `useDashboardGlobalProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardGlobalProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardGlobalProgramsQuery({
 *   variables: {
 *      enrolledOrTeacher: // value for 'enrolledOrTeacher'
 *   },
 * });
 */
export function useDashboardGlobalProgramsQuery(
  baseOptions: Apollo.QueryHookOptions<
    DashboardGlobalProgramsQuery,
    DashboardGlobalProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DashboardGlobalProgramsQuery,
    DashboardGlobalProgramsQueryVariables
  >(DashboardGlobalProgramsDocument, options);
}
export function useDashboardGlobalProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DashboardGlobalProgramsQuery,
    DashboardGlobalProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DashboardGlobalProgramsQuery,
    DashboardGlobalProgramsQueryVariables
  >(DashboardGlobalProgramsDocument, options);
}
export type DashboardGlobalProgramsQueryHookResult = ReturnType<
  typeof useDashboardGlobalProgramsQuery
>;
export type DashboardGlobalProgramsLazyQueryHookResult = ReturnType<
  typeof useDashboardGlobalProgramsLazyQuery
>;
export type DashboardGlobalProgramsQueryResult = Apollo.QueryResult<
  DashboardGlobalProgramsQuery,
  DashboardGlobalProgramsQueryVariables
>;
export const DashboardExploreStudyGroupsDocument = gql`
  query DashboardExploreStudyGroups {
    exploreStudyGroups {
      id
      name
      isExplore
      isSelfLearning
      isChallenge
      license {
        school {
          id
          name
        }
        program {
          id
          name
          image {
            name
          }
          thumbnails
          description
          programUnits {
            id
            name
            description
            thumbnails
            modules {
              id
              name
              contents {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useDashboardExploreStudyGroupsQuery__
 *
 * To run a query within a React component, call `useDashboardExploreStudyGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardExploreStudyGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardExploreStudyGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardExploreStudyGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DashboardExploreStudyGroupsQuery,
    DashboardExploreStudyGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DashboardExploreStudyGroupsQuery,
    DashboardExploreStudyGroupsQueryVariables
  >(DashboardExploreStudyGroupsDocument, options);
}
export function useDashboardExploreStudyGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DashboardExploreStudyGroupsQuery,
    DashboardExploreStudyGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DashboardExploreStudyGroupsQuery,
    DashboardExploreStudyGroupsQueryVariables
  >(DashboardExploreStudyGroupsDocument, options);
}
export type DashboardExploreStudyGroupsQueryHookResult = ReturnType<
  typeof useDashboardExploreStudyGroupsQuery
>;
export type DashboardExploreStudyGroupsLazyQueryHookResult = ReturnType<
  typeof useDashboardExploreStudyGroupsLazyQuery
>;
export type DashboardExploreStudyGroupsQueryResult = Apollo.QueryResult<
  DashboardExploreStudyGroupsQuery,
  DashboardExploreStudyGroupsQueryVariables
>;
export const ChallengeSchoolsDocument = gql`
  query ChallengeSchools {
    challengeSchools {
      id
      name
    }
  }
`;

/**
 * __useChallengeSchoolsQuery__
 *
 * To run a query within a React component, call `useChallengeSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeSchoolsQuery({
 *   variables: {
 *   },
 * });
 */
export function useChallengeSchoolsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ChallengeSchoolsQuery,
    ChallengeSchoolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChallengeSchoolsQuery, ChallengeSchoolsQueryVariables>(
    ChallengeSchoolsDocument,
    options,
  );
}
export function useChallengeSchoolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChallengeSchoolsQuery,
    ChallengeSchoolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChallengeSchoolsQuery,
    ChallengeSchoolsQueryVariables
  >(ChallengeSchoolsDocument, options);
}
export type ChallengeSchoolsQueryHookResult = ReturnType<
  typeof useChallengeSchoolsQuery
>;
export type ChallengeSchoolsLazyQueryHookResult = ReturnType<
  typeof useChallengeSchoolsLazyQuery
>;
export type ChallengeSchoolsQueryResult = Apollo.QueryResult<
  ChallengeSchoolsQuery,
  ChallengeSchoolsQueryVariables
>;
export const AvailableChallengeStudyGroupDocument = gql`
  query AvailableChallengeStudyGroup {
    availableChallengeStudyGroup {
      pk
      name
      license {
        school {
          name
        }
      }
      inviteCode
    }
  }
`;

/**
 * __useAvailableChallengeStudyGroupQuery__
 *
 * To run a query within a React component, call `useAvailableChallengeStudyGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableChallengeStudyGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableChallengeStudyGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableChallengeStudyGroupQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AvailableChallengeStudyGroupQuery,
    AvailableChallengeStudyGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AvailableChallengeStudyGroupQuery,
    AvailableChallengeStudyGroupQueryVariables
  >(AvailableChallengeStudyGroupDocument, options);
}
export function useAvailableChallengeStudyGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AvailableChallengeStudyGroupQuery,
    AvailableChallengeStudyGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AvailableChallengeStudyGroupQuery,
    AvailableChallengeStudyGroupQueryVariables
  >(AvailableChallengeStudyGroupDocument, options);
}
export type AvailableChallengeStudyGroupQueryHookResult = ReturnType<
  typeof useAvailableChallengeStudyGroupQuery
>;
export type AvailableChallengeStudyGroupLazyQueryHookResult = ReturnType<
  typeof useAvailableChallengeStudyGroupLazyQuery
>;
export type AvailableChallengeStudyGroupQueryResult = Apollo.QueryResult<
  AvailableChallengeStudyGroupQuery,
  AvailableChallengeStudyGroupQueryVariables
>;
export const ChallengeProgramsDocument = gql`
  query ChallengePrograms {
    programs(filters: { isChallenge: true }) {
      name
      id
      isChallenge
      description
      namespaces
    }
  }
`;

/**
 * __useChallengeProgramsQuery__
 *
 * To run a query within a React component, call `useChallengeProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useChallengeProgramsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ChallengeProgramsQuery,
    ChallengeProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ChallengeProgramsQuery,
    ChallengeProgramsQueryVariables
  >(ChallengeProgramsDocument, options);
}
export function useChallengeProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChallengeProgramsQuery,
    ChallengeProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChallengeProgramsQuery,
    ChallengeProgramsQueryVariables
  >(ChallengeProgramsDocument, options);
}
export type ChallengeProgramsQueryHookResult = ReturnType<
  typeof useChallengeProgramsQuery
>;
export type ChallengeProgramsLazyQueryHookResult = ReturnType<
  typeof useChallengeProgramsLazyQuery
>;
export type ChallengeProgramsQueryResult = Apollo.QueryResult<
  ChallengeProgramsQuery,
  ChallengeProgramsQueryVariables
>;
export const PublicProgramsDocument = gql`
  query PublicPrograms {
    programs(filters: { isPublic: true }) {
      name
      id
      isChallenge
      isPublic
      description
      namespaces
      thumbnails
    }
  }
`;

/**
 * __usePublicProgramsQuery__
 *
 * To run a query within a React component, call `usePublicProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicProgramsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PublicProgramsQuery,
    PublicProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PublicProgramsQuery, PublicProgramsQueryVariables>(
    PublicProgramsDocument,
    options,
  );
}
export function usePublicProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PublicProgramsQuery,
    PublicProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PublicProgramsQuery, PublicProgramsQueryVariables>(
    PublicProgramsDocument,
    options,
  );
}
export type PublicProgramsQueryHookResult = ReturnType<
  typeof usePublicProgramsQuery
>;
export type PublicProgramsLazyQueryHookResult = ReturnType<
  typeof usePublicProgramsLazyQuery
>;
export type PublicProgramsQueryResult = Apollo.QueryResult<
  PublicProgramsQuery,
  PublicProgramsQueryVariables
>;
export const PublicUnitsDocument = gql`
  query PublicUnits {
    units(filters: { isPublic: true }) {
      name
      id
      description
      thumbnails
      color
      isPublished
    }
  }
`;

/**
 * __usePublicUnitsQuery__
 *
 * To run a query within a React component, call `usePublicUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicUnitsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PublicUnitsQuery,
    PublicUnitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PublicUnitsQuery, PublicUnitsQueryVariables>(
    PublicUnitsDocument,
    options,
  );
}
export function usePublicUnitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PublicUnitsQuery,
    PublicUnitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PublicUnitsQuery, PublicUnitsQueryVariables>(
    PublicUnitsDocument,
    options,
  );
}
export type PublicUnitsQueryHookResult = ReturnType<typeof usePublicUnitsQuery>;
export type PublicUnitsLazyQueryHookResult = ReturnType<
  typeof usePublicUnitsLazyQuery
>;
export type PublicUnitsQueryResult = Apollo.QueryResult<
  PublicUnitsQuery,
  PublicUnitsQueryVariables
>;
export const TeacherTrainingProgramsDocument = gql`
  query TeacherTrainingPrograms {
    programs(filters: { isTeacherTraining: true }) {
      name
      id
      isChallenge
      isTeacherTraining
      description
      namespaces
    }
  }
`;

/**
 * __useTeacherTrainingProgramsQuery__
 *
 * To run a query within a React component, call `useTeacherTrainingProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherTrainingProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherTrainingProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeacherTrainingProgramsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TeacherTrainingProgramsQuery,
    TeacherTrainingProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TeacherTrainingProgramsQuery,
    TeacherTrainingProgramsQueryVariables
  >(TeacherTrainingProgramsDocument, options);
}
export function useTeacherTrainingProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TeacherTrainingProgramsQuery,
    TeacherTrainingProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TeacherTrainingProgramsQuery,
    TeacherTrainingProgramsQueryVariables
  >(TeacherTrainingProgramsDocument, options);
}
export type TeacherTrainingProgramsQueryHookResult = ReturnType<
  typeof useTeacherTrainingProgramsQuery
>;
export type TeacherTrainingProgramsLazyQueryHookResult = ReturnType<
  typeof useTeacherTrainingProgramsLazyQuery
>;
export type TeacherTrainingProgramsQueryResult = Apollo.QueryResult<
  TeacherTrainingProgramsQuery,
  TeacherTrainingProgramsQueryVariables
>;
export const LeaderboardDataQueryDocument = gql`
  query LeaderboardDataQuery {
    challengePoints
  }
`;

/**
 * __useLeaderboardDataQueryQuery__
 *
 * To run a query within a React component, call `useLeaderboardDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardDataQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeaderboardDataQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LeaderboardDataQueryQuery,
    LeaderboardDataQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LeaderboardDataQueryQuery,
    LeaderboardDataQueryQueryVariables
  >(LeaderboardDataQueryDocument, options);
}
export function useLeaderboardDataQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LeaderboardDataQueryQuery,
    LeaderboardDataQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LeaderboardDataQueryQuery,
    LeaderboardDataQueryQueryVariables
  >(LeaderboardDataQueryDocument, options);
}
export type LeaderboardDataQueryQueryHookResult = ReturnType<
  typeof useLeaderboardDataQueryQuery
>;
export type LeaderboardDataQueryLazyQueryHookResult = ReturnType<
  typeof useLeaderboardDataQueryLazyQuery
>;
export type LeaderboardDataQueryQueryResult = Apollo.QueryResult<
  LeaderboardDataQueryQuery,
  LeaderboardDataQueryQueryVariables
>;
export const DashboardChallengeStudyGroupsDocument = gql`
  query DashboardChallengeStudyGroups {
    challengeStudyGroups {
      id
      name
      isExplore
      isSelfLearning
      isChallenge
      license {
        school {
          id
          name
        }
        program {
          id
          name
          image {
            name
          }
          thumbnails
          description
          programUnits {
            id
            name
            description
            thumbnails
            modules {
              id
              name
              contents {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useDashboardChallengeStudyGroupsQuery__
 *
 * To run a query within a React component, call `useDashboardChallengeStudyGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardChallengeStudyGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardChallengeStudyGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardChallengeStudyGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DashboardChallengeStudyGroupsQuery,
    DashboardChallengeStudyGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DashboardChallengeStudyGroupsQuery,
    DashboardChallengeStudyGroupsQueryVariables
  >(DashboardChallengeStudyGroupsDocument, options);
}
export function useDashboardChallengeStudyGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DashboardChallengeStudyGroupsQuery,
    DashboardChallengeStudyGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DashboardChallengeStudyGroupsQuery,
    DashboardChallengeStudyGroupsQueryVariables
  >(DashboardChallengeStudyGroupsDocument, options);
}
export type DashboardChallengeStudyGroupsQueryHookResult = ReturnType<
  typeof useDashboardChallengeStudyGroupsQuery
>;
export type DashboardChallengeStudyGroupsLazyQueryHookResult = ReturnType<
  typeof useDashboardChallengeStudyGroupsLazyQuery
>;
export type DashboardChallengeStudyGroupsQueryResult = Apollo.QueryResult<
  DashboardChallengeStudyGroupsQuery,
  DashboardChallengeStudyGroupsQueryVariables
>;
export const ArticlesDocument = gql`
  query Articles {
    articles(filters: { isPublished: true }) {
      id
      pk
      name
      type
      namespace
    }
  }
`;

/**
 * __useArticlesQuery__
 *
 * To run a query within a React component, call `useArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useArticlesQuery(
  baseOptions?: Apollo.QueryHookOptions<ArticlesQuery, ArticlesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArticlesQuery, ArticlesQueryVariables>(
    ArticlesDocument,
    options,
  );
}
export function useArticlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticlesQuery,
    ArticlesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArticlesQuery, ArticlesQueryVariables>(
    ArticlesDocument,
    options,
  );
}
export type ArticlesQueryHookResult = ReturnType<typeof useArticlesQuery>;
export type ArticlesLazyQueryHookResult = ReturnType<
  typeof useArticlesLazyQuery
>;
export type ArticlesQueryResult = Apollo.QueryResult<
  ArticlesQuery,
  ArticlesQueryVariables
>;
export const EventsDocument = gql`
  query Events {
    events {
      id
      title
      image {
        name
        url
      }
      description
      endDatetime
      link
      namespace
      startDatetime
    }
  }
`;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<EventsQuery, EventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EventsQuery, EventsQueryVariables>(
    EventsDocument,
    options,
  );
}
export function useEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EventsQuery, EventsQueryVariables>(
    EventsDocument,
    options,
  );
}
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>;
export type EventsQueryResult = Apollo.QueryResult<
  EventsQuery,
  EventsQueryVariables
>;
export const GetMeWithInfobipDocument = gql`
  query getMeWithInfobip {
    me {
      id
      infobipDirect {
        id
        infobipState
        infobipUsername
        infobipPassword
      }
    }
  }
`;

/**
 * __useGetMeWithInfobipQuery__
 *
 * To run a query within a React component, call `useGetMeWithInfobipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeWithInfobipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeWithInfobipQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeWithInfobipQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMeWithInfobipQuery,
    GetMeWithInfobipQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMeWithInfobipQuery, GetMeWithInfobipQueryVariables>(
    GetMeWithInfobipDocument,
    options,
  );
}
export function useGetMeWithInfobipLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMeWithInfobipQuery,
    GetMeWithInfobipQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMeWithInfobipQuery,
    GetMeWithInfobipQueryVariables
  >(GetMeWithInfobipDocument, options);
}
export type GetMeWithInfobipQueryHookResult = ReturnType<
  typeof useGetMeWithInfobipQuery
>;
export type GetMeWithInfobipLazyQueryHookResult = ReturnType<
  typeof useGetMeWithInfobipLazyQuery
>;
export type GetMeWithInfobipQueryResult = Apollo.QueryResult<
  GetMeWithInfobipQuery,
  GetMeWithInfobipQueryVariables
>;
export const GetJsonCmsContentDocument = gql`
  query GetJsonCmsContent($contentPk: String, $page: Int) {
    getJsonCmsContent(pk: $contentPk, page: $page) {
      count
      currentPage
      isPresentation
      totalPages
      results {
        id
        plugin
        data
        children
      }
    }
  }
`;

/**
 * __useGetJsonCmsContentQuery__
 *
 * To run a query within a React component, call `useGetJsonCmsContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJsonCmsContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJsonCmsContentQuery({
 *   variables: {
 *      contentPk: // value for 'contentPk'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetJsonCmsContentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetJsonCmsContentQuery,
    GetJsonCmsContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJsonCmsContentQuery,
    GetJsonCmsContentQueryVariables
  >(GetJsonCmsContentDocument, options);
}
export function useGetJsonCmsContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJsonCmsContentQuery,
    GetJsonCmsContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJsonCmsContentQuery,
    GetJsonCmsContentQueryVariables
  >(GetJsonCmsContentDocument, options);
}
export type GetJsonCmsContentQueryHookResult = ReturnType<
  typeof useGetJsonCmsContentQuery
>;
export type GetJsonCmsContentLazyQueryHookResult = ReturnType<
  typeof useGetJsonCmsContentLazyQuery
>;
export type GetJsonCmsContentQueryResult = Apollo.QueryResult<
  GetJsonCmsContentQuery,
  GetJsonCmsContentQueryVariables
>;
export const GetProgramInfoDocument = gql`
  query GetProgramInfo($programInfoPk: ID!) {
    programInfo(pk: $programInfoPk) {
      technologiesUsedInTheProgram
      name
      id
      description
      shortDescription
      tags
      slug
      technicalSkills
      professionalCompetences
      minGrade
      maxGrade
      minHours
      maxHours
      programUnitsDescription
      programRank
      techFields
      knowledgePrerequisites
      teacherExperience
      standardsAlignment
      demo
      scopeAndSequence {
        url
        name
      }
      tracks(filters: { enabled: true }) {
        estimatedDuration
        tags
        name
        trackUnits(filters: { enabled: true }) {
          id
          trackModules(filters: { enabled: true }) {
            id
            module {
              id
              name
            }
          }
          unit {
            id
            name
            programInfoDescription
          }
        }
      }
      organization {
        name
        url
        image {
          height
          name
          size
          url
          width
        }
        id
      }
      partners {
        id
        image {
          height
          name
          size
          url
          width
        }
        name
        url
      }
      videoUrl
      image {
        height
        name
        size
        url
        width
      }
    }
  }
`;

/**
 * __useGetProgramInfoQuery__
 *
 * To run a query within a React component, call `useGetProgramInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramInfoQuery({
 *   variables: {
 *      programInfoPk: // value for 'programInfoPk'
 *   },
 * });
 */
export function useGetProgramInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProgramInfoQuery,
    GetProgramInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProgramInfoQuery, GetProgramInfoQueryVariables>(
    GetProgramInfoDocument,
    options,
  );
}
export function useGetProgramInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProgramInfoQuery,
    GetProgramInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProgramInfoQuery, GetProgramInfoQueryVariables>(
    GetProgramInfoDocument,
    options,
  );
}
export type GetProgramInfoQueryHookResult = ReturnType<
  typeof useGetProgramInfoQuery
>;
export type GetProgramInfoLazyQueryHookResult = ReturnType<
  typeof useGetProgramInfoLazyQuery
>;
export type GetProgramInfoQueryResult = Apollo.QueryResult<
  GetProgramInfoQuery,
  GetProgramInfoQueryVariables
>;
export const GetAllProgramInfoDocument = gql`
  query GetAllProgramInfo {
    programInfos(order: { sortOrder: ASC }) {
      technologiesUsedInTheProgram
      name
      id
      slug
      technicalSkills
      professionalCompetences
      minGrade
      maxGrade
      shortDescription
      tags
      programRank
      techFields
      image {
        height
        name
        size
        url
        width
      }
      organization {
        name
        url
        image {
          height
          name
          size
          url
          width
        }
        id
      }
    }
  }
`;

/**
 * __useGetAllProgramInfoQuery__
 *
 * To run a query within a React component, call `useGetAllProgramInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProgramInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProgramInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProgramInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllProgramInfoQuery,
    GetAllProgramInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllProgramInfoQuery,
    GetAllProgramInfoQueryVariables
  >(GetAllProgramInfoDocument, options);
}
export function useGetAllProgramInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllProgramInfoQuery,
    GetAllProgramInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllProgramInfoQuery,
    GetAllProgramInfoQueryVariables
  >(GetAllProgramInfoDocument, options);
}
export type GetAllProgramInfoQueryHookResult = ReturnType<
  typeof useGetAllProgramInfoQuery
>;
export type GetAllProgramInfoLazyQueryHookResult = ReturnType<
  typeof useGetAllProgramInfoLazyQuery
>;
export type GetAllProgramInfoQueryResult = Apollo.QueryResult<
  GetAllProgramInfoQuery,
  GetAllProgramInfoQueryVariables
>;
export const MarketPlaceEmailEnterDocument = gql`
  mutation MarketPlaceEmailEnter($data: LeadUserInput!) {
    appendDataToLeadUser(data: $data) {
      data
      email
    }
  }
`;
export type MarketPlaceEmailEnterMutationFn = Apollo.MutationFunction<
  MarketPlaceEmailEnterMutation,
  MarketPlaceEmailEnterMutationVariables
>;

/**
 * __useMarketPlaceEmailEnterMutation__
 *
 * To run a mutation, you first call `useMarketPlaceEmailEnterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketPlaceEmailEnterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketPlaceEmailEnterMutation, { data, loading, error }] = useMarketPlaceEmailEnterMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMarketPlaceEmailEnterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarketPlaceEmailEnterMutation,
    MarketPlaceEmailEnterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarketPlaceEmailEnterMutation,
    MarketPlaceEmailEnterMutationVariables
  >(MarketPlaceEmailEnterDocument, options);
}
export type MarketPlaceEmailEnterMutationHookResult = ReturnType<
  typeof useMarketPlaceEmailEnterMutation
>;
export type MarketPlaceEmailEnterMutationResult =
  Apollo.MutationResult<MarketPlaceEmailEnterMutation>;
export type MarketPlaceEmailEnterMutationOptions = Apollo.BaseMutationOptions<
  MarketPlaceEmailEnterMutation,
  MarketPlaceEmailEnterMutationVariables
>;
export const ConversationQueryDocument = gql`
  query ConversationQuery(
    $userId: String
    $includeDeleted: Boolean
    $conversationId: String
    $studyGroupId: String
    $gptBlockId: String
  ) {
    conversations(
      userId: $userId
      includeDeleted: $includeDeleted
      conversationId: $conversationId
      studyGroupId: $studyGroupId
      gptBlockId: $gptBlockId
    ) {
      name
      id
      gptBlockUniqueId
      limit
      notDisplayedMessageLen
      lastMessage {
        id
        text
        isGenerated
        createdAt
      }
      hasInappropriateMsg
      createdAt
      user {
        id
      }
      assistant {
        id
        image {
          height
          name
          path
          size
          url
          width
        }
        introMessages
        name
        namespaces
      }
    }
  }
`;

/**
 * __useConversationQueryQuery__
 *
 * To run a query within a React component, call `useConversationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      includeDeleted: // value for 'includeDeleted'
 *      conversationId: // value for 'conversationId'
 *      studyGroupId: // value for 'studyGroupId'
 *      gptBlockId: // value for 'gptBlockId'
 *   },
 * });
 */
export function useConversationQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConversationQueryQuery,
    ConversationQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConversationQueryQuery,
    ConversationQueryQueryVariables
  >(ConversationQueryDocument, options);
}
export function useConversationQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConversationQueryQuery,
    ConversationQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConversationQueryQuery,
    ConversationQueryQueryVariables
  >(ConversationQueryDocument, options);
}
export type ConversationQueryQueryHookResult = ReturnType<
  typeof useConversationQueryQuery
>;
export type ConversationQueryLazyQueryHookResult = ReturnType<
  typeof useConversationQueryLazyQuery
>;
export type ConversationQueryQueryResult = Apollo.QueryResult<
  ConversationQueryQuery,
  ConversationQueryQueryVariables
>;
export const GetConversationMessagesDocument = gql`
  query GetConversationMessages($conversationId: String!) {
    messages(conversationId: $conversationId) {
      id
      text
      isGenerated
      createdAt
      flags {
        type
        createdById
        createdAt
      }
    }
  }
`;

/**
 * __useGetConversationMessagesQuery__
 *
 * To run a query within a React component, call `useGetConversationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationMessagesQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useGetConversationMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetConversationMessagesQuery,
    GetConversationMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConversationMessagesQuery,
    GetConversationMessagesQueryVariables
  >(GetConversationMessagesDocument, options);
}
export function useGetConversationMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConversationMessagesQuery,
    GetConversationMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConversationMessagesQuery,
    GetConversationMessagesQueryVariables
  >(GetConversationMessagesDocument, options);
}
export type GetConversationMessagesQueryHookResult = ReturnType<
  typeof useGetConversationMessagesQuery
>;
export type GetConversationMessagesLazyQueryHookResult = ReturnType<
  typeof useGetConversationMessagesLazyQuery
>;
export type GetConversationMessagesQueryResult = Apollo.QueryResult<
  GetConversationMessagesQuery,
  GetConversationMessagesQueryVariables
>;
export const GetHistoryForSearchDocument = gql`
  query GetHistoryForSearch(
    $userId: String
    $includeDeleted: Boolean
    $conversationId: String
    $studyGroupId: String
    $gptBlockId: String
  ) {
    conversations(
      userId: $userId
      includeDeleted: $includeDeleted
      conversationId: $conversationId
      studyGroupId: $studyGroupId
      gptBlockId: $gptBlockId
    ) {
      id
      history {
        id
        text
        isGenerated
        createdAt
      }
      assistant {
        id
        image {
          height
          name
          path
          size
          url
          width
        }
        introMessages
        name
        namespaces
      }
    }
  }
`;

/**
 * __useGetHistoryForSearchQuery__
 *
 * To run a query within a React component, call `useGetHistoryForSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoryForSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoryForSearchQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      includeDeleted: // value for 'includeDeleted'
 *      conversationId: // value for 'conversationId'
 *      studyGroupId: // value for 'studyGroupId'
 *      gptBlockId: // value for 'gptBlockId'
 *   },
 * });
 */
export function useGetHistoryForSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetHistoryForSearchQuery,
    GetHistoryForSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetHistoryForSearchQuery,
    GetHistoryForSearchQueryVariables
  >(GetHistoryForSearchDocument, options);
}
export function useGetHistoryForSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHistoryForSearchQuery,
    GetHistoryForSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHistoryForSearchQuery,
    GetHistoryForSearchQueryVariables
  >(GetHistoryForSearchDocument, options);
}
export type GetHistoryForSearchQueryHookResult = ReturnType<
  typeof useGetHistoryForSearchQuery
>;
export type GetHistoryForSearchLazyQueryHookResult = ReturnType<
  typeof useGetHistoryForSearchLazyQuery
>;
export type GetHistoryForSearchQueryResult = Apollo.QueryResult<
  GetHistoryForSearchQuery,
  GetHistoryForSearchQueryVariables
>;
export const SendConversationMessageDocument = gql`
  mutation SendConversationMessage($data: ConversationInput!) {
    getConversationResponse(data: $data) {
      id
    }
  }
`;
export type SendConversationMessageMutationFn = Apollo.MutationFunction<
  SendConversationMessageMutation,
  SendConversationMessageMutationVariables
>;

/**
 * __useSendConversationMessageMutation__
 *
 * To run a mutation, you first call `useSendConversationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendConversationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendConversationMessageMutation, { data, loading, error }] = useSendConversationMessageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendConversationMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendConversationMessageMutation,
    SendConversationMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendConversationMessageMutation,
    SendConversationMessageMutationVariables
  >(SendConversationMessageDocument, options);
}
export type SendConversationMessageMutationHookResult = ReturnType<
  typeof useSendConversationMessageMutation
>;
export type SendConversationMessageMutationResult =
  Apollo.MutationResult<SendConversationMessageMutation>;
export type SendConversationMessageMutationOptions = Apollo.BaseMutationOptions<
  SendConversationMessageMutation,
  SendConversationMessageMutationVariables
>;
export const CreateConversationFromBlockDocument = gql`
  mutation CreateConversationFromBlock($data: ConversationBlockInput!) {
    createConversationFromBlock(data: $data) {
      id
    }
  }
`;
export type CreateConversationFromBlockMutationFn = Apollo.MutationFunction<
  CreateConversationFromBlockMutation,
  CreateConversationFromBlockMutationVariables
>;

/**
 * __useCreateConversationFromBlockMutation__
 *
 * To run a mutation, you first call `useCreateConversationFromBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationFromBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationFromBlockMutation, { data, loading, error }] = useCreateConversationFromBlockMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateConversationFromBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateConversationFromBlockMutation,
    CreateConversationFromBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateConversationFromBlockMutation,
    CreateConversationFromBlockMutationVariables
  >(CreateConversationFromBlockDocument, options);
}
export type CreateConversationFromBlockMutationHookResult = ReturnType<
  typeof useCreateConversationFromBlockMutation
>;
export type CreateConversationFromBlockMutationResult =
  Apollo.MutationResult<CreateConversationFromBlockMutation>;
export type CreateConversationFromBlockMutationOptions =
  Apollo.BaseMutationOptions<
    CreateConversationFromBlockMutation,
    CreateConversationFromBlockMutationVariables
  >;
export const ResetConversationFromBlockIdDocument = gql`
  mutation ResetConversationFromBlockId(
    $conversationId: String!
    $blockId: String!
  ) {
    resetConversation(
      data: { conversationId: $conversationId, blockId: $blockId }
    ) {
      id
    }
  }
`;
export type ResetConversationFromBlockIdMutationFn = Apollo.MutationFunction<
  ResetConversationFromBlockIdMutation,
  ResetConversationFromBlockIdMutationVariables
>;

/**
 * __useResetConversationFromBlockIdMutation__
 *
 * To run a mutation, you first call `useResetConversationFromBlockIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetConversationFromBlockIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetConversationFromBlockIdMutation, { data, loading, error }] = useResetConversationFromBlockIdMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useResetConversationFromBlockIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetConversationFromBlockIdMutation,
    ResetConversationFromBlockIdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetConversationFromBlockIdMutation,
    ResetConversationFromBlockIdMutationVariables
  >(ResetConversationFromBlockIdDocument, options);
}
export type ResetConversationFromBlockIdMutationHookResult = ReturnType<
  typeof useResetConversationFromBlockIdMutation
>;
export type ResetConversationFromBlockIdMutationResult =
  Apollo.MutationResult<ResetConversationFromBlockIdMutation>;
export type ResetConversationFromBlockIdMutationOptions =
  Apollo.BaseMutationOptions<
    ResetConversationFromBlockIdMutation,
    ResetConversationFromBlockIdMutationVariables
  >;
export const MarkMessageWithFlagDocument = gql`
  mutation MarkMessageWithFlag($type: String!, $messageId: String!) {
    markMessageWithFlag(data: { type: $type, messageId: $messageId }) {
      id
    }
  }
`;
export type MarkMessageWithFlagMutationFn = Apollo.MutationFunction<
  MarkMessageWithFlagMutation,
  MarkMessageWithFlagMutationVariables
>;

/**
 * __useMarkMessageWithFlagMutation__
 *
 * To run a mutation, you first call `useMarkMessageWithFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMessageWithFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMessageWithFlagMutation, { data, loading, error }] = useMarkMessageWithFlagMutation({
 *   variables: {
 *      type: // value for 'type'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useMarkMessageWithFlagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkMessageWithFlagMutation,
    MarkMessageWithFlagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkMessageWithFlagMutation,
    MarkMessageWithFlagMutationVariables
  >(MarkMessageWithFlagDocument, options);
}
export type MarkMessageWithFlagMutationHookResult = ReturnType<
  typeof useMarkMessageWithFlagMutation
>;
export type MarkMessageWithFlagMutationResult =
  Apollo.MutationResult<MarkMessageWithFlagMutation>;
export type MarkMessageWithFlagMutationOptions = Apollo.BaseMutationOptions<
  MarkMessageWithFlagMutation,
  MarkMessageWithFlagMutationVariables
>;
export const AssistantsQueryDocument = gql`
  query AssistantsQuery {
    assistants {
      id
      image {
        height
        name
        path
        size
        url
        width
      }
      infobipId
      introMessages
      name
      namespaces
    }
  }
`;

/**
 * __useAssistantsQueryQuery__
 *
 * To run a query within a React component, call `useAssistantsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssistantsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssistantsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssistantsQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AssistantsQueryQuery,
    AssistantsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AssistantsQueryQuery, AssistantsQueryQueryVariables>(
    AssistantsQueryDocument,
    options,
  );
}
export function useAssistantsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssistantsQueryQuery,
    AssistantsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssistantsQueryQuery,
    AssistantsQueryQueryVariables
  >(AssistantsQueryDocument, options);
}
export type AssistantsQueryQueryHookResult = ReturnType<
  typeof useAssistantsQueryQuery
>;
export type AssistantsQueryLazyQueryHookResult = ReturnType<
  typeof useAssistantsQueryLazyQuery
>;
export type AssistantsQueryQueryResult = Apollo.QueryResult<
  AssistantsQueryQuery,
  AssistantsQueryQueryVariables
>;
